const svgContent =`<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{opacity:0.25;}.cls-2{fill:none;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:#fff;fill-opacity:0;}.cls-2{fill:#333;fill-rule:evenodd;}</style><style>.cls-1{fill:none;}.cls-2{fill:#333;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style><style>.cls-1{fill:none;}</style></defs><symbol id="Account" viewBox="0 0 18 18">
<g id="account">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,5h-15C0.675,5,0,5.675,0,6.5v10C0,17.325,0.675,18,1.5,18h15c0.825,0,1.5-0.675,1.5-1.5v-10
		C18,5.675,17.325,5,16.5,5z M16.8,16.5c0,0.163-0.137,0.3-0.3,0.3h-15c-0.163,0-0.3-0.137-0.3-0.3v-10c0-0.163,0.137-0.3,0.3-0.3
		h15c0.163,0,0.3,0.137,0.3,0.3V16.5z M3,12h2v-2H3V12z M14.8,2.6H3.2C2.537,2.6,2,3.137,2,3.8h14C16,3.137,15.463,2.6,14.8,2.6z
		 M12.8,0H5.2C4.537,0,4,0.537,4,1.2h10C14,0.537,13.463,0,12.8,0z"/>
</g>
</symbol><symbol id="AccountActive" viewBox="0 0 18 18">
<g id="account_x5F_active">
	<g style="opacity:0.3;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M16.5,6h-15C0.675,6,0,6.675,0,7.5v9C0,17.325,0.675,18,1.5,18h15c0.825,0,1.5-0.675,1.5-1.5v-9C18,6.675,17.325,6,16.5,6z
		 M5,12H3v-2h2V12z M16,4.2C16,3.537,15.463,3,14.8,3H3.2C2.537,3,2,3.537,2,4.2v0.3h14V4.2z M14,1.2C14,0.537,13.463,0,12.8,0H5.2
		C4.537,0,4,0.537,4,1.2v0.3h10V1.2z"/>
</g>
</symbol><symbol id="Add" viewBox="0 0 18 18">
<g id="add">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<polygon points="18,8.4 9.6,8.4 9.6,0 8.4,0 8.4,8.4 0,8.4 0,9.6 8.4,9.6 8.4,18 9.6,18 9.6,9.6 18,9.6 	"/>
</g>
</symbol><symbol id="AddNewCompany" viewBox="0 0 18 18"><g id="addNewCompany"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M5,8a5,5,0,1,0,5,5A5,5,0,0,0,5,8Zm0,8.8A3.8,3.8,0,1,1,8.8,13,3.8,3.8,0,0,1,5,16.8Zm13-2V16H10.42a6.09,6.09,0,0,0,.78-3,6.31,6.31,0,0,0-.33-2H12.3v3.8h2.5V1.2H5.2V6.81H5a6.63,6.63,0,0,0-1,.08V0H16V14.8ZM9,4H7V2.79H9ZM7,5.3H9V6.5H7ZM13,4H11V2.79h2ZM11,5.3h2V6.5H11Zm0,2.51h2V9H11ZM5.5,12.33H7.33v1.2H5.5v1.84H4.3V13.53H2.47v-1.2H4.3V10.5H5.5Z"/></g></symbol><symbol id="AddCircle" viewBox="0 0 18 18">
<g id="add_x5F_circle">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.03,0,0,4.03,0,9s4.03,9,9,9s9-4.03,9-9S13.97,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M9.6,4H8.4v4.4H4V9.6h4.4V14h1.2V9.6H14V8.4H9.6V4z"/>
</g>
</symbol><symbol id="AddCircleActive" viewBox="0 0 18 18">
<g id="add_x5F_circle_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M14,9.9H9.9V14H8.1V9.9H4V8.1h4.1V4h1.8v4.1H14V9.9z"/>
	</g>
</g>
</symbol><symbol id="Alert" viewBox="0 0 18 18">
<g id="alert">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.293,13.293L15,11V6.252c0-3.285-2.532-6.15-5.815-6.249C9.123,0.001,9.061,0,9,0C5.686,0,3,2.686,3,6v5l-2.293,2.293
		C0.077,13.923,0.523,15,1.414,15h5.148C6.527,15.162,6.5,15.327,6.5,15.5C6.5,16.881,7.619,18,9,18c1.381,0,2.5-1.119,2.5-2.5
		c0-0.173-0.027-0.338-0.062-0.5h5.148C17.477,15,17.923,13.923,17.293,13.293z M10.3,15.5c0,0.717-0.583,1.3-1.3,1.3
		c-0.717,0-1.3-0.583-1.3-1.3c0-0.181,0.049-0.346,0.119-0.5h2.363C10.251,15.154,10.3,15.319,10.3,15.5z M1.897,13.8l1.951-1.952
		L4.2,11.497V11V6c0-2.647,2.153-4.8,4.8-4.8l0.148,0.002C11.713,1.279,13.8,3.544,13.8,6.252V11v0.497l0.352,0.351l1.952,1.952
		H1.897z"/>
</g>
</symbol><symbol id="AlertActive" viewBox="0 0 18 18">
<g id="alert_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,18c1.025,0,1.903-0.618,2.289-1.5H6.711C7.097,17.382,7.975,18,9,18z M17.293,13.293L15,11V6.251
		c0-3.285-2.532-6.15-5.815-6.249C5.787-0.099,3,2.625,3,6v5l-2.293,2.293C0.077,13.923,0.523,15,1.414,15h15.172
		C17.477,15,17.923,13.923,17.293,13.293z"/>
</g>
</symbol><symbol id="Assets" viewBox="0 0 18 18">
<g id="assets">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M9.773,12.539C9.609,12.89,8.208,13.8,5.5,13.8c-2.744,0-4.15-0.936-4.282-1.264c-0.4-0.173-0.762-0.37-1.077-0.591
			C0.052,12.124,0,12.309,0,12.5C0,13.881,2.462,15,5.5,15s5.5-1.119,5.5-2.5c0-0.191-0.052-0.376-0.141-0.555
			C10.542,12.168,10.177,12.366,9.773,12.539z"/>
		<path d="M9.773,15.539C9.609,15.89,8.208,16.8,5.5,16.8c-2.744,0-4.15-0.936-4.282-1.264c-0.4-0.173-0.762-0.37-1.077-0.591
			C0.052,15.124,0,15.309,0,15.5C0,16.881,2.462,18,5.5,18s5.5-1.119,5.5-2.5c0-0.191-0.052-0.376-0.141-0.555
			C10.542,15.168,10.177,15.366,9.773,15.539z"/>
		<path d="M11.5,0L5.812,5.688C6.359,5.7,6.884,5.742,7.382,5.814L11.5,1.697l5.3,5.299v5.785H14V7h-3.221
			c0.514,0.346,0.91,0.751,1.173,1.2H12.8v5.781H18V6.499L11.5,0z"/>
		<path d="M5.5,7C2.462,7,0,8.119,0,9.5C0,10.881,2.462,12,5.5,12S11,10.881,11,9.5C11,8.119,8.538,7,5.5,7z M5.5,10.8
			c-2.817,0-4.235-0.991-4.301-1.294C1.265,9.191,2.683,8.2,5.5,8.2s4.235,0.991,4.301,1.294C9.735,9.809,8.317,10.8,5.5,10.8z"/>
	</g>
</g>
</symbol><symbol id="AssetsActive" viewBox="0 0 18 18">
<g id="assets_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M11.5,0L5.98,5.519C8.859,5.617,11.115,6.572,12.039,8H13v5.981h5V6.499L11.5,0z M5.5,13.5
		c-2.261,0-4.175-0.524-5.427-1.388C0.029,12.239,0,12.368,0,12.5C0,13.881,2.462,15,5.5,15s5.5-1.119,5.5-2.5
		c0-0.132-0.029-0.261-0.073-0.388C9.675,12.976,7.761,13.5,5.5,13.5z M5.5,16.5c-2.261,0-4.175-0.524-5.427-1.388
		C0.029,15.239,0,15.368,0,15.5C0,16.881,2.462,18,5.5,18s5.5-1.119,5.5-2.5c0-0.132-0.029-0.261-0.073-0.388
		C9.675,15.976,7.761,16.5,5.5,16.5z M5.5,7C2.462,7,0,8.119,0,9.5S2.462,12,5.5,12S11,10.881,11,9.5S8.538,7,5.5,7z"/>
</g>
</symbol><symbol id="Avatar" viewBox="0 0 18 18"><g id="avatar"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path id="_Compound_Path_" data-name="&lt;Compound Path&gt;" class="cls-2" d="M5.6,10.9l2.5,2.5.9.9.8-.8L12.3,11a6,6,0,0,1,2.1,1.4,2.07,2.07,0,0,1,.6,1l1.1,2.8H1.8l1.1-2.8a1.46,1.46,0,0,1,.6-.9,4.57,4.57,0,0,1,2.1-1.6m6.5-1.4L9,12.6,5.9,9.5a8.62,8.62,0,0,0-3.3,2,3.53,3.53,0,0,0-.8,1.3L0,17.3H18l-1.8-4.5a5.67,5.67,0,0,0-.8-1.3,9.44,9.44,0,0,0-3.3-2ZM9,.8c-2.4,0-3.5,1.9-3.5,4a.57.57,0,0,0-.7.2.59.59,0,0,0,.1.8,2.51,2.51,0,0,0,.7.4C6,7.9,7,9.3,9,9.3c2.5,0,3.5-2.3,3.5-4.4S11.5.8,9,.8ZM9,8.1A2.11,2.11,0,0,1,7,6.7c.2,0,.4.1.7.1a1,1,0,0,0,.8.5.94.94,0,0,0,1-1,.94.94,0,0,0-1-1,.78.78,0,0,0-.7.3,4.25,4.25,0,0,1-1.1-.2V4.9C6.7,4.1,6.9,2,9,2s2.3,2.1,2.3,2.9C11.3,6.1,10.8,8.1,9,8.1Z"/></g></symbol><symbol id="AvatarActive" viewBox="0 0 18 18"><g id="avatar_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M18,17.25H0l1.8-4.47a4.41,4.41,0,0,1,.84-1.33,7.79,7.79,0,0,1,3.28-2L9,12.52l3.08-3.07a8,8,0,0,1,3.27,2,4.41,4.41,0,0,1,.84,1.33ZM4.93,5.8A.6.6,0,0,1,4.76,5a.59.59,0,0,1,.73-.22c0-2.09,1.09-4,3.51-4s3.49,2.08,3.49,4.14S11.51,9.25,9,9.25A3.39,3.39,0,0,1,5.62,6.19,4.7,4.7,0,0,1,4.93,5.8Zm1.76-.91V5c0,.09,0,.22,0,.38a3.81,3.81,0,0,0,1.06.19,1,1,0,0,1,.74-.33,1,1,0,1,1-.85,1.53A4.62,4.62,0,0,1,7,6.64,2.05,2.05,0,0,0,9,8.05c1.81,0,2.29-2,2.29-3.16C11.29,4,11.07,2,9,2S6.69,4,6.69,4.89Z"/></g></symbol><symbol id="Back" viewBox="0 0 18 18">
<g id="direction_x5F_left">
	<rect transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="7.153,2 0.151,9 7.153,16 8.849,16 2.449,9.6 18,9.6 18,8.4 2.449,8.4 8.849,2 	"/>
</g>
</symbol><symbol id="BalanceTransfer" viewBox="0 0 18 18"><g id="balanceTransfer"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M15,7.2H12V6h3ZM6.06,8.64l-1,1H8.74v1.2H5.07l1,1H4.36L2.79,10.21,4.37,8.64Zm1.49,3.57,1.58,1.58L7.55,15.36H5.86l1-1H3.17V13.18H6.83l-1-1ZM6,7.19a4.81,4.81,0,1,0,4.8,4.8A4.8,4.8,0,0,0,6,7.19M6,6a6,6,0,1,1-6,6A6,6,0,0,1,6,6ZM18,1.5v9h0a1.43,1.43,0,0,1-.12.58A1.5,1.5,0,0,1,16.5,12H13.21a6.75,6.75,0,0,0-.11-1.19h3.4a.31.31,0,0,0,.3-.3V9.9h0V7.42h0V5.16h0v-1H4.2V5A6.84,6.84,0,0,0,3,5.46v-4A1.5,1.5,0,0,1,4.5,0h12A1.5,1.5,0,0,1,18,1.5Zm-1.5-.3H4.5a.3.3,0,0,0-.3.3V3H16.8V1.5A.3.3,0,0,0,16.5,1.2Z"/></g></symbol><symbol id="Barcode" viewBox="0 0 18 18">
<g id="barcode">
	<path d="M16.8,1v16H18V1H16.8z M14.4,17h1.2V1h-1.2V17z M10.8,17h2.4V1h-2.4V17z M8.4,17h1.2V1H8.4V17z M2.4,17h1.2V1H2.4V17z
		 M0,17h1.2V1H0V17z M4.8,17h2.4V1H4.8V17z"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="Block" viewBox="0 0 18 18">
<g id="block">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.03,0,0,4.029,0,9s4.03,9,9,9s9-4.029,9-9S13.97,0,9,0z M9,1.2c1.935,0,3.704,0.712,5.068,1.883L3.083,14.069
		C1.913,12.704,1.2,10.935,1.2,9C1.2,4.699,4.699,1.2,9,1.2z M9,16.8c-1.935,0-3.704-0.712-5.068-1.883L14.917,3.931
		C16.087,5.296,16.8,7.065,16.8,9C16.8,13.301,13.301,16.8,9,16.8z"/>
</g>
</symbol><symbol id="BlockActive" viewBox="0 0 18 18">
<g id="block_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<g>
			<circle cx="9" cy="9" r="9"/>
		</g>
		<path style="fill:#FFFFFF;" d="M2.232,14.92c0.264,0.301,0.547,0.584,0.848,0.848L15.768,3.08
			c-0.264-0.301-0.547-0.584-0.848-0.848L2.232,14.92z"/>
	</g>
</g>
</symbol><symbol id="Borrowing" viewBox="0 0 18 18">
<g id="borrowing">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M11.5,0L5,6.499V6.8h1.396L11.5,1.697l5.3,5.299v5.785h-2.6v1.2H18V6.499L11.5,0z M11.5,8h-10C0.675,8,0,8.675,0,9.5V11
		v1.2v4.3C0,17.325,0.675,18,1.5,18h10c0.825,0,1.5-0.675,1.5-1.5v-4.3V11V9.5C13,8.675,12.325,8,11.5,8z M11.8,16.5
		c0,0.163-0.137,0.3-0.3,0.3h-10c-0.163,0-0.3-0.137-0.3-0.3v-4.3h10.6V16.5z M11.8,11H1.2V9.5c0-0.163,0.137-0.3,0.3-0.3h10
		c0.163,0,0.3,0.137,0.3,0.3V11z M10,14H8v1.2h2V14z"/>
</g>
</symbol><symbol id="BorrowingActive" viewBox="0 0 18 18">
<g id="borrowing_x5F_active">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M0,17c0,0.55,0.45,1,1,1h11c0.55,0,1-0.45,1-1v-4.5H0V17z M9,14h2v1.5H9V14z M12,8H1C0.45,8,0,8.45,0,9v2h13V9
		C13,8.45,12.55,8,12,8z M11.5,0L5,6.499V6.5h7c1.379,0,2.5,1.122,2.5,2.5v4.981H18V6.499L11.5,0z"/>
</g>
</symbol><symbol id="CalculatorCurrency" viewBox="0 0 18 18">
<g id="calculator_x5F_currency">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M12.8,13.2h2.762c-1.388,2.161-3.808,3.6-6.562,3.6c-4.301,0-7.8-3.499-7.8-7.8c0-0.621,0.081-1.221,0.219-1.8H0.194
		C0.073,7.782,0,8.382,0,9c0,4.971,4.029,9,9,9c3.132,0,5.888-1.602,7.5-4.029V16.9l1.2-1.2V12H14L12.8,13.2z M9,0
		C5.868,0,3.112,1.602,1.5,4.029V1.1L0.3,2.3V6H4l1.2-1.2H2.438C3.826,2.639,6.246,1.2,9,1.2c4.301,0,7.8,3.499,7.8,7.8
		c0,0.621-0.081,1.221-0.219,1.8h1.225C17.927,10.218,18,9.618,18,9C18,4.029,13.971,0,9,0z M8.936,11.648
		c-1.283,0-1.292-0.651-1.295-0.866L6.44,10.8c0.016,1.108,0.753,1.847,1.959,2.012V14h1.2v-1.216
		c1.193-0.215,1.959-1.01,1.959-2.121c0-1.494-1.342-1.91-2.063-2.135l0,0L8.859,8.325c-0.957-0.297-1.219-0.51-1.219-0.988
		c0-0.914,1.089-0.985,1.423-0.985c1.283,0,1.292,0.651,1.295,0.866l1.2-0.018C11.544,6.092,10.807,5.353,9.6,5.188V4H8.4v1.216
		C7.207,5.431,6.44,6.226,6.44,7.337c0,1.494,1.342,1.91,2.059,2.133l0.637,0.203l0.004,0.002c0.957,0.297,1.219,0.51,1.219,0.988
		C10.359,11.577,9.27,11.648,8.936,11.648z"/>
</g>
</symbol><symbol id="CalculatorCurrencyActive" viewBox="0 0 18 18">
<g id="calculator_x5F_currency_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,16.8c-4.301,0-7.8-3.499-7.8-7.8c0-0.513,0.053-1.014,0.148-1.5H0.131C0.047,7.987,0,8.488,0,9c0,4.971,4.029,9,9,9
		c3.132,0,5.888-1.602,7.5-4.029V16.9l1.2-1.2V12h-1.502C15.02,14.815,12.238,16.8,9,16.8z M9,0C5.868,0,3.112,1.602,1.5,4.029V1.1
		L0.3,2.3V6h1.502C2.98,3.184,5.762,1.2,9,1.2c4.301,0,7.8,3.499,7.8,7.8c0,0.513-0.053,1.014-0.148,1.5h1.217
		C17.953,10.013,18,9.512,18,9C18,4.029,13.971,0,9,0z M9,15.3c3.479,0,6.3-2.82,6.3-6.3S12.479,2.7,9,2.7S2.7,5.521,2.7,9
		S5.521,15.3,9,15.3z M9.096,9.817L9.09,9.816L8.454,9.613C7.755,9.396,6.291,8.941,6.291,7.337c0-1.151,0.765-1.981,1.959-2.241V4
		h1.5v1.065c1.206,0.21,1.943,0.984,1.959,2.133l-1.5,0.021c-0.003-0.196-0.01-0.718-1.146-0.718c-0.383,0-1.273,0.081-1.273,0.835
		c0,0.368,0.168,0.552,1.114,0.846l0.642,0.204l0,0c0.705,0.218,2.163,0.675,2.163,2.276c0,1.151-0.765,1.981-1.959,2.241V14h-1.5
		v-1.065c-1.206-0.21-1.943-0.984-1.959-2.133l1.5-0.021c0.003,0.196,0.01,0.718,1.146,0.718c0.383,0,1.273-0.081,1.273-0.835
		C10.209,10.295,10.041,10.111,9.096,9.817z"/>
</g>
</symbol><symbol id="Calendar" viewBox="0 0 18 18">
<g id="calendar">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15,1V0h-1.2v1H4.2V0H3v1H0v17l14.2,0v0l3.8-3.8V1H15z M14.2,16.303V14.2h2.103L14.2,16.303z M16.8,13H13v3.8H1.2V6h15.6
		V13z M16.8,4.8H1.2V2.2H3v1.3h1.2V2.2h9.6v1.3H15V2.2h1.8V4.8z M8.8,10.029V15H10V7.971L7.003,9.667l0.591,1.045L8.8,10.029z"/>
</g>
</symbol><symbol id="CalendarActive" viewBox="0 0 18 18">
<g id="calendar_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="14.5,17.7 17.7,14.5 14.5,14.5 		"/>
		<polygon points="15,1 15,0 13,0 13,1 5,1 5,0 3,0 3,1 0,1 0,4 18,4 18,1 		"/>
		<path d="M0,18h13v-5h5V5.5H0V18z M10.15,6.714V15h-1.5V9.286L7.668,9.842L6.929,8.537L10.15,6.714z"/>
	</g>
</g>
</symbol><symbol id="Camera" viewBox="0 0 18 18">
<g id="camera_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,4.5h-2.352l-1.236-3.06c-0.23-0.568-0.781-0.94-1.394-0.94H6.482c-0.613,0-1.164,0.372-1.394,0.94L3.852,4.5H1.5
		C0.675,4.5,0,5.175,0,6v10c0,0.825,0.675,1.5,1.5,1.5h15c0.825,0,1.5-0.675,1.5-1.5V6C18,5.175,17.325,4.5,16.5,4.5z M16.8,16
		c0,0.163-0.137,0.3-0.3,0.3h-15c-0.163,0-0.3-0.137-0.3-0.3V6c0-0.163,0.137-0.3,0.3-0.3h3.161l1.54-3.81
		C6.247,1.774,6.358,1.7,6.482,1.7h5.036c0.124,0,0.235,0.074,0.281,0.19l1.54,3.81H16.5c0.163,0,0.3,0.137,0.3,0.3V16z M9,5.5
		c-2.485,0-4.5,2.015-4.5,4.5c0,2.485,2.015,4.5,4.5,4.5s4.5-2.015,4.5-4.5C13.5,7.515,11.485,5.5,9,5.5z M9,13.3
		c-1.82,0-3.3-1.48-3.3-3.3S7.18,6.7,9,6.7s3.3,1.48,3.3,3.3S10.82,13.3,9,13.3z"/>
</g>
</symbol><symbol id="CameraActive" viewBox="0 0 18 18">
<g id="camera_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M16.5,4.5h-2.352l-1.236-3.06c-0.23-0.568-0.781-0.94-1.394-0.94H6.482c-0.613,0-1.164,0.372-1.394,0.94L3.852,4.5H1.5
			C0.675,4.5,0,5.175,0,6v10c0,0.825,0.675,1.5,1.5,1.5h15c0.825,0,1.5-0.675,1.5-1.5V6C18,5.175,17.325,4.5,16.5,4.5z M9,15
			c-2.761,0-5-2.239-5-5s2.239-5,5-5s5,2.239,5,5S11.761,15,9,15z"/>
		<circle cx="9" cy="10" r="3.5"/>
	</g>
</g>
</symbol><symbol id="Card" viewBox="0 0 18 18">
<g id="card">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,6h-15C0.675,6,0,6.675,0,7.5v9C0,17.325,0.675,18,1.5,18h15c0.825,0,1.5-0.675,1.5-1.5v-9C18,6.675,17.325,6,16.5,6z
		 M16.8,16.5c0,0.163-0.137,0.3-0.3,0.3h-15c-0.163,0-0.3-0.137-0.3-0.3v-6.3h15.6V16.5z M16.8,9H1.2V7.5c0-0.163,0.137-0.3,0.3-0.3
		h15c0.163,0,0.3,0.137,0.3,0.3V9z M15,12h-3v1.2h3V12z M13.05,1.221C13.085,1.207,13.122,1.2,13.159,1.2
		c0.103,0,0.23,0.058,0.282,0.187L14.82,4.8h1.294l-1.561-3.862C14.318,0.355,13.753,0,13.159,0c-0.186,0-0.375,0.035-0.558,0.109
		L0.988,4.8h3.204L13.05,1.221z"/>
</g>
</symbol><symbol id="CardDetails" viewBox="0 0 18 18"><g id="cardDetails"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M16.5,0H4.5A1.5,1.5,0,0,0,3,1.5v4A7.73,7.73,0,0,1,4.2,5V4.2H16.8v6.3a.3.3,0,0,1-.3.3H13.09A6.78,6.78,0,0,1,13.2,12h3.3A1.5,1.5,0,0,0,18,10.5v-9A1.5,1.5,0,0,0,16.5,0Zm.3,3H4.2V1.5a.3.3,0,0,1,.3-.3h12a.31.31,0,0,1,.3.3ZM15,6V7.2H12V6ZM5.74,9.05a.7.7,0,1,1-.39.91A.71.71,0,0,1,5.74,9.05ZM6.6,11v4H5.4V11ZM6,7.2A4.8,4.8,0,1,0,10.8,12,4.8,4.8,0,0,0,6,7.2ZM6,6a6,6,0,1,1-6,6A6,6,0,0,1,6,6Z"/></g></symbol><symbol id="CardDetailsActive" viewBox="0 0 18 18"><g id="cardDetails_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M16.5,0A1.5,1.5,0,0,1,18,1.5V2H3V1.5A1.5,1.5,0,0,1,4.5,0ZM18,3.5v7A1.5,1.5,0,0,1,16.5,12h-3A7.49,7.49,0,0,0,3,5.13V3.5Zm-5,3h3V5H13ZM6,6a6,6,0,1,0,6,6A6,6,0,0,0,6,6ZM5.67,8.66a.9.9,0,1,1-.51,1.17A.91.91,0,0,1,5.67,8.66ZM5.1,15.15H6.9v-4H5.1Z"/></g></symbol><symbol id="CardActive" viewBox="0 0 18 18">
<g id="card_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17,6H1C0.45,6,0,6.45,0,7v2h18V7C18,6.45,17.55,6,17,6z M0,17c0,0.55,0.45,1,1,1h16c0.55,0,1-0.45,1-1v-6.5H0V17z M13,12
		h3v1.5h-3V12z M14.553,0.938C14.318,0.355,13.753,0,13.159,0c-0.186,0-0.375,0.035-0.558,0.109L1.731,4.5h14.262L14.553,0.938z"/>
</g>
</symbol><symbol id="CardManage" viewBox="0 0 18 18">
<g id="card_x5F_manage">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M9.555,10.181l0.418-0.986L8.805,8.027L7.819,8.445C7.471,8.247,7.105,8.095,6.727,7.992L6.326,7H4.674L4.273,7.992
			C3.895,8.095,3.529,8.246,3.181,8.445L2.195,8.027L1.027,9.195l0.418,0.986c-0.199,0.348-0.351,0.714-0.453,1.092L0,11.674v1.652
			l0.992,0.401c0.102,0.378,0.254,0.744,0.453,1.092l-0.418,0.986l1.168,1.168l0.986-0.418c0.348,0.199,0.714,0.351,1.092,0.453
			L4.674,18h1.652l0.401-0.992c0.378-0.103,0.744-0.254,1.092-0.453l0.986,0.418l1.168-1.168l-0.418-0.986
			c0.199-0.348,0.351-0.714,0.453-1.092L11,13.326v-1.652l-0.992-0.401C9.905,10.895,9.753,10.529,9.555,10.181z M5.5,15.892
			c-1.873,0-3.392-1.519-3.392-3.392S3.627,9.108,5.5,9.108s3.392,1.519,3.392,3.392S7.373,15.892,5.5,15.892z"/>
		<path d="M16.5,0h-12C3.675,0,3,0.675,3,1.5v5c0.383-0.16,0.784-0.285,1.2-0.369V4.2h12.6v6.3c0,0.163-0.137,0.3-0.3,0.3h-4.732
			c0.105,0.387,0.176,0.788,0.207,1.2H16.5c0.825,0,1.5-0.675,1.5-1.5v-9C18,0.675,17.325,0,16.5,0z M16.8,3H4.2V1.5
			c0-0.163,0.137-0.3,0.3-0.3h12c0.163,0,0.3,0.137,0.3,0.3V3z"/>
		<rect x="12" y="6" width="3" height="1.2"/>
	</g>
</g>
</symbol><symbol id="CardManageActive" viewBox="0 0 18 18">
<g id="card_x5F_manage_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M3,6.234C3.774,5.925,4.616,5.75,5.5,5.75c3.559,0,6.468,2.756,6.725,6.25H17c0.55,0,1-0.45,1-1V3.5H3V6.234z M13,5h3v1.5
		h-3V5z M17,0H4C3.45,0,3,0.45,3,1v1h15V1C18,0.45,17.55,0,17,0z M9.555,10.181l0.418-0.986L8.805,8.027L7.819,8.445
		C7.471,8.247,7.105,8.095,6.727,7.992L6.326,7H4.674L4.273,7.992C3.895,8.095,3.529,8.247,3.181,8.445L2.195,8.027L1.027,9.195
		l0.418,0.986c-0.199,0.348-0.351,0.714-0.453,1.092L0,11.674v1.652l0.992,0.401c0.103,0.378,0.254,0.744,0.453,1.092l-0.418,0.986
		l1.168,1.168l0.986-0.418c0.348,0.199,0.714,0.351,1.092,0.453L4.674,18h1.652l0.401-0.992c0.378-0.103,0.744-0.254,1.092-0.453
		l0.986,0.418l1.168-1.168l-0.418-0.986c0.199-0.348,0.351-0.714,0.453-1.092L11,13.326v-1.652l-0.992-0.401
		C9.905,10.895,9.753,10.529,9.555,10.181z M5.5,15C4.119,15,3,13.881,3,12.5S4.119,10,5.5,10S8,11.119,8,12.5S6.881,15,5.5,15z"/>
</g>
</symbol><symbol id="CardReport" viewBox="0 0 18 18">
<g id="card_x5F_report">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,0h-12C3.675,0,3,0.675,3,1.5v3.963c0.383-0.177,0.784-0.319,1.2-0.426V4.2h12.6v6.3c0,0.163-0.137,0.3-0.3,0.3
		h-3.408c0.066,0.391,0.108,0.79,0.108,1.2h3.3c0.825,0,1.5-0.675,1.5-1.5v-9C18,0.675,17.325,0,16.5,0z M16.8,3H4.2V1.5
		c0-0.163,0.137-0.3,0.3-0.3h12c0.163,0,0.3,0.137,0.3,0.3V3z M15,6h-3v1.2h3V6z M6,6c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6
		S9.314,6,6,6z M6,16.8c-2.647,0-4.8-2.153-4.8-4.8S3.353,7.2,6,7.2s4.8,2.153,4.8,4.8S8.647,16.8,6,16.8z M6.6,9H5.4v4h1.2V9z
		 M6,13.6c-0.387,0-0.7,0.313-0.7,0.7S5.613,15,6,15s0.7-0.313,0.7-0.7S6.386,13.6,6,13.6z"/>
</g>
</symbol><symbol id="CardReportActive" viewBox="0 0 18 18">
<g id="card_x5F_report_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M3,5.97C3.778,5.671,4.618,5.5,5.5,5.5c3.691,0,6.716,2.874,6.975,6.5H17c0.55,0,1-0.45,1-1V3.5H3V5.97z M13,5h3v1.5h-3V5
			z"/>
		<path d="M5.5,7C2.462,7,0,9.462,0,12.5S2.462,18,5.5,18s5.5-2.462,5.5-5.5S8.538,7,5.5,7z M4.6,8.5H6.4v4H4.6V8.5z M5.5,15.8
			c-0.552,0-1-0.447-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C6.5,15.353,6.052,15.8,5.5,15.8z"/>
		<path d="M17,0H4C3.45,0,3,0.45,3,1v1h15V1C18,0.45,17.55,0,17,0z"/>
	</g>
</g>
</symbol><symbol id="CarInsurance" viewBox="0 0 18 18"><g id="carInsurance"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M14.23,1.21H6.76L5.25,5h10.5ZM6.5,7.36A.85.85,0,0,1,7.32,8H5.69A.84.84,0,0,1,6.5,7.36Zm8,0a.84.84,0,1,1-.83.84A.84.84,0,0,1,14.5,7.36ZM16,11h-.8v1.17H16ZM15,0l2,4.92h.65a.35.35,0,0,1,.34.36v.63a.35.35,0,0,1-.34.35H17.2v6.1a1,1,0,0,1-1,1H15a1,1,0,0,1-1-1V11H11V9.8h5V6.2H5V8H3.79V6.27H3.34A.35.35,0,0,1,3,5.92V5.29a.35.35,0,0,1,.34-.36H4L6,0ZM8.8,10.21H1.2v.61A6.15,6.15,0,0,0,5,16.71,6,6,0,0,0,8.8,10.82ZM10,9v1.81a7.21,7.21,0,0,1-4.79,7.09L5,18l-.21-.08A7.38,7.38,0,0,1,0,10.82V9Z"/></g></symbol><symbol id="CarInsuranceActive" viewBox="0 0 18 18"><g id="carInsurance_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M14.2,1.26H6.8L5.32,5H15.67Zm.3,6.1a.84.84,0,1,0,.84.84A.84.84,0,0,0,14.5,7.36ZM15,0l2,4.92h.66a.35.35,0,0,1,.33.36v.63a.34.34,0,0,1-.33.35H17.2v6.1a1,1,0,0,1-1,1h-.8a1,1,0,0,1-1-1V11H11V8H7.32a.85.85,0,0,0-.82-.65A.84.84,0,0,0,5.69,8H3.79V6.27H3.34A.35.35,0,0,1,3,5.92V5.29a.35.35,0,0,1,.34-.36H4L6,0ZM10,9v1.81a7.21,7.21,0,0,1-4.79,7.09L5,18l-.21-.08A7.38,7.38,0,0,1,0,10.82V9Z"/></g></symbol><symbol id="CarLoan" viewBox="0 0 18 18"><g id="carLoan"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" x="0.02" y="0.05" width="17.99" height="17.99"/><path class="cls-2" d="M17.59,6.77h-.86L14.43,1H3.6L1.3,6.77H.41a.41.41,0,0,0-.4.42v.75a.41.41,0,0,0,.4.43H1V16a1,1,0,0,0,1,1H3.21a1,1,0,0,0,1-1V14.18h9.61V16a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V8.37h.58a.41.41,0,0,0,.4-.43V7.19A.41.41,0,0,0,17.59,6.77ZM4.41,2.21h9.21L15.52,7h-13ZM3,15.8H2.22V14.18H3Zm12.8,0H15V14.18h.79Zm0-2.82H2.22V8.17H15.81Zm-3-2.2a1,1,0,1,1,1,1A1,1,0,0,1,12.8,10.78Zm-9.6,0a1,1,0,1,1,1,1A1,1,0,0,1,3.2,10.78Z"/></g></symbol><symbol id="CarLoanActive" viewBox="0 0 18 18"><g id="carLoan_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" y="0.04" width="18" height="18"/><path class="cls-2" d="M17.6,6.77h-.86L14.44,1H3.59L1.29,6.77H.4a.41.41,0,0,0-.4.42v.75a.41.41,0,0,0,.4.43H1V16a1,1,0,0,0,1,1H3.2a1,1,0,0,0,1-1V14.18h9.63V16a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V8.37h.59a.41.41,0,0,0,.4-.43V7.19A.41.41,0,0,0,17.6,6.77ZM4.2,11.88a1.1,1.1,0,0,1,0-2.2,1.1,1.1,0,0,1,0,2.2Zm9.6,0a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,13.8,11.88ZM2.64,6.9,4.46,2.34h9.08L15.36,6.9Z"/></g></symbol><symbol id="ChatAi" viewBox="0 0 18 18">
<g id="chat_x5F_ai">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M6,6c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1S5,4.448,5,5C5,5.552,5.448,6,6,6z M12,6c0.552,0,1-0.448,1-1
		c0-0.552-0.448-1-1-1s-1,0.448-1,1C11,5.552,11.448,6,12,6z M0,0v18l4-4h14V0H0z M16.8,12.8H4H3.503l-0.352,0.351L1.2,15.103V1.2
		h15.6V12.8z M6,9.474C6.838,10.109,7.87,10.5,9,10.5s2.162-0.391,3-1.026V8.118C11.266,8.958,10.2,9.5,9,9.5S6.734,8.958,6,8.118
		V9.474z"/>
</g>
</symbol><symbol id="ChatAiActive" viewBox="0 0 18 18">
<g id="chat_x5F_ai_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v18l4-4h14V0H0z M5,5c0-0.552,0.448-1,1-1s1,0.448,1,1S6.552,6,6,6S5,5.552,5,5z M12,9.797
		c-0.852,0.597-1.883,0.953-3,0.953s-2.148-0.356-3-0.953v-2.07C6.684,8.646,7.769,9.25,9,9.25s2.316-0.604,3-1.523V9.797z M12,6
		c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S12.552,6,12,6z"/>
</g>
</symbol><symbol id="ChequeDeposit" viewBox="0 0 18 18">
<g id="cheque_x5F_deposit">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M13.8,16.801H4.2V2.4H3V18h12V2.4h-1.2V16.801z M8.8,6v9H12V6H8.8z M10.8,13.8H10V7.2h0.8V13.8z M6,10v5h1.2v-5H6z
		 M15.873,0H2.127C0.955,0,0,0.941,0,2.1c0,1.047,0.783,1.91,1.8,2.067V2.936C1.451,2.806,1.2,2.483,1.2,2.1
		c0-0.496,0.416-0.9,0.927-0.9h13.745c0.511,0,0.927,0.404,0.927,0.9c0,0.383-0.251,0.706-0.6,0.836v1.231
		C17.217,4.01,18,3.147,18,2.1C18,0.941,17.045,0,15.873,0z"/>
</g>
</symbol><symbol id="ChequeDepositActive" viewBox="0 0 18 18">
<g id="cheque_x5F_deposit_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M3,2.4V18h12V2.4H3z M7,15H5.5v-5H7V15z M12,15H9V6h3V15z M15.873,0H2.127C0.955,0,0,0.941,0,2.1
		c0,1.047,0.783,1.91,1.8,2.067V2.936C1.451,2.806,1.2,2.483,1.2,2.1c0-0.496,0.416-0.9,0.927-0.9h13.745
		c0.511,0,0.927,0.404,0.927,0.9c0,0.383-0.251,0.707-0.6,0.836v1.231C17.217,4.01,18,3.147,18,2.1C18,0.941,17.045,0,15.873,0z"/>
</g>
</symbol><symbol id="ChevronDoubleDown" viewBox="0 0 16 18">
<g id="chevron_x5F_double_x5F_down">
	<g>
		<polygon points="0,7.696 0,9.392 8,17.392 16,9.392 16,7.696 8,15.694 		"/>
		<polygon points="8,8.694 0,0.696 0,2.392 8,10.392 16,2.392 16,0.696 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="16" height="18"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleDownThick" viewBox="0 0 16 18">
<g id="chevron_x5F_double_x5F_down_x5F_thick">
	<g>
		<polygon points="0,7.271 0,9.817 8,17.815 16,9.817 16,7.271 8,15.271 		"/>
		<polygon points="8,8.271 0,0.271 0,2.817 8,10.815 16,2.817 16,0.271 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="16" height="18"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleLeft" viewBox="0 0 18 16">
<g id="chevron_x5F_double_x5F_left">
	<g>
		<polygon points="10.304,0 8.608,0 0.608,8 8.608,16 10.304,16 2.306,8 		"/>
		<polygon points="9.306,8 17.304,0 15.608,0 7.608,8 15.608,16 17.304,16 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="16"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleLeftThick" viewBox="0 0 18 16">
<g id="chevron_x5F_double_x5F_left_x5F_thick">
	<g>
		<polygon points="10.729,0 8.183,0 0.185,8 8.183,16 10.729,16 2.729,8 		"/>
		<polygon points="9.729,8 17.729,0 15.183,0 7.185,8 15.183,16 17.729,16 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="16"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleRight" viewBox="0 0 18 16">
<g id="chevron_x5F_double_x5F_right">
	<g>
		<polygon points="7.696,0 9.392,0 17.392,8 9.392,16 7.696,16 15.694,8 		"/>
		<polygon points="8.694,8 0.696,0 2.392,0 10.392,8 2.392,16 0.696,16 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect x="0" y="0" style="fill:none;" width="18" height="16"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleRightThick" viewBox="0 0 18 16">
<g id="chevron_x5F_double_x5F_right_x5F_thick">
	<g>
		<polygon points="7.271,16 9.817,16 17.815,8 9.817,0 7.271,0 15.271,8 		"/>
		<polygon points="8.271,8 0.271,16 2.817,16 10.815,8 2.817,0 0.271,0 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="16"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleUp" viewBox="0 0 16 18">
<g id="chevron_x5F_double_x5F_up">
	<g>
		<polygon points="16,10.304 16,8.608 8,0.608 0,8.608 0,10.304 8,2.306 		"/>
		<polygon points="8,9.306 16,17.304 16,15.608 8,7.608 0,15.608 0,17.304 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="16" height="18"/>
	</g>
</g>
</symbol><symbol id="ChevronDoubleUpThick" viewBox="0 0 16 18">
<g id="chevron_x5F_double_x5F_up_x5F_thick">
	<g>
		<polygon points="16,10.729 16,8.183 8,0.185 0,8.183 0,10.729 8,2.729 		"/>
		<polygon points="8,9.729 16,17.729 16,15.183 8,7.185 0,15.183 0,17.729 		"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="16" height="18"/>
	</g>
</g>
</symbol><symbol id="ChevronDown" viewBox="0 0 18 18">
<g id="chevron_x5F_down_1_">
	<polygon points="17,4.196 9,12.194 1,4.196 1,5.892 9,13.892 17,5.892 	"/>
	<rect transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 18 18)" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ChevronDownThick" viewBox="0 0 16 11">
<g id="chevron_x5F_down_x5F_thick">
	<polygon points="16,0.271 8,8.271 0,0.271 0,2.817 8,10.815 16,2.817 	"/>
	<rect transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 16 11)" style="fill:none;" width="16" height="11"/>
</g>
</symbol><symbol id="ChevronLeft" viewBox="0 0 18 18">
<g id="chevron_x5F_left_1_">
	<polygon points="13.804,17 5.806,9 13.804,1 12.108,1 4.108,9 12.108,17 	"/>
	<rect transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 18)" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ChevronLeftThick" viewBox="0 0 11 16">
<g id="chevron_x5F_left_x5F_thick">
	<polygon points="10.729,16 2.729,8 10.729,0 8.183,0 0.185,8 8.183,16 	"/>
	<rect x="-2.5" y="2.5" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -2.5 13.5)" style="fill:none;" width="16" height="11"/>
</g>
</symbol><symbol id="ChevronRight" viewBox="0 0 18 18">
<g id="chevron_x5F_right_1_">
	<polygon points="4.196,17 12.194,9 4.196,1 5.892,1 13.892,9 5.892,17 	"/>
	
		<rect x="0" y="0" transform="matrix(6.558493e-11 -1 1 6.558493e-11 -5.893543e-10 18)" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ChevronRightThick" viewBox="0 0 11 16">
<g id="chevron_x5F_right_x5F_thick">
	<polygon points="0.271,16 8.271,8 0.271,0 2.817,0 10.815,8 2.817,16 	"/>
	<rect x="-2.5" y="2.5" transform="matrix(4.484952e-11 -1 1 4.484952e-11 -2.5 13.5)" style="fill:none;" width="16" height="11"/>
</g>
</symbol><symbol id="ChevronUp" viewBox="0 0 18 18">
<g id="chevron_x5F_up_1_">
	<polygon points="1,13.804 9,5.806 17,13.804 17,12.108 9,4.108 1,12.108 	"/>
	<rect style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ChevronUpThick" viewBox="0 0 16 11">
<g id="chevron_x5F_up_x5F_thick">
	<polygon points="0,10.729 8,2.729 16,10.729 16,8.183 8,0.185 0,8.183 	"/>
	<rect style="fill:none;" width="16" height="11"/>
</g>
</symbol><symbol id="Clear" viewBox="0 0 18 18">
<g id="clear_1_">
	<path d="M12.576,4.576L9,8.152L5.424,4.576L4.576,5.424L8.152,9l-3.576,3.576l0.849,0.848L9,9.848l3.576,3.576l0.849-0.848L9.848,9
		l3.576-3.576L12.576,4.576z M9,0C4.029,0,0,4.03,0,9s4.029,9,9,9s9-4.03,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		S4.699,1.2,9,1.2s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="ClearActive" viewBox="0 0 18 18">
<g id="clear_x5F_active_1_">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<g>
			<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M13.636,12.363l-1.272,1.273L9,10.273l-3.364,3.364
				l-1.272-1.273L7.727,9L4.364,5.637l1.272-1.273L9,7.727l3.364-3.364l1.272,1.273L10.273,9L13.636,12.363z"/>
		</g>
	</g>
</g>
</symbol><symbol id="ClientManagement" viewBox="0 0 18 18">
<g id="client_x5F_management">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16,0H5v2.8h1.2V1.2H16c0.441,0,0.8,0.359,0.8,0.8v11c0,0.441-0.359,0.8-0.8,0.8h-2.8V15H16c1.105,0,2-0.895,2-2V2
		C18,0.895,17.105,0,16,0z M8.2,4H7v0H0v14h12V9V7.8L8.2,4L8.2,4z M10.8,16.8H1.2V5.2H7V9h3.8V16.8z M10.303,7.8H8.2V5.697
		L10.303,7.8z M15,3H8.897l1.2,1.2H15V3z"/>
</g>
</symbol><symbol id="ClientManagementActive" viewBox="0 0 18 18">
<g id="client_x5F_management_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="0,4 0,18 12,18 12,9 7,9 7,4 		"/>
		<path d="M16,0H5v2.5h10V4h-4.679L13.5,7.179V15H16c1.104,0,2-0.896,2-2V2C18,0.896,17.104,0,16,0z"/>
		<polygon points="8.5,7.5 11.7,7.5 8.5,4.3 		"/>
	</g>
</g>
</symbol><symbol id="Close" viewBox="0 0 18 18">
<g id="close">
	<rect style="fill:none;" width="18" height="18"/>
	<polygon points="16.424,2.424 15.576,1.576 9,8.152 2.424,1.576 1.576,2.424 8.152,9 1.576,15.576 2.424,16.424 9,9.848 
		15.576,16.424 16.424,15.576 9.848,9 	"/>
</g>
</symbol><symbol id="Collapse" viewBox="0 0 18 18">
<g id="collapse">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<g>
		<polygon points="18,5.8 13.048,5.8 17.924,0.924 17.076,0.076 12.2,4.952 12.2,0 11,1.2 11,7 16.8,7 		"/>
		<polygon points="5.8,4.952 0.924,0.076 0.076,0.924 4.952,5.8 0,5.8 1.2,7 7,7 7,1.2 5.8,0 		"/>
		<polygon points="12.2,13.048 17.076,17.924 17.924,17.076 13.048,12.2 18,12.2 16.8,11 11,11 11,16.8 12.2,18 		"/>
		<polygon points="0,12.2 4.952,12.2 0.076,17.076 0.924,17.924 5.8,13.048 5.8,18 7,16.8 7,11 1.2,11 		"/>
	</g>
</g>
</symbol><symbol id="Compose" viewBox="0 0 18 18">
<g id="compose">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.8,16.8H1.2V2.2h9.788l1.2-1.2H0v17h16V6.812l-1.2,1.2V16.8z M17.508,1.232l-0.74-0.74C16.44,0.164,16.01,0,15.58,0
		c-0.43,0-0.86,0.164-1.188,0.492L6.298,8.587L4,14l5.413-2.298l8.095-8.095C18.164,2.951,18.164,1.888,17.508,1.232z M16.659,2.759
		l-7.93,7.93l-2.464,1.046l1.046-2.464l7.93-7.93c0.122-0.122,0.265-0.14,0.339-0.14s0.217,0.018,0.339,0.14l0.74,0.74
		c0.122,0.122,0.14,0.265,0.14,0.339S16.782,2.636,16.659,2.759z"/>
</g>
</symbol><symbol id="ComposeActive" viewBox="0 0 18 18">
<g id="compose_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.508,1.233l-0.741-0.741c-0.656-0.656-1.719-0.656-2.375,0L6.298,8.587L4,14l5.413-2.298l8.095-8.095
		C18.164,2.951,18.164,1.888,17.508,1.233z M10.268,12.969l-0.269,0.114l-5.413,2.298l-3.417,1.451l1.451-3.417l2.298-5.413
		l0.114-0.269l0.206-0.206L11.764,1H0v17h16V7.236l-5.526,5.526L10.268,12.969z"/>
</g>
</symbol><symbol id="Contactless" viewBox="0 0 18 18">
<g id="contactless">
	<path d="M4.838,9.838l0.849,0.849C6.531,9.828,7.703,9.292,9,9.292s2.469,0.536,3.313,1.395l0.849-0.849
		C12.101,8.762,10.627,8.093,9,8.093S5.899,8.762,4.838,9.838z M9,5.343c-2.386,0-4.546,0.978-6.106,2.552l0.848,0.848
		c1.342-1.357,3.203-2.2,5.258-2.2s3.916,0.843,5.258,2.2l0.848-0.848C13.546,6.32,11.386,5.343,9,5.343z M6.783,11.783l0.848,0.848
		C7.977,12.27,8.461,12.042,9,12.042s1.023,0.228,1.369,0.589l0.848-0.848c-0.563-0.578-1.348-0.94-2.217-0.94
		S7.346,11.205,6.783,11.783z M9,0C4.03,0,0,4.029,0,9s4.03,9,9,9s9-4.029,9-9S13.97,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		S4.699,1.2,9,1.2s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z"/>
	<rect y="0" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ContactlessActive" viewBox="0 0 18 18">
<g id="contactless_x5F_active">
	<g>
		<circle cx="9" cy="9" r="9"/>
		<g>
			<path style="fill:#FFFFFF;" d="M9,8.093c-1.627,0-3.101,0.669-4.162,1.745l0.849,0.849C6.531,9.828,7.703,9.292,9,9.292
				s2.469,0.536,3.313,1.395l0.849-0.849C12.101,8.762,10.627,8.093,9,8.093z"/>
			<path style="fill:#FFFFFF;" d="M9,10.843c-0.869,0-1.654,0.362-2.217,0.94l0.848,0.848C7.977,12.27,8.461,12.042,9,12.042
				s1.023,0.228,1.369,0.589l0.848-0.848C10.654,11.205,9.869,10.843,9,10.843z"/>
			<path style="fill:#FFFFFF;" d="M9,5.343c-2.386,0-4.546,0.978-6.106,2.552l0.848,0.848c1.342-1.357,3.203-2.2,5.258-2.2
				s3.916,0.843,5.258,2.2l0.848-0.848C13.546,6.32,11.386,5.343,9,5.343z"/>
		</g>
	</g>
	<rect style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="ContactAddressBook" viewBox="0 0 18 18">
<g id="contact_x5F_address_x5F_book">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15,0H1v4H0v1.2h1v3.2H0v1.2h1v3.2H0V14h1v4h14c1.104,0,2-0.895,2-2V2C17,0.895,16.104,0,15,0z M15.8,16
		c0,0.441-0.359,0.8-0.8,0.8H2.2V14H3v-1.2H2.2V9.6H3V8.4H2.2V5.2H3V4H2.2V1.2H15c0.441,0,0.8,0.359,0.8,0.8V16z M11.82,10.424
		c-0.389-0.401-0.875-0.704-1.45-0.89l-1.366,1.366L7.636,9.531c-0.577,0.186-1.066,0.49-1.457,0.892
		c-0.163,0.168-0.288,0.37-0.376,0.588L5,13h8l-0.804-1.989C12.108,10.794,11.984,10.592,11.82,10.424z M9.004,8.764
		c1.089,0,1.551-1.021,1.551-1.937c0-0.951-0.454-1.841-1.551-1.841c-1.097,0-1.56,0.881-1.56,1.841
		C7.444,7.769,7.898,8.764,9.004,8.764z"/>
</g>
</symbol><symbol id="ContactAddressBookActive" viewBox="0 0 18 18">
<g id="contact_x5F_address_x5F_book_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15,0H1v4H0v1.2h1v3.2H0v1.2h1v3.2H0V14h1v4h14c1.104,0,2-0.896,2-2V2C17,0.896,16.104,0,15,0z M9.004,4.786
		c1.098,0,1.551,0.889,1.551,1.841c0,0.916-0.463,1.937-1.551,1.937c-1.106,0-1.56-0.995-1.56-1.937
		C7.444,5.667,7.907,4.786,9.004,4.786z M5,13l0.804-1.989c0.088-0.217,0.212-0.419,0.376-0.588
		c0.391-0.402,0.879-0.706,1.457-0.892l1.368,1.368l1.366-1.366c0.574,0.186,1.061,0.489,1.45,0.89
		c0.163,0.168,0.288,0.37,0.376,0.588L13,13H5z"/>
</g>
</symbol><symbol id="ContactChat" viewBox="0 0 18 18">
<g id="contact_x5F_chat">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v18l4-4h14V0H0z M16.8,12.8H3.503L1.2,15.103V1.2h15.6V12.8z M14,4.3H4v1.2h10V4.3z M14,8.5H4v1.2h10V8.5z"/>
</g>
</symbol><symbol id="ContactChatActive" viewBox="0 0 18 18">
<g id="contact_x5F_chat_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v18l4-4h14V0H0z M14,10H4V8.5h10V10z M14,5.5H4V4h10V5.5z"/>
</g>
</symbol><symbol id="ContactComplaint" viewBox="0 0 18 18">
<g id="contact_x5F_complaint">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v18l4-4h14V0H0z M16.8,12.8H4H3.503l-0.352,0.352L1.2,15.103V1.2h15.6V12.8z M9,11c0.552,0,1-0.448,1-1
		c0-0.552-0.448-1-1-1s-1,0.448-1,1C8,10.552,8.448,11,9,11z M9.601,2.383H8.4V7.5h1.2V2.383z"/>
</g>
</symbol><symbol id="ContactLiveChat" viewBox="0 0 18 18">
<g id="contact_x5F_live_x5F_chat">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="3" y="10.4" width="5" height="1.2"/>
		<path d="M9.176,5.8C8.761,5.256,8.584,4.483,8.584,3.769c0-0.603,0.145-2.569,2.007-2.569c1.849,0,1.993,1.967,1.993,2.569
			c0,0.486-0.11,1.122-0.384,1.663v1.791c1.072-0.711,1.584-2.111,1.584-3.453C13.784,1.479,12.531,0,10.591,0
			C8.643,0,7.384,1.479,7.384,3.769c0,0.707,0.134,1.414,0.404,2.031H9.176z"/>
		<path d="M16.31,10.844c-0.183-0.453-0.437-0.849-0.755-1.178c-0.529-0.544-1.166-0.992-1.893-1.331L13.286,8.16l-0.297,0.289
			c-0.24,0.234-0.508,0.413-0.789,0.566v1.322c0.469-0.178,0.908-0.419,1.301-0.739c0.451,0.249,0.851,0.552,1.192,0.903
			c0.21,0.216,0.38,0.482,0.504,0.791l1.014,2.508H12.2V15h5.79L16.31,10.844z"/>
		<path d="M0,18l3.009-3.008H11V7H0V18z M1.2,8.2h8.6v5.592H2.512L1.2,15.103V8.2z"/>
	</g>
</g>
</symbol><symbol id="ContactLiveChatActive" viewBox="0 0 18 18">
<g id="contact_x5F_live_x5F_chat_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M13.286,8.16l-0.297,0.289c-0.153,0.15-0.318,0.278-0.489,0.394V15h5.49l-1.68-4.156
			c-0.183-0.453-0.437-0.849-0.755-1.178c-0.529-0.544-1.166-0.992-1.893-1.331L13.286,8.16z"/>
		<path d="M12.5,5.5v1.468c0.862-0.754,1.284-1.994,1.284-3.2C13.784,1.479,12.531,0,10.591,0C8.643,0,7.384,1.479,7.384,3.769
			c0,0.596,0.098,1.189,0.289,1.731H12.5z"/>
		<path d="M11,7H0v11l3-3h8V7z M8,11.75H3v-1.5h5V11.75z"/>
	</g>
</g>
</symbol><symbol id="ContactMessage" viewBox="0 0 18 18">
<g id="contact_x5F_message">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,2v14h18V2H0z M15.952,3.2L9,10.151L2.048,3.2H15.952z M1.2,14.8V4.048l7.8,7.8l7.8-7.8V14.8H1.2z"/>
</g>
</symbol><symbol id="ContactMessageActive" viewBox="0 0 18 18">
<g id="contact_x5F_message_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="16.939,2 1.061,2 9,9.939 		"/>
		<polygon points="9,12.061 0,3.061 0,16 18,16 18,3.061 		"/>
	</g>
</g>
</symbol><symbol id="ContactPhone" viewBox="0 0 18 18">
<g id="contact_x5F_phone">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M13.636,17.999c-0.417,0-0.837-0.092-1.23-0.28c-3.923-1.88-6.856-5.046-6.979-5.18c-0.098-0.087-3.265-3.021-5.145-6.944
		c-0.519-1.082-0.303-2.372,0.535-3.21L2.81,0.391c0.504-0.504,1.382-0.504,1.885,0L7.42,3.116c0.519,0.52,0.519,1.365,0,1.884
		L5.938,6.482C5.892,6.528,5.884,6.602,5.92,6.649c0.56,0.726,1.175,1.425,1.827,2.078l1.525,1.525
		c0.649,0.648,1.348,1.264,2.078,1.826c0.047,0.037,0.121,0.028,0.167-0.017L13,10.58c0.502-0.502,1.381-0.503,1.884,0.001
		l2.726,2.726C17.862,13.559,18,13.893,18,14.25c0,0.355-0.139,0.689-0.391,0.94l-1.993,1.993
		C15.082,17.718,14.365,17.999,13.636,17.999z M3.752,1.205c-0.036,0-0.072,0.012-0.094,0.033L1.665,3.232
		c-0.479,0.479-0.6,1.221-0.301,1.845c1.781,3.717,4.879,6.585,4.91,6.613c0.064,0.067,2.941,3.169,6.65,4.946
		c0.623,0.299,1.365,0.177,1.843-0.301l2.033-2.088c0-0.024-0.007-0.062-0.039-0.094l-2.726-2.726c-0.064-0.064-0.123-0.064-0.186,0
		l-1.482,1.482c-0.472,0.472-1.223,0.523-1.749,0.118c-0.771-0.594-1.509-1.243-2.194-1.929L6.899,9.575
		C6.21,8.887,5.562,8.148,4.97,7.382C4.566,6.857,4.617,6.105,5.089,5.634l1.482-1.482c0.052-0.051,0.052-0.136,0-0.188L3.845,1.238
		C3.823,1.217,3.788,1.205,3.752,1.205z"/>
</g>
</symbol><symbol id="ContactPhoneActive" viewBox="0 0 18 18">
<g id="contact_x5F_phone_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.61,13.307l-2.726-2.726c-0.503-0.504-1.382-0.503-1.884-0.001l-1.482,1.482c-0.046,0.046-0.12,0.054-0.167,0.017
		c-0.73-0.562-1.429-1.178-2.078-1.826L7.748,8.728C7.095,8.074,6.48,7.375,5.92,6.649C5.884,6.602,5.892,6.528,5.938,6.482L7.42,5
		c0.519-0.519,0.519-1.364,0-1.884L4.694,0.391c-0.503-0.504-1.381-0.504-1.885,0L0.816,2.385c-0.838,0.838-1.053,2.128-0.535,3.21
		c1.879,3.924,5.047,6.857,5.145,6.944c0.123,0.134,3.056,3.3,6.979,5.18c0.393,0.188,0.814,0.28,1.23,0.28
		c0.729,0,1.446-0.281,1.98-0.815l1.993-1.993C17.861,14.939,18,14.605,18,14.25C18,13.894,17.862,13.559,17.61,13.307z"/>
</g>
</symbol><symbol id="ContactScreenShare" viewBox="0 0 18 18">
<g id="contact_x5F_screen_x5F_share">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<g>
		<polygon points="5.2,6.4 4,6.4 4,11 11.6,11 11.6,9.8 5.2,9.8 		"/>
		<path d="M14,4H0v11h6.4v1.8H3V18h8v-1.2H7.6V15H14V4z M12.8,13.8H1.2V5.2h11.6V13.8z"/>
		<polygon points="4,0 4,2.8 5.2,2.8 5.2,1.2 16.8,1.2 16.8,9.8 15.2,9.8 15.2,11 18,11 18,0 		"/>
	</g>
</g>
</symbol><symbol id="ContactVideo" viewBox="0 0 18 18">
<g id="contact_x5F_video">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M18,15V0H0v15h8.4v1.8H4V18h10v-1.2H9.6V15H18z M1.2,13.8V1.2h15.6v12.6H1.2z M9.005,8.292
		c1.561,0,2.272-1.426,2.272-2.751c0-1.581-0.913-2.644-2.272-2.644c-1.365,0-2.282,1.062-2.282,2.644
		C6.723,6.91,7.428,8.292,9.005,8.292z M9.005,4.097c0.968,0,1.072,1.01,1.072,1.444c0,0.063-0.012,1.552-1.072,1.552
		c-1.03,0-1.082-1.293-1.082-1.552C7.923,5.106,8.028,4.097,9.005,4.097z M12.54,9.883c-0.504-0.519-1.124-0.9-1.843-1.134
		l-0.35-0.114L9.005,9.977L7.662,8.634L7.312,8.746C6.589,8.979,5.966,9.361,5.461,9.882C5.232,10.117,5.05,10.4,4.92,10.725
		L4.081,12.8h1.294l0.658-1.627c0.072-0.179,0.169-0.331,0.289-0.454c0.288-0.297,0.632-0.533,1.024-0.704l1.66,1.659l1.656-1.656
		c0.39,0.171,0.731,0.406,1.018,0.701c0.119,0.122,0.216,0.275,0.289,0.455l0.657,1.626h1.294l-0.838-2.074
		C12.95,10.401,12.769,10.117,12.54,9.883z"/>
</g>
</symbol><symbol id="ContactVirtual" viewBox="0 0 18 18">
<g id="contact_x5F_virtual">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M4.25,8.25C4.94,8.25,5.5,7.69,5.5,7S4.94,5.75,4.25,5.75S3,6.31,3,7S3.56,8.25,4.25,8.25z M13.75,8.25
		C14.44,8.25,15,7.69,15,7s-0.56-1.25-1.25-1.25S12.5,6.31,12.5,7S13.06,8.25,13.75,8.25z M9,8.25c0.69,0,1.25-0.56,1.25-1.25
		S9.69,5.75,9,5.75S7.75,6.31,7.75,7S8.31,8.25,9,8.25z M0,0v18l4-4h14V0H0z M16.8,12.8H4H3.503l-0.352,0.351L1.2,15.103V1.2h15.6
		V12.8z"/>
</g>
</symbol><symbol id="ContactVirtualActive" viewBox="0 0 18 18">
<g id="contact_x5F_virtual_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v18l4-4h14V0H0z M4.25,8.25C3.56,8.25,3,7.69,3,7s0.56-1.25,1.25-1.25S5.5,6.31,5.5,7S4.94,8.25,4.25,8.25z M9,8.25
		C8.31,8.25,7.75,7.69,7.75,7S8.31,5.75,9,5.75S10.25,6.31,10.25,7S9.69,8.25,9,8.25z M13.75,8.25c-0.69,0-1.25-0.56-1.25-1.25
		s0.56-1.25,1.25-1.25S15,6.31,15,7S14.44,8.25,13.75,8.25z"/>
</g>
</symbol><symbol id="ControlBackward" viewBox="0 0 18 18">
<g id="control_x5F_backward">
	<polygon points="4,8.55 4,1 1,1 1,17 4,17 4,9.45 17,17 17,1 	"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="ControlForward" viewBox="0 0 18 18">
<g id="control_x5F_forward">
	<polygon points="14,1 14,8.55 1,1 1,17 14,9.45 14,17 17,17 17,1 	"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="ControlPause" viewBox="0 0 18 18">
<g id="control_x5F_pause">
	<g>
		<rect x="2" y="1" width="4" height="16"/>
		<rect x="12" y="1" width="4" height="16"/>
	</g>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="ControlPlay" viewBox="0 0 18 18">
<g id="control_x5F_play">
	<polygon points="16.774,9 3,1 3,17 	"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="Copy" viewBox="0 0 18 18">
<g id="copy">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M1,17h10V7H1V17z M2.2,8.2h7.6v7.6H2.2V8.2z M8.2,4.2H7v1.6h1.2V4.2z M8.2,2.2H9V1H7v2h1.2V2.2z M15,1v1.2h0.8V3H17V1H15z
		 M12.2,11h1.6V9.8h-1.6V11z M15.8,9.8H15V11h2V8.2h-1.2V9.8z M15.8,7H17V4.2h-1.2V7z M10.2,2.2h3.6V1h-3.6V2.2z"/>
</g>
</symbol><symbol id="CreditLimitIncrease" viewBox="0 0 18 18"><g id="creditLimitIncrease"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M16.5,0H4.5A1.5,1.5,0,0,0,3,1.48V10L4.2,8.82V4.17H16.8v6.31a.31.31,0,0,1-.3.3H9.9L11.07,12H16.5A1.5,1.5,0,0,0,18,10.48v-9A1.5,1.5,0,0,0,16.5,0ZM15,6V7.18H12V6Zm1.5-4.79a.3.3,0,0,1,.3.3V3H4.2V1.48a.3.3,0,0,1,.3-.3ZM2.21,13.08v1.69l3.4-3.4V18h1.2V11.37l3.4,3.4V13.08l-4-4Z"/></g></symbol><symbol id="Dashboard" viewBox="0 0 18 18">
<g id="dashboard">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M9,0C4.03,0,0,4.029,0,9s4.03,9,9,9s9-4.029,9-9S13.97,0,9,0z M9,16.8c-4.099,0-7.461-3.18-7.77-7.2H3V8.4H1.23
		c0.13-1.7,0.804-3.247,1.853-4.469l1.25,1.25l0.849-0.848l-1.25-1.251C5.296,1.912,7.065,1.2,9,1.2s3.704,0.712,5.068,1.883
		l-1.25,1.251l0.849,0.848l1.25-1.25C15.965,5.153,16.639,6.7,16.77,8.4H15V9.6h1.77C16.461,13.62,13.099,16.8,9,16.8z M9.6,7.102V3
		H8.4v4.102C7.591,7.358,7,8.106,7,9c0,1.105,0.896,2,2,2s2-0.895,2-2C11,8.106,10.409,7.358,9.6,7.102z M9,9.8
		C8.559,9.8,8.2,9.441,8.2,9S8.559,8.2,9,8.2S9.8,8.559,9.8,9S9.441,9.8,9,9.8z"/>
</g>
</symbol><symbol id="DashboardActive" viewBox="0 0 18 18">
<g id="dashboard_x5F_active">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<g>
		<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M3.495,9.517H1.226C1.215,9.345,1.2,9.174,1.2,9
			c0-0.334,0.028-0.661,0.069-0.983h2.226V9.517z M4.577,5.404L3.093,3.921c0.327-0.38,0.689-0.728,1.083-1.038l1.461,1.461
			L4.577,5.404z M9,11.5c-1.381,0-2.5-1.119-2.5-2.5c0-1.118,0.738-2.053,1.75-2.373V3h1.5v3.627C10.762,6.947,11.5,7.882,11.5,9
			C11.5,10.381,10.381,11.5,9,11.5z M12.362,4.344l1.461-1.461c0.394,0.311,0.756,0.658,1.083,1.038l-1.484,1.483L12.362,4.344z
			 M14.505,9.517v-1.5h2.226C16.772,8.339,16.8,8.666,16.8,9c0,0.174-0.015,0.345-0.026,0.517H14.505z"/>
		<circle cx="9" cy="9" r="1"/>
	</g>
</g>
</symbol><symbol id="DataChart" viewBox="0 0 18 18">
<g id="data_x5F_chart">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M11,0v7h7C18,3.134,14.866,0,11,0z M12.2,1.325c2.237,0.472,4.003,2.238,4.475,4.475H12.2V1.325z M9,2H8
		c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8V9H9V2z M1.2,10c0-3.682,2.943-6.683,6.6-6.79v6.341l-4.915,4.915
		C1.839,13.27,1.2,11.71,1.2,10z M8,16.8c-1.608,0-3.086-0.564-4.251-1.501L8,11.049l4.251,4.25C11.086,16.236,9.608,16.8,8,16.8z
		 M14.79,10.2c-0.048,1.631-0.67,3.117-1.675,4.266L8.849,10.2H14.79z"/>
</g>
</symbol><symbol id="DataChartActive" viewBox="0 0 18 18">
<g id="data_x5F_chart_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M8,2c-4.418,0-8,3.582-8,8c0,1.939,0.69,3.716,1.838,5.101L8,8.939V2z M2.898,16.161C4.283,17.309,6.061,18,8,18
		s3.717-0.691,5.102-1.839L8,11.061L2.898,16.161z M14.162,15.101C15.31,13.716,16,11.939,16,10H9.061L14.162,15.101z M11,0v7h7
		C18,3.134,14.866,0,11,0z"/>
</g>
</symbol><symbol id="Delete" viewBox="0 0 18 18">
<g id="delete">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.5,2H12V1.5C12,0.675,11.325,0,10.5,0h-3C6.675,0,6,0.675,6,1.5V2H2.5C1.672,2,1,2.672,1,3.5V6h1v12h14V6h1V3.5
		C17,2.672,16.328,2,15.5,2z M7.2,1.5c0-0.163,0.137-0.3,0.3-0.3h3c0.163,0,0.3,0.137,0.3,0.3V2H7.2V1.5z M14.8,16.8H3.2V6h11.6
		V16.8z M15.8,4.8H2.2V3.5c0-0.165,0.135-0.3,0.3-0.3h13c0.166,0,0.3,0.135,0.3,0.3V4.8z M7.2,8H6v7h1.2V8z M12,8h-1.2v7H12V8z"/>
</g>
</symbol><symbol id="DeleteActive" viewBox="0 0 18 18">
<g id="delete_x5F_active">
	<rect style="fill:none;" width="18" height="18"/>
	<g>
		<path d="M2,18h14V6H2V18z M10.5,9H12v6h-1.5V9z M6,9h1.5v6H6V9z"/>
		<path d="M17,4.5v-1C17,2.671,16.329,2,15.5,2H12V1.5C12,0.675,11.325,0,10.5,0h-3C6.675,0,6,0.675,6,1.5V2H2.5
			C1.671,2,1,2.671,1,3.5v1H17z M7.2,1.5c0-0.163,0.137-0.3,0.3-0.3h3c0.163,0,0.3,0.137,0.3,0.3V2H7.2V1.5z"/>
	</g>
</g>
</symbol><symbol id="DeviceSmartWatch" viewBox="0 0 18 18"><g id="deviceSmartWatch"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M13.2,2.3h0a4.85,4.85,0,0,1-.44-1.11A1.62,1.62,0,0,0,11.15,0H6.85A1.62,1.62,0,0,0,5.29,1.19,4.85,4.85,0,0,1,4.85,2.3h0A2.1,2.1,0,0,0,2.7,4.4v9.2a2.1,2.1,0,0,0,2.1,2.1h0a4.85,4.85,0,0,1,.44,1.11A1.62,1.62,0,0,0,6.85,18h4.3a1.62,1.62,0,0,0,1.56-1.19,4.85,4.85,0,0,1,.44-1.11h0a2.1,2.1,0,0,0,2.1-2.1V4.4A2.1,2.1,0,0,0,13.2,2.3ZM6.45,1.5a.41.41,0,0,1,.4-.3h4.3a.41.41,0,0,1,.4.3,6.81,6.81,0,0,0,.26.76H6.19A6.81,6.81,0,0,0,6.45,1.5Zm5.1,15a.41.41,0,0,1-.4.3H6.85a.41.41,0,0,1-.4-.3,6.81,6.81,0,0,0-.26-.76h5.62A6.81,6.81,0,0,0,11.55,16.5Zm2.55-2.9a.9.9,0,0,1-.9.9H4.8a.9.9,0,0,1-.9-.9V4.4a.9.9,0,0,1,.9-.9h8.4a.9.9,0,0,1,.9.9Z"/></g></symbol><symbol id="DeviceAll" viewBox="0 0 18 18"><title>device_all</title><polygon points="18 12 18 0 3 0 3 2.8 4.2 2.8 4.2 1.2 16.8 1.2 16.8 10.8 10.2 10.8 10.2 15 14 15 14 13.8 11.4 13.8 11.4 12 18 12"/><path d="M7,4H2A2,2,0,0,0,0,6V16a2,2,0,0,0,2,2H7a2,2,0,0,0,2-2V6A2,2,0,0,0,7,4Zm.8,12a.86.86,0,0,1-.8.8H2a.86.86,0,0,1-.8-.8V14.5H7.8Zm0-2.7H1.2V6A.86.86,0,0,1,2,5.2H7a.86.86,0,0,1,.8.8Z" transform="translate(0 0)"/><circle cx="4.5" cy="15.6" r="0.6"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="DeviceDesktop" viewBox="0 0 18 18">
<g id="device_x5F_desktop">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M18,15V0H0v15h8.4v1.8H4V18h10v-1.2H9.6V15H18z M1.2,1.2h15.6v12.6H1.2V1.2z"/>
</g>
</symbol><symbol id="DeviceMobile" viewBox="0 0 18 18"><title>device_mobile</title><circle cx="9" cy="15.5" r="0.8"/><path d="M13,0H5A2,2,0,0,0,3,2V16a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V2A2,2,0,0,0,13,0ZM5,1.2h8a.86.86,0,0,1,.8.8V13H4.2V2A.86.86,0,0,1,5,1.2Zm8,15.6H5a.86.86,0,0,1-.8-.8V14.2h9.6V16A.86.86,0,0,1,13,16.8Z" transform="translate(0 0)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="DeviceTablet" viewBox="0 0 18 18"><title>device_tablet</title><path d="M14.52,0h-11a2,2,0,0,0-2,2V16a2,2,0,0,0,2,2h11a2,2,0,0,0,2-2V2A2,2,0,0,0,14.52,0Zm.8,16a.81.81,0,0,1-.8.8h-11a.81.81,0,0,1-.8-.8V2a.81.81,0,0,1,.8-.8h11a.81.81,0,0,1,.8.8Z"/><rect x="2.53" y="2.8" width="13.11" height="1.2"/><circle cx="8.99" cy="15.32" r="0.78"/><rect x="2.3" y="12.75" width="13.34" height="1.2"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="Dial" viewBox="0 0 18 18">
<g id="dial">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,0h-15C0.675,0,0,0.675,0,1.5v15C0,17.325,0.675,18,1.5,18h15c0.825,0,1.5-0.675,1.5-1.5v-15
		C18,0.675,17.325,0,16.5,0z M16.8,1.5v4.1h-4.4V1.2h4.1C16.663,1.2,16.8,1.337,16.8,1.5z M6.8,11.2V6.8h4.4v4.4H6.8z M11.2,12.4
		v4.4H6.8v-4.4H11.2z M5.6,11.2H1.2V6.8h4.4V11.2z M6.8,5.6V1.2h4.4v4.4H6.8z M12.4,6.8h4.4v4.4h-4.4V6.8z M1.5,1.2h4.1v4.4H1.2V1.5
		C1.2,1.337,1.337,1.2,1.5,1.2z M1.2,16.5v-4.1h4.4v4.4H1.5C1.337,16.8,1.2,16.663,1.2,16.5z M16.5,16.8h-4.1v-4.4h4.4v4.1
		C16.8,16.663,16.663,16.8,16.5,16.8z"/>
</g>
</symbol><symbol id="DialActive" viewBox="0 0 18 18">
<g id="dial_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="6.55" y="6.55" width="4.9" height="4.9"/>
		<path d="M12.95,5.05H18V1.5C18,0.675,17.325,0,16.5,0h-3.55V5.05z"/>
		<rect x="6.55" width="4.9" height="5.05"/>
		<rect y="6.55" width="5.05" height="4.9"/>
		<rect x="6.55" y="12.95" width="4.9" height="5.05"/>
		<path d="M5.05,12.95H0v3.55C0,17.325,0.675,18,1.5,18h3.55V12.95z"/>
		<path d="M12.95,12.95V18h3.55c0.825,0,1.5-0.675,1.5-1.5v-3.55H12.95z"/>
		<rect x="12.95" y="6.55" width="5.05" height="4.9"/>
		<path d="M5.05,5.05V0H1.5C0.675,0,0,0.675,0,1.5v3.55H5.05z"/>
	</g>
</g>
</symbol><symbol id="DigitalStatements" viewBox="0 0 18 18"><g id="digitalStatements"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M4.5,15a.6.6,0,1,1-.6.6A.6.6,0,0,1,4.5,15ZM7,4H2A2,2,0,0,0,0,6V16a2,2,0,0,0,2,2H7a2,2,0,0,0,2-2V6A2,2,0,0,0,7,4Zm.8,12a.86.86,0,0,1-.8.8H2a.86.86,0,0,1-.8-.8V14.5H7.8Zm0-2.7H1.2V6A.86.86,0,0,1,2,5.2H7a.86.86,0,0,1,.8.8ZM14.2,0H4V2.8H5.2V1.2H13V5h3.8v9.8H10.2V16H18V3.8Zm0,3.8V1.7l2.1,2.1Z"/></g></symbol><symbol id="Dining" viewBox="0 0 18 18">
<g id="dining">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M4.408,5.862l0.821,0.875C6.292,5.74,6.386,4.104,5.441,3.093C4.929,2.54,4.995,1.699,5.593,1.138L4.771,0.263
		C3.696,1.272,3.603,2.874,4.562,3.91C5.059,4.44,4.99,5.316,4.408,5.862z M12.408,5.862l0.821,0.875
		c1.063-0.997,1.157-2.634,0.211-3.645c-0.512-0.553-0.446-1.394,0.152-1.955l-0.821-0.875c-1.076,1.01-1.168,2.611-0.209,3.647
		C13.059,4.44,12.99,5.316,12.408,5.862z M8.408,5.862l0.821,0.875c1.063-0.997,1.157-2.634,0.211-3.645
		C8.929,2.54,8.995,1.699,9.593,1.138L8.771,0.263C7.696,1.272,7.603,2.874,8.562,3.91C9.059,4.44,8.99,5.316,8.408,5.862z M0,8
		v1.001C0,13.971,4.029,18,9,18c4.971,0,9-4.029,9-8.999V8H0z M9,16.8c-4.234,0-7.691-3.391-7.797-7.6h15.595
		C16.691,13.409,13.234,16.8,9,16.8z"/>
</g>
</symbol><symbol id="DiningActive" viewBox="0 0 18 18">
<g id="dining_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M4.408,5.862l0.821,0.875C6.292,5.74,6.386,4.104,5.441,3.093C4.929,2.54,4.995,1.699,5.593,1.138L4.771,0.263
		C3.696,1.272,3.603,2.874,4.562,3.91C5.059,4.44,4.99,5.316,4.408,5.862z M12.408,5.862l0.821,0.875
		c1.063-0.997,1.157-2.634,0.211-3.645c-0.512-0.553-0.446-1.394,0.152-1.955l-0.821-0.875c-1.076,1.01-1.168,2.611-0.209,3.647
		C13.059,4.44,12.99,5.316,12.408,5.862z M8.408,5.862l0.821,0.875c1.063-0.997,1.157-2.634,0.211-3.645
		C8.929,2.54,8.995,1.699,9.593,1.138L8.771,0.263C7.696,1.272,7.603,2.874,8.562,3.91C9.059,4.44,8.99,5.316,8.408,5.862z M0,8
		v1.001C0,13.971,4.029,18,9,18s9-4.029,9-8.999V8H0z"/>
</g>
</symbol><symbol id="DirectionDown" viewBox="0 0 18 18">
<g id="direction_x5F_down">
	<rect transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 18 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="2,10.847 9,17.849 16,10.847 16,9.151 9.6,15.551 9.6,0 8.4,0 8.4,15.551 2,9.151 	"/>
</g>
</symbol><symbol id="DirectionLeft" viewBox="0 0 18 18">
<g id="direction_x5F_left">
	<rect transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="7.153,2 0.151,9 7.153,16 8.849,16 2.449,9.6 18,9.6 18,8.4 2.449,8.4 8.849,2 	"/>
</g>
</symbol><symbol id="DirectionRight" viewBox="0 0 18 18">
<g id="direction_x5F_right">
	
		<rect x="0" y="0" transform="matrix(4.486817e-11 -1 1 4.486817e-11 -4.001759e-10 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="10.847,2 17.849,9 10.847,16 9.151,16 15.551,9.6 0,9.6 0,8.4 15.551,8.4 9.151,2 	"/>
</g>
</symbol><symbol id="DirectionSwitch" viewBox="0 0 18 18">
<g id="direction_x5F_switch">
	<rect transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M5,2H3.8v12.467L0,10.668v1.697l4.4,4.4L9,12.164v-1.696l-4,4V2z M13.6,1.235L9,5.836v1.696l4-4V16h1.2V3.533L18,7.332
		V5.635L13.6,1.235z"/>
</g>
</symbol><symbol id="DirectionUp" viewBox="0 0 18 18">
<g id="direction_x5F_up">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="16,7.153 9,0.151 2,7.153 2,8.849 8.4,2.449 8.4,18 9.6,18 9.6,2.449 16,8.849 	"/>
</g>
</symbol><symbol id="Document" viewBox="0 0 18 18">
<g id="document">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M13.2,0L13.2,0H1v18h16V3.8L13.2,0z M15.303,3.8H13.2V1.697L15.303,3.8z M15.8,16.8H2.2V1.2H12V5h3.8V16.8z"/>
</g>
</symbol><symbol id="DocumentReport" viewBox="0 0 18 18"><g id="documentReport"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M12,0H0V18H12a2,2,0,0,0,2-2V2A2,2,0,0,0,12,0Zm.8,16a.8.8,0,0,1-.8.8H1.2V1.2H12a.8.8,0,0,1,.8.8ZM3,5.2h8V4H3ZM8,14h3V12.8H8Zm7.2-9.53v1.3l1.24.5L15.2,9.33v3.21L18,5.61Z"/></g></symbol><symbol id="DocumentArticle" viewBox="0 0 18 18">
<g id="document_x5F_article">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="15,3.518 15,1.822 13.178,0 3,0 3,1.199 12.681,1.199 		"/>
		<path d="M12.2,2.4L2,2.4V18h14V6.2L12.2,2.4L12.2,2.4z M14.8,16.8H3.2V3.6H11v3.8h3.8V16.8z M14.303,6.2H12.2V4.097L14.303,6.2z"/>
	</g>
</g>
</symbol><symbol id="DocumentConfidential" viewBox="0 0 18 18">
<g id="document_x5F_confidential">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M14.2,0L14.2,0H4v4.934C4.322,4.855,4.654,4.8,5,4.8c0.068,0,0.132,0.016,0.2,0.02V1.2H13V5h3.8v9.8h-5.6V16H18V3.8L14.2,0
		z M14.2,3.8V1.697L16.303,3.8H14.2z M8.8,10H8V9c0-1.65-1.35-3-3-3S2,7.35,2,9v1H1.2C0.54,10,0,10.54,0,11.2v5.6
		C0,17.46,0.54,18,1.2,18h7.6c0.66,0,1.2-0.54,1.2-1.2v-5.6C10,10.54,9.46,10,8.8,10z M3.2,9c0-0.992,0.808-1.8,1.8-1.8
		S6.8,8.008,6.8,9v1H3.2V9z M8.8,16.8H1.2v-5.6h7.6V16.8z M5.6,13H4.4v2h1.2V13z"/>
</g>
</symbol><symbol id="DocumentEStatement" viewBox="0 0 18 18">
<g id="document_x5F_e_x5F_statement">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M13.2,0L13.2,0H1v18h16V3.8L13.2,0z M13.2,1.697L15.303,3.8H13.2V1.697z M15.8,16.8H2.2V1.2H12V5h3.8V16.8z M10.34,8.994
		L7,6.49v4.176l0.928-0.464L9.329,13l1.484-0.743L9.412,9.458L10.34,8.994z"/>
</g>
</symbol><symbol id="DocumentPdf" viewBox="0 0 18 18">
<g id="document_x5F_pdf">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M3.901,9.378H3.584v0.798h0.267c0.547,0,0.621-0.209,0.621-0.413C4.472,9.489,4.306,9.378,3.901,9.378z M13.2,0L13.2,0L3,0
		v5.8h1.2V1.2H12V5h3.8v11.8H4.2v-1.6H3V18h14V3.8L13.2,0z M13.2,3.8V1.697L15.303,3.8H13.2z M13,13.99V7.01
		C13,7.004,12.996,7,12.99,7H1.01C1.004,7,1,7.004,1,7.01v6.98C1,13.995,1.004,14,1.01,14h11.98C12.996,14,13,13.995,13,13.99z
		 M4.76,10.77l-0.001,0.001c-0.171,0.069-0.405,0.106-0.658,0.106H3.584v1.273H2.672V8.676h1.315c0.322,0,0.66,0.016,0.944,0.207
		c0.302,0.205,0.461,0.521,0.461,0.912C5.393,10.239,5.156,10.604,4.76,10.77z M6.813,12.151H5.685V8.676h1.238
		c1.275,0,1.922,0.579,1.922,1.722C8.844,11.952,7.759,12.151,6.813,12.151z M11.58,9.383h-1.463v0.675h1.377v0.702h-1.377v1.392
		H9.218V8.676h2.362V9.383z M6.859,9.378H6.596v2.071h0.235c0.759,0,1.083-0.312,1.083-1.043S7.609,9.378,6.859,9.378z"/>
</g>
</symbol><symbol id="DollarBill" viewBox="0 0 18 18">
<g id="dollar_x5F_bill">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M0,2.5v13h18v-13H0z M1.249,3.749H8.4v1.467C7.207,5.431,6.44,6.226,6.44,7.337c0,1.494,1.342,1.91,2.059,2.133
		l0.637,0.203l0.004,0.002c0.957,0.297,1.219,0.51,1.219,0.988c0,0.914-1.089,0.985-1.423,0.985c-1.283,0-1.292-0.651-1.295-0.866
		L6.44,10.8c0.016,1.108,0.753,1.847,1.959,2.012v1.439H1.249V3.749z M16.751,14.251H9.6v-1.467c1.193-0.215,1.959-1.01,1.959-2.121
		c0-1.494-1.342-1.91-2.063-2.135l0,0L8.859,8.325c-0.957-0.297-1.219-0.51-1.219-0.988c0-0.914,1.089-0.985,1.423-0.985
		c1.283,0,1.292,0.651,1.295,0.866l1.2-0.018C11.544,6.092,10.807,5.354,9.6,5.188V3.749h7.151V14.251z"/>
</g>
</symbol><symbol id="DollarBillActive" viewBox="0 0 18 18">
<g id="dollar_x5F_bill_x5F_active">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M0,2.5v13h18v-13H0z M8.904,8.183l0.642,0.204l0,0c0.705,0.218,2.163,0.675,2.163,2.276c0,1.151-0.765,1.981-1.959,2.241
		V14h-1.5v-1.065c-1.206-0.21-1.943-0.984-1.959-2.133l1.5-0.021c0.003,0.196,0.01,0.718,1.146,0.718
		c0.383,0,1.273-0.081,1.273-0.835c0-0.368-0.168-0.552-1.114-0.846L9.09,9.816L8.454,9.613C7.755,9.396,6.291,8.941,6.291,7.337
		c0-1.151,0.765-1.981,1.959-2.241V4h1.5v1.065c1.206,0.21,1.943,0.984,1.959,2.133l-1.5,0.021c-0.003-0.196-0.01-0.718-1.146-0.718
		c-0.383,0-1.273,0.081-1.273,0.835C7.791,7.705,7.959,7.889,8.904,8.183z"/>
</g>
</symbol><symbol id="Download" viewBox="0 0 18 18">
<g id="download">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M15.8,12v3.8H2.2V12H1v5h16v-5H15.8z M14,8.848V7.151l-4.4,4.4V1H8.4v10.551L4,7.151v1.697l5,5.001L14,8.848z"/>
</g>
</symbol><symbol id="ECoupon" viewBox="0 0 18 18"><g id="eCoupon"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M18,7.1V2.5H0V7.1H.15a1.9,1.9,0,0,1,0,3.78H0v4.6H18V10.9h-.15A1.9,1.9,0,0,1,18,7.1ZM1.2,14.3V11.86a3.1,3.1,0,0,0,0-5.72V3.7H8.4V5.22a2.15,2.15,0,0,0-2,2.12c0,1.49,1.34,1.91,2.06,2.13l.64.21c1,.29,1.22.5,1.22,1,0,.92-1.09,1-1.42,1-1.29,0-1.3-.65-1.3-.87l-1.2,0a2,2,0,0,0,2,2V14.3Zm15.6-2.44V14.3H9.6V12.78a2.15,2.15,0,0,0,2-2.12c0-1.49-1.34-1.91-2.06-2.13l-.64-.2c-1-.3-1.22-.52-1.22-1,0-.92,1.09-1,1.42-1,1.29,0,1.3.65,1.3.87l1.2,0a2,2,0,0,0-2-2V3.7h7.2V6.14a3.1,3.1,0,0,0,0,5.72Z"/></g></symbol><symbol id="ECouponActive" viewBox="0 0 18 18"><g id="eCoupon_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" y="-0.01" width="18" height="18"/><path class="cls-2" d="M18,2.49v4.6a1.9,1.9,0,0,0-.15,3.8H18v4.6H0v-4.6H.15A1.91,1.91,0,0,0,1.9,9,1.89,1.89,0,0,0,.15,7.1H0V2.49ZM9.75,4H8.25v1.1a2.27,2.27,0,0,0-2,2.24c0,1.6,1.47,2.06,2.17,2.28h0l.63.2c.95.3,1.12.48,1.12.85,0,.75-.89.83-1.27.83-1.14,0-1.14-.52-1.15-.72h0l-1.5,0a2.14,2.14,0,0,0,2,2.13h0V14h1.5V12.9a2.26,2.26,0,0,0,2-2.24c0-1.6-1.46-2.06-2.16-2.28h0l-.64-.2c-1-.3-1.12-.48-1.12-.85,0-.75.89-.84,1.28-.84,1.13,0,1.14.53,1.14.72h0l1.5,0a2.12,2.12,0,0,0-2-2.13h0Z"/></g></symbol><symbol id="Edit" viewBox="0 0 18 18">
<g id="edit">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.368,1.584l-0.952-0.952C15.994,0.211,15.441,0,14.889,0s-1.105,0.211-1.527,0.632L2.954,11.041L0,18l6.959-2.954
		L17.368,4.638C18.211,3.795,18.211,2.427,17.368,1.584z M6.276,14.032l-4.011,1.702l1.702-4.011l8.454-8.454l2.308,2.308
		L6.276,14.032z M16.519,3.789L15.578,4.73L13.27,2.422l0.941-0.941C14.392,1.3,14.633,1.2,14.889,1.2
		c0.256,0,0.497,0.1,0.678,0.281l0.952,0.952C16.893,2.807,16.893,3.415,16.519,3.789z"/>
</g>
</symbol><symbol id="EditActive" viewBox="0 0 18 18">
<g id="edit_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M16.533,5.472l0.834-0.834c0.843-0.843,0.843-2.21,0-3.054l-0.952-0.952c-0.843-0.843-2.21-0.843-3.054,0l-0.835,0.834
			L16.533,5.472z"/>
		<polygon points="11.467,2.527 2.954,11.041 0,18 6.959,15.046 15.473,6.533 		"/>
	</g>
</g>
</symbol><symbol id="Education" viewBox="0 0 18 18">
<g id="education">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M9,1.5l-9,4l9,4l7.8-3.467V13.5H18v-8L9,1.5z M9,8.187L2.955,5.5L9,2.813L15.045,5.5L9,8.187z M13.8,13.5
		c0,0.635-1.822,1.8-4.8,1.8s-4.8-1.165-4.8-1.8V8.68L3,8.146V13.5c0,1.657,2.686,3,6,3s6-1.343,6-3V8.146L13.8,8.68V13.5z"/>
</g>
</symbol><symbol id="EducationActive" viewBox="0 0 18 18">
<g id="education_x5F_active">
	<path d="M9,1.5l-9,4l9,4l7.8-3.467V13.5H18v-8L9,1.5z M9,11.142l-0.609-0.271L3,8.475V13.5c0,1.657,2.686,3,6,3s6-1.343,6-3V8.475
		l-5.391,2.396L9,11.142z"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="EducationBook" viewBox="0 0 18 18">
<g id="education_x5F_book">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M11.647,0.29C10.542,0.29,9.569,0.854,9,1.71C8.431,0.854,7.458,0.29,6.353,0.29H0v16h6.353
		c1.105,0,2.078,0.565,2.647,1.421c0.569-0.856,1.542-1.421,2.647-1.421H18v-16H11.647z M1.2,15.09V1.49h5.153
		c0.663,0,1.279,0.331,1.648,0.885L8.4,2.975v12.622c-0.621-0.329-1.321-0.508-2.047-0.508H1.2z M16.8,15.09h-5.153
		c-0.726,0-1.426,0.179-2.047,0.508V2.975l0.399-0.601c0.368-0.554,0.984-0.885,1.648-0.885H16.8V15.09z"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="EducationBookActive" viewBox="0 0 18 18">
<g id="education_x5F_book_x5F_active_1_">
	<rect style="fill:none;" width="18" height="18"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<g>
		<path d="M8.25,0.946C7.718,0.545,7.07,0.29,6.353,0.29H0v16h6.353c0.717,0,1.365,0.256,1.897,0.657V0.946z"/>
		<path d="M11.647,0.29c-0.717,0-1.365,0.256-1.897,0.657v16c0.532-0.401,1.18-0.657,1.897-0.657H18v-16H11.647z"/>
	</g>
</g>
</symbol><symbol id="Expand" viewBox="0 0 18 18">
<g id="expand">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M7.139,11.709l-0.848-0.848L2.2,14.952V10.8L1,12v5h5l1.2-1.2H3.048L7.139,11.709z M15.8,14.952l-4.091-4.09l-0.848,0.848
		l4.091,4.09H10.8L12,17h5v-5l-1.2-1.2V14.952z M12,1l-1.2,1.2h4.152l-4.09,4.09l0.848,0.848l4.09-4.09V7.2L17,6V1H12z M1,1v5
		l1.2,1.2V3.048l4.091,4.09L7.139,6.29L3.048,2.2H7.2L6,1H1z"/>
</g>
</symbol><symbol id="Export" viewBox="0 0 18 18">
<g id="export">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M15.8,15.8H2.2V2.2H8V1H1v16h16v-6h-1.2V15.8z M7.4,13h1.2V8.5c0-1.323,1.077-2.4,2.4-2.4h4.702l-3.9,3.9h1.696l4.501-4.5
		L13.498,1h-1.697l3.9,3.9H11c-1.985,0-3.6,1.614-3.6,3.6V13z"/>
</g>
</symbol><symbol id="FastTrack" viewBox="0 0 18 18">
<g id="fast_x5F_track">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.03,0,9s4.029,9,9,9s9-4.03,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		c0-4.301,3.499-7.8,7.8-7.8s7.8,3.499,7.8,7.8C16.8,13.301,13.301,16.8,9,16.8z M6.193,5H4.496l4,4l-4,4h1.697l4-4L6.193,5z
		 M10.612,5H8.916l4,4l-4,4h1.697l4.001-4L10.612,5z"/>
</g>
</symbol><symbol id="FastTrackActive" viewBox="0 0 18 18">
<g id="fast_x5F_track_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M4.284,13l4-4l-4-4h2.121l4,4l-4,4H4.284z M10.824,13
		H8.703l4-4l-4-4h2.121l4,4L10.824,13z"/>
</g>
</symbol><symbol id="FavouritePin" viewBox="0 0 18 18">
<g id="favourite_x5F_pin">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.561,4.409l-3.97-3.97C13.298,0.146,12.914,0,12.53,0s-0.768,0.146-1.061,0.439L6.909,5H0l6.076,6.076L0.211,16.94
		c-0.234,0.233-0.234,0.614,0,0.848c0.117,0.117,0.271,0.176,0.424,0.176s0.307-0.059,0.424-0.176l5.864-5.864L13,18v-6.909
		l4.561-4.561C18.146,5.945,18.146,4.995,17.561,4.409z M16.712,5.682L11.8,10.594v4.509L2.897,6.2h4.509l4.912-4.912
		C12.391,1.215,12.473,1.2,12.53,1.2s0.14,0.015,0.212,0.088l3.97,3.97C16.785,5.331,16.8,5.413,16.8,5.47
		S16.785,5.609,16.712,5.682z"/>
</g>
</symbol><symbol id="FavouritePinActive" viewBox="0 0 18 18">
<g id="favourite_x5F_pin_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.561,4.409l-3.97-3.97c-0.586-0.586-1.536-0.586-2.121,0L6.909,5H0l5.793,5.793l-5.5,5.5
		c-0.391,0.391-0.391,1.023,0,1.414C0.488,17.902,0.744,18,1,18s0.512-0.098,0.707-0.293l5.5-5.5L13,18v-6.909l4.561-4.561
		C18.146,5.945,18.146,4.995,17.561,4.409z"/>
</g>
</symbol><symbol id="FavouriteStar" viewBox="0 0 18 18">
<g id="favourite_x5F_star">
	<rect x="0" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9,4.299l1.035,3.083L10.31,8.2h0.863h3.241l-2.62,1.974l-0.677,0.51l0.254,0.808l0.975,3.103l-2.65-1.886L9,12.214
		l-0.696,0.495l-2.65,1.886l0.975-3.103l0.254-0.808l-0.677-0.51L3.587,8.2h3.241H7.69l0.275-0.818L9,4.299 M9,0.528L6.827,7H0
		l5.485,4.133l-2.047,6.513L9,13.687l5.562,3.959l-2.047-6.513L18,7h-6.827L9,0.528L9,0.528z"/>
</g>
</symbol><symbol id="FavouriteStarActive" viewBox="0 0 18 18">
<g id="favourite_x5F_star_x5F_active">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<polygon points="18,7 11.173,7 9,0.528 6.827,7 0,7 5.485,11.133 3.438,17.646 9,13.687 14.562,17.646 12.515,11.133 	"/>
</g>
</symbol><symbol id="FileAttachment" viewBox="0 0 18 18">
<g id="file_x5F_attachment">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M12.2,0L12.2,0H2v8.703l1.2-1.2V1.2H11V5h3.8v11.8H8.491l-1.2,1.2H16V3.8L12.2,0z M12.2,3.8V1.697L14.303,3.8H12.2z
		 M12.026,7.534c-1.11-1.108-2.918-1.108-4.03,0v0.001l-5.222,5.223c-0.682,0.682-0.682,1.792,0,2.474
		c0.341,0.342,0.79,0.512,1.237,0.512c0.448,0,0.896-0.17,1.238-0.512l4.42-4.42L8.82,9.964l-4.42,4.42
		c-0.214,0.213-0.562,0.214-0.778,0c-0.214-0.215-0.214-0.563,0-0.778l5.222-5.222l0,0c0.643-0.645,1.69-0.644,2.333-0.001
		c0.643,0.644,0.643,1.691,0,2.335l-5.277,5.276c-1.074,1.072-2.821,1.072-3.895,0c-1.074-1.074-1.074-2.822,0-3.896L6.535,7.57
		L5.686,6.723L1.158,11.25c-1.542,1.541-1.542,4.05,0,5.592c0.771,0.771,1.783,1.156,2.796,1.156s2.025-0.385,2.796-1.156
		l5.277-5.276C13.138,10.454,13.138,8.646,12.026,7.534z"/>
</g>
</symbol><symbol id="Filter" viewBox="0 0 18 18">
<g id="filter">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M5.23,12.9c-1.173,0-2.15,0.811-2.42,1.9H0V16h2.81c0.27,1.089,1.247,1.9,2.42,1.9c1.173,0,2.15-0.811,2.419-1.9H18v-1.2
		H7.649C7.38,13.711,6.403,12.9,5.23,12.9z M5.23,16.7c-0.717,0-1.3-0.583-1.3-1.3s0.583-1.3,1.3-1.3c0.717,0,1.3,0.583,1.3,1.3
		S5.947,16.7,5.23,16.7z M12.77,6.9c-1.173,0-2.15,0.811-2.419,1.9H0V10h10.351c0.27,1.089,1.247,1.9,2.419,1.9
		c1.173,0,2.15-0.811,2.42-1.9H18V8.8h-2.81C14.92,7.711,13.943,6.9,12.77,6.9z M12.77,10.7c-0.717,0-1.3-0.583-1.3-1.3
		s0.583-1.3,1.3-1.3c0.717,0,1.3,0.583,1.3,1.3S13.487,10.7,12.77,10.7z M7.649,2.8C7.38,1.711,6.403,0.9,5.23,0.9
		c-1.173,0-2.15,0.811-2.42,1.9H0V4h2.81c0.27,1.089,1.247,1.9,2.42,1.9c1.173,0,2.15-0.811,2.419-1.9H18V2.8H7.649z M5.23,4.7
		c-0.717,0-1.3-0.583-1.3-1.3s0.583-1.3,1.3-1.3c0.717,0,1.3,0.583,1.3,1.3S5.947,4.7,5.23,4.7z"/>
</g>
</symbol><symbol id="FilterActive" viewBox="0 0 18 18">
<g id="filter_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M5.23,12.5c-1.025,0-1.903,0.618-2.289,1.5H0v2h2.941c0.386,0.882,1.264,1.5,2.289,1.5c1.025,0,1.903-0.618,2.289-1.5H18
		v-2H7.519C7.133,13.118,6.255,12.5,5.23,12.5z M7.519,2C7.133,1.118,6.255,0.5,5.23,0.5C4.205,0.5,3.327,1.118,2.941,2H0v2h2.941
		C3.327,4.882,4.205,5.5,5.23,5.5c1.025,0,1.903-0.618,2.289-1.5H18V2H7.519z M12.77,6.5c-1.025,0-1.903,0.618-2.289,1.5H0v2h10.481
		c0.386,0.882,1.264,1.5,2.289,1.5c1.025,0,1.903-0.618,2.289-1.5H18V8h-2.941C14.673,7.118,13.795,6.5,12.77,6.5z"/>
</g>
</symbol><symbol id="FilterDown" viewBox="0 0 18 9">
<g id="filter_x5F_down">
	<polygon points="0,0 9,8.999 18,0 	"/>
	<rect y="0" style="fill:none;" width="18" height="9"/>
</g>
</symbol><symbol id="FilterUp" viewBox="0 0 18 9">
<g id="filter_x5F_up">
	<polygon points="18,9 9,0.001 0,9 	"/>
	<rect style="fill:none;" width="18" height="9"/>
</g>
</symbol><symbol id="Fx" viewBox="0 0 18 18">
<g id="fx">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C5.862,0,3.108,1.611,1.5,4.047V1.1L0.3,2.3V6H4l1.2-1.2H2.447C3.836,2.641,6.248,1.2,9,1.2c4.301,0,7.8,3.499,7.8,7.8
		c0,0.62-0.081,1.221-0.218,1.8h1.237C17.937,10.218,18,9.617,18,9C18,4.029,13.971,0,9,0z M12.8,13.2h2.753
		c-1.388,2.159-3.801,3.6-6.553,3.6c-4.301,0-7.8-3.499-7.8-7.8c0-0.62,0.081-1.221,0.218-1.8H0.181C0.063,7.782,0,8.383,0,9
		c0,4.971,4.029,9,9,9c3.138,0,5.892-1.611,7.5-4.047V16.9l1.2-1.2V12H14L12.8,13.2z M5.623,13.223l7.6-7.6l-0.849-0.848l-7.6,7.6
		L5.623,13.223z M8.6,6.8C8.6,5.806,7.794,5,6.8,5S5,5.806,5,6.8s0.806,1.8,1.8,1.8S8.6,7.794,8.6,6.8z M6.2,6.8
		c0-0.331,0.269-0.6,0.6-0.6s0.6,0.269,0.6,0.6S7.131,7.4,6.8,7.4S6.2,7.131,6.2,6.8z M9.4,11.2c0,0.994,0.806,1.8,1.8,1.8
		s1.8-0.806,1.8-1.8s-0.806-1.8-1.8-1.8S9.4,10.206,9.4,11.2z M11.8,11.2c0,0.331-0.269,0.6-0.6,0.6s-0.6-0.269-0.6-0.6
		s0.269-0.6,0.6-0.6S11.8,10.869,11.8,11.2z"/>
</g>
</symbol><symbol id="FxActive" viewBox="0 0 18 18">
<g id="fx_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C5.868,0,3.112,1.602,1.5,4.029V1.1L0.3,2.3V6h1.502C2.98,3.184,5.762,1.2,9,1.2c4.301,0,7.8,3.499,7.8,7.8
		c0,0.513-0.053,1.014-0.148,1.5h1.217C17.953,10.012,18,9.512,18,9C18,4.03,13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		c0-0.513,0.053-1.014,0.148-1.5H0.131C0.047,7.988,0,8.488,0,9c0,4.97,4.029,9,9,9c3.132,0,5.888-1.602,7.5-4.029V16.9l1.2-1.2V12
		h-1.502C15.02,14.816,12.238,16.8,9,16.8z M9,15.3c3.479,0,6.3-2.821,6.3-6.3S12.479,2.7,9,2.7S2.7,5.521,2.7,9S5.521,15.3,9,15.3z
		 M11.25,12.5c-0.69,0-1.25-0.56-1.25-1.25c0-0.69,0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25C12.5,11.94,11.94,12.5,11.25,12.5z
		 M11.319,5.619l1.061,1.061l-5.7,5.7l-1.061-1.061L11.319,5.619z M6.75,5.5C7.44,5.5,8,6.06,8,6.75C8,7.44,7.44,8,6.75,8
		S5.5,7.44,5.5,6.75C5.5,6.06,6.06,5.5,6.75,5.5z"/>
</g>
</symbol><symbol id="Global" viewBox="0 0 18 18">
<g id="global">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M6.851,1.508C5.244,3.055,4.166,5.546,4.03,8.4h-2.8
		C1.482,5.111,3.778,2.391,6.851,1.508z M1.23,9.6h2.8c0.136,2.854,1.214,5.345,2.821,6.892C3.778,15.609,1.482,12.889,1.23,9.6z
		 M8.4,16.221C6.637,15.044,5.387,12.549,5.234,9.6H8.4V16.221z M8.4,8.4H5.234C5.387,5.451,6.637,2.956,8.4,1.779V8.4z M16.77,8.4
		h-2.8c-0.135-2.848-1.208-5.334-2.809-6.882C14.225,2.404,16.518,5.116,16.77,8.4z M9.6,16.221V9.6h3.166
		C12.613,12.549,11.363,15.044,9.6,16.221z M9.6,8.4V1.779c1.763,1.177,3.013,3.672,3.166,6.622H9.6z M11.161,16.482
		c1.601-1.548,2.674-4.034,2.809-6.882h2.8C16.518,12.884,14.225,15.596,11.161,16.482z"/>
</g>
</symbol><symbol id="GlobalMoney" viewBox="0 0 18 18"><g id="globalMoney"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M17.82,10.8A8.86,8.86,0,0,0,18,9,9,9,0,0,0,1.5,4.05V1.87L.3,3.07V6H3.24l1.2-1.2h-2A7.83,7.83,0,0,1,6.85,1.51,10.31,10.31,0,0,0,4,8.4H1.23a7.9,7.9,0,0,1,.19-1.2H.18A8.86,8.86,0,0,0,0,9,9,9,0,0,0,16.5,14v2.18l1.2-1.2V12H14.89l-1.2,1.2h1.85a7.83,7.83,0,0,1-4.38,3.28A10.25,10.25,0,0,0,14,9.6h2.8a6.82,6.82,0,0,1-.19,1.2ZM1.23,9.6H4a10.31,10.31,0,0,0,2.82,6.89A7.8,7.8,0,0,1,1.23,9.6ZM8.4,16.22C6.64,15,5.39,12.55,5.24,9.6H8.4Zm0-7.82H5.24C5.39,5.45,6.64,3,8.4,1.78Zm1.2,7.82V9.6h3.17C12.61,12.55,11.36,15,9.6,16.22Zm0-7.82h0V1.78c1.76,1.18,3,3.67,3.17,6.62ZM14,8.4a10.25,10.25,0,0,0-2.81-6.88A7.79,7.79,0,0,1,16.77,8.4Z"/></g></symbol><symbol id="GlobalActive" viewBox="0 0 18 18">
<g id="global_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M8.25,16.656V9.75H4.794C4.989,12.835,6.346,15.438,8.25,16.656z"/>
		<path d="M9.75,9.75v6.906c1.904-1.218,3.261-3.821,3.456-6.906H9.75z"/>
		<path d="M8.25,8.25V1.344C6.346,2.562,4.989,5.164,4.794,8.25H8.25z"/>
		<path d="M14.708,8.25h3.254c-0.337-4.071-3.378-7.368-7.326-8.094C12.906,1.677,14.506,4.698,14.708,8.25z"/>
		<path d="M14.708,9.75c-0.202,3.552-1.802,6.573-4.072,8.094c3.948-0.726,6.989-4.023,7.326-8.094H14.708z"/>
		<path d="M3.292,9.75H0.038c0.337,4.071,3.378,7.368,7.326,8.094C5.094,16.323,3.494,13.302,3.292,9.75z"/>
		<path d="M9.75,1.344V8.25h3.456C13.011,5.164,11.654,2.562,9.75,1.344z"/>
		<path d="M3.292,8.25c0.202-3.552,1.802-6.573,4.072-8.094C3.416,0.882,0.375,4.179,0.038,8.25H3.292z"/>
	</g>
</g>
</symbol><symbol id="Goals" viewBox="0 0 18 18">
<g id="goals">
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M9,3C5.686,3,3,5.686,3,9s2.686,6,6,6s6-2.686,6-6S12.314,3,9,3z M9,13.8
		c-2.647,0-4.8-2.153-4.8-4.8S6.353,4.2,9,4.2s4.8,2.153,4.8,4.8S11.647,13.8,9,13.8z M9,6C7.343,6,6,7.343,6,9s1.343,3,3,3
		s3-1.343,3-3S10.657,6,9,6z M9,10.8c-0.993,0-1.8-0.807-1.8-1.8S8.007,7.2,9,7.2s1.8,0.807,1.8,1.8S9.993,10.8,9,10.8z"/>
	<rect y="0" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="GoalsActive" viewBox="0 0 18 18">
<g id="goals_x5F_active">
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7
		S12.86,16,9,16z M9,3C5.686,3,3,5.687,3,9s2.686,6,6,6s6-2.687,6-6S12.314,3,9,3z M9,13c-2.206,0-4-1.794-4-4s1.794-4,4-4
		s4,1.794,4,4S11.206,13,9,13z M9,6C7.343,6,6,7.343,6,9s1.343,3,3,3s3-1.343,3-3S10.657,6,9,6z M9,10c-0.551,0-1-0.449-1-1
		s0.449-1,1-1s1,0.449,1,1S9.551,10,9,10z"/>
	<rect y="0" style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="Grab" viewBox="0 0 18 18">
<g id="grab" transform="translate(5.000000, 0.000000)" fill="#767676">
  <circle id="Oval" cx="1.29999995" cy="1.29999995" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="6.29999995" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="1.29999995" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="6.29999995" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="11.3" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="11.3" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="16.3" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="16.3" r="1.29999995"/>
</g>
</symbol><symbol id="GrabActive" viewBox="0 0 18 18">
<g id="grab_active" transform="translate(5.000000, 0.000000)" fill="#333333">
  <circle id="Oval" cx="1.29999995" cy="1.29999995" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="6.29999995" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="1.29999995" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="6.29999995" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="11.3" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="11.3" r="1.29999995"/>
  <circle id="Oval" cx="1.29999995" cy="16.3" r="1.29999995"/>
  <circle id="Oval" cx="6.29999995" cy="16.3" r="1.29999995"/>
</g>
</symbol><symbol id="Health" viewBox="0 0 18 18">
<g id="health">
	<rect x="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.62,2.55c-0.92-0.92-2.125-1.379-3.33-1.379S10.879,1.63,9.96,2.55C9.544,2.965,9.228,3.44,9,3.946
		C8.772,3.44,8.456,2.965,8.04,2.55C7.121,1.63,5.915,1.17,4.71,1.17S2.299,1.63,1.38,2.55c-1.839,1.839-1.839,4.821,0,6.66L9,16.83
		l7.62-7.62C18.46,7.371,18.46,4.389,16.62,2.55z M15.772,8.361L9,15.133L2.228,8.361C1.565,7.698,1.2,6.817,1.2,5.88
		c0-0.938,0.365-1.819,1.028-2.482C2.891,2.735,3.772,2.37,4.71,2.37s1.819,0.365,2.482,1.028c0.296,0.296,0.536,0.646,0.714,1.04
		l0.468,1.038h1.253l0.468-1.038c0.178-0.394,0.418-0.744,0.714-1.041c0.663-0.663,1.544-1.028,2.482-1.028s1.819,0.365,2.482,1.028
		C16.435,4.061,16.8,4.942,16.8,5.88C16.8,6.817,16.435,7.698,15.772,8.361z M8.65,9.536L7.087,7.974L6.239,8.822l2.411,2.412
		l4.78-4.78l-0.849-0.848L8.65,9.536z"/>
</g>
</symbol><symbol id="HealthActive" viewBox="0 0 18 18">
<g id="health_x5F_active_1_">
	<rect x="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.62,2.55c-1.839-1.839-4.822-1.839-6.661,0C9.544,2.965,9.228,3.44,9,3.946C8.772,3.44,8.456,2.965,8.04,2.55
		c-1.839-1.839-4.822-1.839-6.661,0c-1.839,1.839-1.839,4.821,0,6.66L9,16.829l7.62-7.62C18.46,7.371,18.46,4.389,16.62,2.55z
		 M8.366,11.478L5.372,8.484l1.061-1.061l1.934,1.934l4.146-4.146l1.061,1.061L8.366,11.478z"/>
</g>
</symbol><symbol id="Help" viewBox="0 0 18 18">
<g id="help_x5F_circle_1_">
	<g>
		<g style="opacity:0.25;">
			<rect y="0" style="fill:none;" width="18" height="18"/>
		</g>
	</g>
	<path d="M9,0C4.029,0,0,4.03,0,9s4.029,9,9,9s9-4.03,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M8.999,12.5c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S9.552,12.5,8.999,12.5z
		 M9.604,3.539C8.75,3.363,7.875,3.569,7.207,4.113C6.54,4.656,6.157,5.46,6.157,6.319h1.2c0-0.496,0.221-0.961,0.607-1.275
		c0.392-0.318,0.887-0.437,1.396-0.33c0.636,0.133,1.154,0.677,1.26,1.323c0.089,0.538-0.078,1.064-0.458,1.443L9.013,8.629
		C8.75,8.894,8.4,9.324,8.4,10.011V11h1.2v-0.989c0-0.176,0.042-0.312,0.262-0.533L11.01,8.33c0.657-0.656,0.946-1.562,0.794-2.488
		C11.616,4.7,10.732,3.775,9.604,3.539z"/>
</g>
</symbol><symbol id="HelpActive" viewBox="0 0 18 18">
<g id="help_x5F_active_1_">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<g>
		<g>
			<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M8.999,14.5c-0.69,0-1.25-0.56-1.25-1.25
				S8.309,12,8.999,12s1.25,0.56,1.25,1.25S9.69,14.5,8.999,14.5z M11.222,8.542l-1.148,1.147C9.9,9.864,9.9,9.929,9.9,10.011V11
				H8.1v-0.989c0-0.798,0.4-1.292,0.7-1.594L9.95,7.269c0.311-0.31,0.447-0.741,0.374-1.184c-0.086-0.526-0.508-0.969-1.025-1.077
				c-0.419-0.087-0.824,0.008-1.145,0.27C7.838,5.534,7.657,5.914,7.657,6.319h-1.8c0-0.95,0.423-1.839,1.161-2.438
				C7.756,3.28,8.724,3.052,9.666,3.246c1.248,0.261,2.226,1.284,2.434,2.547C12.268,6.815,11.948,7.817,11.222,8.542z"/>
		</g>
	</g>
</g>
</symbol><symbol id="Home" viewBox="0 0 18 18">
<g id="home">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0L1,8v10h7v-6.8h2V18h7V8L9,0z M15.8,16.8h-4.6V10H6.8v6.8H2.2V8.497l6.8-6.8l6.8,6.8V16.8z"/>
</g>
</symbol><symbol id="HomeActive" viewBox="0 0 18 18">
<g id="home_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<polygon points="9,0 1,8 1,18 8,18 8,12 10,12 10,18 17,18 17,8 	"/>
</g>
</symbol><symbol id="Insight" viewBox="0 0 18 18">
<g id="insight">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.168,3.436C13.834,1.284,11.528,0,9,0C6.47,0,4.163,1.286,2.83,3.44C2.146,4.545,2.034,5.934,2.528,7.156L5,13.266V16
		l2,2h4l2-2v-2.734l2.471-6.113C15.966,5.93,15.853,4.539,15.168,3.436z M11.8,15.503L10.503,16.8H7.497L6.2,15.503V13h5.6V15.503z
		 M9.8,11.8H8.2V6c0-0.441,0.359-0.8,0.8-0.8c0.441,0,0.8,0.359,0.8,0.8V11.8z M14.359,6.704l-2.06,5.096H11V6c0-1.104-0.895-2-2-2
		C7.895,4,7,4.895,7,6v5.8H5.701l-2.06-5.093C3.289,5.837,3.367,4.852,3.85,4.071C4.963,2.273,6.888,1.199,9,1.199
		c2.11,0,4.034,1.072,5.148,2.869C14.632,4.848,14.71,5.833,14.359,6.704z"/>
</g>
</symbol><symbol id="InsightActive" viewBox="0 0 18 18">
<g id="insight_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="5,13 5,16 7,18 11,18 13,16 13,13 		"/>
		<path d="M15.168,3.436C13.834,1.284,11.528,0,9,0C6.47,0,4.163,1.286,2.83,3.44C2.146,4.545,2.034,5.934,2.528,7.156L4.286,11.5H7
			V6c0-1.104,0.895-2,2-2c1.104,0,2,0.895,2,2v5.5h2.714l1.757-4.347C15.966,5.93,15.853,4.539,15.168,3.436z"/>
		<path d="M9,5.5C8.724,5.5,8.5,5.724,8.5,6v5.5h1V6C9.5,5.724,9.275,5.5,9,5.5z"/>
	</g>
</g>
</symbol><symbol id="InstalmentPaymentPlan" viewBox="0 0 18 18"><g id="instalmentPaymentPlan"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M15,7.2H12V6h3Zm1.5-6h-12a.31.31,0,0,0-.3.3V3h12.6V1.5A.3.3,0,0,0,16.49,1.2Zm1.5.3v9h0a1.58,1.58,0,0,1-.11.58,1.52,1.52,0,0,1-1.39.92H10.8V10.8h5.69a.3.3,0,0,0,.3-.3V9.9h0V7.43h0V5.16h0v-1H4.19V5h0V6.6H3V1.5A1.51,1.51,0,0,1,4.49,0h12A1.5,1.5,0,0,1,18,1.5ZM7.2,8.4V7.8H6v.6H3.59V7.8H2.4v.61H0V18h9.6V8.4Zm1.21,8.4H1.2V12H8.41Zm-7.21-6V9.6H2.4v.6H3.59V9.6H6v.6H7.2V9.6H8.41v1.2Z"/></g></symbol><symbol id="Insurance" viewBox="0 0 18 18">
<g id="insurance">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.276,2.549C13.587,0.905,11.358,0,9,0C6.642,0,4.413,0.905,2.724,2.549C1.04,4.189,0.072,6.385,0,8.734V10h0.362
		l0.695-0.859c0.484-0.57,1.188-0.896,1.933-0.896c0.936,0,1.793,0.514,2.237,1.341L5.45,10h0.54l0.251-0.346
		C6.762,8.938,7.544,8.474,8.4,8.317v7.22c0,0.691-0.562,1.254-1.253,1.254s-1.253-0.562-1.253-1.254V15h-1.2v0.537
		c0,1.353,1.101,2.453,2.453,2.453S9.6,16.89,9.6,15.537V8.316c0.858,0.154,1.642,0.617,2.165,1.332L12.023,10h0.526l0.228-0.422
		c0.445-0.823,1.3-1.334,2.233-1.334c0.744,0,1.449,0.327,1.932,0.896L17.638,10H18V8.734C17.928,6.385,16.96,4.189,15.276,2.549z
		 M2.99,7.044c-0.572,0-1.128,0.131-1.632,0.378C1.67,5.903,2.429,4.511,3.561,3.409C4.75,2.252,6.25,1.526,7.866,1.291
		C6.434,2.87,5.52,4.855,5.269,6.982C5.238,7.248,5.233,7.517,5.222,7.785C4.588,7.312,3.81,7.044,2.99,7.044z M9.005,7.044
		c-0.932,0-1.83,0.293-2.586,0.806c0.009-0.243,0.014-0.487,0.042-0.729c0.236-1.999,1.132-3.857,2.54-5.291
		c1.43,1.457,2.329,3.346,2.549,5.377c0.023,0.209,0.026,0.424,0.034,0.637C10.829,7.335,9.934,7.044,9.005,7.044z M15.01,7.044
		c-0.818,0-1.596,0.267-2.229,0.739c-0.01-0.236-0.013-0.473-0.038-0.704c-0.235-2.164-1.152-4.183-2.607-5.788
		c1.615,0.235,3.114,0.961,4.303,2.118c1.136,1.106,1.896,2.504,2.207,4.012C16.142,7.176,15.585,7.044,15.01,7.044z"/>
</g>
</symbol><symbol id="InsuranceActive" viewBox="0 0 18 18">
<g id="insurance_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.276,2.549C13.587,0.905,11.358,0,9,0S4.413,0.905,2.724,2.549C1.04,4.189,0.072,6.385,0,8.734V10h0.362l0.695-0.859
		c0.484-0.57,1.188-0.896,1.932-0.896c0.936,0,1.793,0.514,2.237,1.341L5.449,10h0.54l0.251-0.346
		C6.762,8.938,7.544,8.473,8.4,8.317v7.22c0,0.691-0.562,1.254-1.253,1.254s-1.253-0.562-1.253-1.254V15h-1.2v0.537
		c0,1.353,1.101,2.453,2.453,2.453S9.6,16.89,9.6,15.537V8.315c0.858,0.154,1.642,0.617,2.165,1.332L12.023,10h0.526l0.228-0.422
		c0.445-0.823,1.3-1.334,2.233-1.334c0.745,0,1.449,0.327,1.932,0.896L17.638,10H18V8.734C17.928,6.385,16.96,4.189,15.276,2.549z
		 M12.194,8.325c-0.234-0.223-0.493-0.413-0.766-0.582c-0.009-0.173-0.01-0.348-0.028-0.519c-0.211-1.946-1.056-3.761-2.4-5.178
		C7.678,3.441,6.836,5.226,6.61,7.14C6.587,7.341,6.585,7.544,6.575,7.747c-0.272,0.169-0.531,0.36-0.764,0.583
		C5.596,8.084,5.344,7.88,5.077,7.699C5.089,7.454,5.092,7.208,5.12,6.965c0.248-2.1,1.136-4.061,2.522-5.642
		C8.087,1.245,8.54,1.2,9,1.2c0.461,0,0.914,0.045,1.359,0.124c1.409,1.607,2.302,3.602,2.533,5.739
		c0.023,0.208,0.024,0.422,0.034,0.634C12.66,7.877,12.408,8.08,12.194,8.325z"/>
</g>
</symbol><symbol id="Intranet" viewBox="0 0 18 18">
<g id="intranet">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M16.5,1.5h-15C0.675,1.5,0,2.175,0,3v1.3v1.2V15c0,0.825,0.675,1.5,1.5,1.5h15c0.825,0,1.5-0.675,1.5-1.5V5.5V4.3V3
		C18,2.175,17.325,1.5,16.5,1.5z M5,15.3H1.5c-0.163,0-0.3-0.137-0.3-0.3V5.5H5V15.3z M16.8,15c0,0.163-0.137,0.3-0.3,0.3H6.2V5.5
		h10.6V15z M16.8,4.3H1.2V3c0-0.163,0.137-0.3,0.3-0.3h15c0.163,0,0.3,0.137,0.3,0.3V4.3z M12.031,13.621l1.649-0.826l-1-1.997
		l1.031-0.516L10,7.5v4.639l1.031-0.516L12.031,13.621z"/>
</g>
</symbol><symbol id="Investment" viewBox="0 0 18 18">
<g id="investment">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.606,1.545l-7.21,7.211L5.629,5.988L2.4,9.217v1.697l3.229-3.228l2.767,2.768l7.21-7.211L18,5.635V3.939L15.606,1.545z
		 M1.2,0H0v16.8V18h1.2H18v-1.2H1.2V0z"/>
</g>
</symbol><symbol id="InvestmentActive" viewBox="0 0 18 18">
<g id="investment_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1.2,0H0v18h18v-1.2H1.2V0z M15.606,1.545l-7.21,7.211L5.629,5.988L2.7,8.917V15.3H18V3.939L15.606,1.545z"/>
</g>
</symbol><symbol id="InvestmentMarket" viewBox="0 0 18 18">
<g id="investment_x5F_market">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M15.606,0.545l-7.21,7.211L5.629,4.988L2.4,8.217v1.697l3.229-3.228l2.767,2.768l7.21-7.211L18,4.635V2.939L15.606,0.545z
		 M9.046,10.666L2.4,13.486v1.304l6.646-2.822l4.302,1.825L18,9.142V7.446l-4.928,4.928L9.046,10.666z M1.2,0H0v16.8V18h1.2H18v-1.2
		H1.2V0z"/>
</g>
</symbol><symbol id="InvestmentMarketActive" viewBox="0 0 18 18">
<style type="text/css">
	.st0{fill:none;}
</style>
<g id="investment_x5F_market_x5F_active">
	<rect y="0" class="st0" width="18" height="18"/>
	<path d="M1.2,0H0v18h18v-1.2H1.2V0z M15.6,0.5L8.4,7.8L5.6,5L2.7,7.9v4.3L9,9.5l4,1.7l5-5V2.9L15.6,0.5z M9,11.1l-6.3,2.7v1.5H18
		V8.4L13.4,13L9,11.1z"/>
</g>
</symbol><symbol id="InvestmentQuote" viewBox="0 0 18 18.014">
<g id="investment_x5F_quote">
	<rect y="0.014" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="2.4,11.762 5.587,8.576 8.354,11.342 18,1.696 18,0 8.354,9.645 5.587,6.878 2.4,10.066 		"/>
		<polygon points="16.8,4.615 16.8,16.814 12.2,16.814 12.2,9.215 11,10.415 11,16.814 7,16.814 7,11.707 5.8,10.507 5.8,16.814 
			1.2,16.814 1.2,0.014 0,0.014 0,18.014 18,18.014 18,3.415 		"/>
	</g>
</g>
</symbol><symbol id="InvestmentQuoteActive" viewBox="0 0 18 18">
<g id="investment_x5F_quote_x5F_active">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M8.354,9.419L5.587,6.652L2.7,9.54v5.76h4.1V9.986l1.5,1.5V15.3h4.1V7.494l1.5-1.5V15.3H18V0L8.354,9.419z M1.2,0H0v18h18
		v-1.2H1.2V0z"/>
</g>
</symbol><symbol id="Link" viewBox="0 0 18 18">
<g id="link">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.864,12.834c-0.067,0.083-0.139,0.164-0.217,0.241l-2.836,2.836C6.239,16.484,5.476,16.8,4.665,16.8
		c-0.811,0-1.573-0.316-2.147-0.889l-0.428-0.428c-1.184-1.184-1.184-3.11,0-4.294l2.836-2.836c0.573-0.574,1.336-0.889,2.147-0.889
		s1.574,0.316,2.147,0.889l0.428,0.428c0.056,0.056,0.108,0.114,0.159,0.173c0.32,0.248,0.71,0.384,1.121,0.384
		c0.162,0,0.321-0.023,0.473-0.063c-0.206-0.487-0.507-0.944-0.905-1.342l-0.428-0.428C9.241,6.677,8.156,6.263,7.072,6.263
		S4.904,6.677,4.077,7.504l-2.836,2.836c-1.655,1.655-1.655,4.337,0,5.991l0.428,0.428C2.496,17.586,3.581,18,4.665,18
		s2.169-0.414,2.996-1.241l2.836-2.836c0.302-0.302,0.548-0.638,0.74-0.996c-0.102,0.006-0.205,0.009-0.308,0.009
		C10.567,12.937,10.211,12.902,9.864,12.834z M16.759,1.669l-0.428-0.428C15.504,0.414,14.419,0,13.335,0s-2.169,0.414-2.996,1.241
		L7.504,4.077c-0.302,0.302-0.548,0.638-0.74,0.996c0.102-0.006,0.205-0.009,0.308-0.009c0.361,0,0.717,0.035,1.063,0.103
		c0.067-0.083,0.139-0.164,0.217-0.241l2.836-2.836C11.761,1.516,12.524,1.2,13.335,1.2c0.811,0,1.573,0.316,2.147,0.889
		l0.428,0.428c1.184,1.184,1.184,3.111,0,4.294l-2.836,2.836c-0.573,0.573-1.336,0.889-2.147,0.889s-1.574-0.316-2.147-0.889
		L8.352,9.219C8.296,9.164,8.244,9.106,8.194,9.047c-0.32-0.248-0.71-0.384-1.121-0.384c-0.162,0-0.321,0.023-0.473,0.063
		c0.206,0.488,0.507,0.945,0.905,1.342l0.428,0.428c0.827,0.827,1.911,1.241,2.996,1.241s2.168-0.414,2.996-1.241l2.836-2.836
		C18.414,6.006,18.414,3.324,16.759,1.669z"/>
</g>
</symbol><symbol id="LinkActive" viewBox="0 0 18 18">
<g id="link_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.006,12.585l-2.759,2.759C5.824,15.768,5.262,16,4.665,16c-0.597,0-1.159-0.232-1.581-0.655l-0.428-0.428
		C2.233,14.494,2,13.933,2,13.335c0-0.597,0.233-1.159,0.655-1.582L5.659,8.75c0.453-0.406,1.316-1.03,2.678-0.701
		c0,0,0.595,0.12,1.095,0.446c0.592,0.386,1.348,0.548,1.92,0.21c-0.187-0.335-0.404-0.657-0.688-0.941l-0.428-0.428
		C9.409,6.508,8.324,6.095,7.24,6.095S5.072,6.508,4.245,7.336l-3.004,3.003c-1.655,1.654-1.655,4.337,0,5.992l0.428,0.428
		C2.496,17.586,3.581,18,4.665,18c1.084,0,2.169-0.414,2.996-1.241l3.004-3.004c0.274-0.274,0.486-0.583,0.669-0.905
		c-0.191,0.021-0.379,0.055-0.574,0.055C10.15,12.905,9.563,12.784,9.006,12.585z M16.759,1.669l-0.428-0.428
		C15.504,0.414,14.419,0,13.335,0c-1.084,0-2.169,0.414-2.996,1.241L7.336,4.245C7.061,4.519,6.85,4.828,6.666,5.15
		C6.857,5.128,7.045,5.095,7.24,5.095c0.609,0,1.196,0.122,1.754,0.32l2.759-2.759C12.176,2.232,12.738,2,13.335,2
		c0.597,0,1.159,0.232,1.581,0.655l0.428,0.428C15.767,3.506,16,4.067,16,4.665c0,0.597-0.233,1.159-0.655,1.582L12.341,9.25
		c-0.453,0.406-1.316,1.03-2.678,0.701c0,0-0.595-0.12-1.095-0.446c-0.592-0.386-1.348-0.548-1.92-0.21
		c0.187,0.335,0.404,0.657,0.688,0.941l0.428,0.428c0.827,0.828,1.912,1.241,2.996,1.241s2.168-0.414,2.996-1.241l3.004-3.003
		C18.414,6.006,18.414,3.324,16.759,1.669z"/>
</g>
</symbol><symbol id="LiquidityManagement" viewBox="0 0 18 18">
<g id="liquidity_x5F_management_1_">
	<path id="liquidity_x5F_management" d="M13.8,9V0H8.4v9h-3V5H0v13h18V9H13.8z M9.6,1.199h3v15.602h-3V1.199z M8.4,10.199v6.602h-3
		v-6.602H8.4z M1.2,6.199h3v10.602h-3V6.199z M16.8,16.801h-3v-6.602h3V16.801z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="LiquidityManagementActive" viewBox="0 0 18 18">
<g id="liquidity_x5F_management_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="4.95" y="9" width="3.3" height="9"/>
		<rect x="14.55" y="9" width="3.45" height="9"/>
		<rect y="5" width="3.45" height="13"/>
		<rect x="9.75" width="3.3" height="18"/>
	</g>
</g>
</symbol><symbol id="Location" viewBox="0 0 18 18">
<g id="location">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.232,2.184C12.788,0.728,10.894,0,9,0S5.212,0.728,3.767,2.184c-2.89,2.912-2.89,7.633,0,10.544L9,18l5.232-5.272
		C17.122,9.816,17.122,5.095,14.232,2.184z M13.381,11.883L9,16.297l-4.381-4.414c-2.423-2.441-2.423-6.413,0-8.854
		C5.79,1.849,7.345,1.2,9,1.2c1.654,0,3.21,0.649,4.381,1.829C15.803,5.47,15.803,9.442,13.381,11.883z M9,3.4
		c-2.261,0-4.1,1.839-4.1,4.1s1.839,4.1,4.1,4.1s4.1-1.839,4.1-4.1S11.261,3.4,9,3.4z M9,10.4c-1.599,0-2.9-1.302-2.9-2.9
		S7.401,4.6,9,4.6s2.9,1.302,2.9,2.9S10.599,10.4,9,10.4z"/>
</g>
</symbol><symbol id="LocationActive" viewBox="0 0 18 18">
<g id="location_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<circle cx="9" cy="7.5" r="2.75"/>
		<path d="M14.233,2.184C12.788,0.728,10.894,0,9,0S5.212,0.728,3.767,2.184c-2.89,2.912-2.89,7.633,0,10.544L9,18l5.233-5.272
			C17.123,9.816,17.123,5.095,14.233,2.184z M9,11.75c-2.343,0-4.25-1.906-4.25-4.25S6.657,3.25,9,3.25s4.25,1.906,4.25,4.25
			S11.343,11.75,9,11.75z"/>
	</g>
</g>
</symbol><symbol id="Memo" viewBox="0 0 18 18">
<g id="memo">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<path d="M14.149,2C14.172,2.165,14.2,2.329,14.2,2.5c0,0.24-0.027,0.473-0.071,0.7H15.8V13H12v3.8H2.2V3.2h4.671
		C6.827,2.973,6.8,2.74,6.8,2.5c0-0.171,0.028-0.335,0.051-0.5H1v16h11v0h1.2v0l3.8-3.8V2H14.149z M13.2,16.303V14.2h2.103
		L13.2,16.303z M6.576,5.576l0.849,0.848l1.79-1.79C9.591,4.861,10.028,5,10.5,5C11.881,5,13,3.881,13,2.5S11.881,0,10.5,0
		S8,1.119,8,2.5c0,0.472,0.139,0.909,0.366,1.285L6.576,5.576z M10.5,1.2c0.717,0,1.3,0.583,1.3,1.3s-0.583,1.3-1.3,1.3
		S9.2,3.217,9.2,2.5S9.783,1.2,10.5,1.2z"/>
</g>
</symbol><symbol id="Menu" viewBox="0 0 18 18">
<g id="menu">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1,17h16v-1.2H1V17z M1,1v1.2h16V1H1z M1,9.6h16V8.4H1V9.6z"/>
</g>
</symbol><symbol id="MenuActive" viewBox="0 0 18 18">
<g id="menu_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1,17h16v-2H1V17z M1,1v2h16V1H1z M1,10h16V8H1V10z"/>
</g>
</symbol><symbol id="MenuMoreHorizontal" viewBox="0 0 18 18">
<g id="menu_x5F_more_x5F_horizontal">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1.5,7.5C0.672,7.5,0,8.172,0,9s0.672,1.5,1.5,1.5S3,9.829,3,9S2.328,7.5,1.5,7.5z M16.5,7.5C15.672,7.5,15,8.172,15,9
		s0.672,1.5,1.5,1.5S18,9.829,18,9S17.328,7.5,16.5,7.5z M9,7.5C8.172,7.5,7.5,8.172,7.5,9s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5
		S9.828,7.5,9,7.5z"/>
</g>
</symbol><symbol id="MenuMoreHorizontalActive" viewBox="0 0 18 18">
<g id="menu_x5F_more_x5F_horizontal_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M2,7C0.896,7,0,7.896,0,9s0.896,2,2,2s2-0.896,2-2S3.104,7,2,7z M16,7c-1.104,0-2,0.896-2,2s0.896,2,2,2s2-0.896,2-2
		S17.104,7,16,7z M9,7C7.896,7,7,7.896,7,9s0.896,2,2,2s2-0.896,2-2S10.104,7,9,7z"/>
</g>
</symbol><symbol id="MenuMoreVertical" viewBox="0 0 18 18">
<g id="menu_x5F_more_x5F_vertical">
	
		<rect y="0" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 18 1.091571e-11)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,3c0.828,0,1.5-0.672,1.5-1.5S9.828,0,9,0C8.171,0,7.5,0.672,7.5,1.5S8.171,3,9,3z M9,15c-0.829,0-1.5,0.672-1.5,1.5
		S8.171,18,9,18c0.828,0,1.5-0.672,1.5-1.5S9.828,15,9,15z M9,7.5C8.171,7.5,7.5,8.172,7.5,9s0.671,1.5,1.5,1.5
		c0.828,0,1.5-0.672,1.5-1.5S9.828,7.5,9,7.5z"/>
</g>
</symbol><symbol id="MenuMoreVerticalActive" viewBox="0 0 18 18">
<g id="menu_x5F_more_x5F_vertical_x5F_active">
	
		<rect y="0" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 18 1.091571e-11)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,4c1.104,0,2-0.896,2-2s-0.896-2-2-2C7.895,0,7,0.896,7,2S7.895,4,9,4z M9,14c-1.105,0-2,0.896-2,2s0.895,2,2,2
		c1.104,0,2-0.896,2-2S10.104,14,9,14z M9,7C7.895,7,7,7.896,7,9s0.895,2,2,2c1.104,0,2-0.896,2-2S10.104,7,9,7z"/>
</g>
</symbol><symbol id="MyECoupons" viewBox="0 0 18 18"><g id="myECoupons"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path id="_Compound_Path_" data-name="&lt;Compound Path&gt;" class="cls-2" d="M18,6v4.5a1.5,1.5,0,0,0,0,3V18H0V13.5a1.5,1.5,0,0,0,0-3V6ZM8.4,7.2H1.2V9.58l.07,0a2.7,2.7,0,0,1,1.42,2.21V12a2.69,2.69,0,0,1-1.43,2.38l-.07,0V16.8H8.4v-1A2,2,0,0,1,6.45,14V13.8l1.2,0c0,.22,0,.87,1.3.87.33,0,1.42-.07,1.42-1,0-.47-.26-.69-1.22-1h0l-.64-.21c-.72-.22-2.06-.64-2.06-2.13a2.15,2.15,0,0,1,2-2.12h0Zm8.4,0H9.6v1a2,2,0,0,1,2,1.84v.17l-1.2,0c0-.22,0-.87-1.3-.87-.33,0-1.42.07-1.42,1,0,.47.26.69,1.22,1h0l.63.21c.73.22,2.07.64,2.07,2.13a2.15,2.15,0,0,1-2,2.12h0v1h7.2V14.42l-.07,0a2.7,2.7,0,0,1-1.42-2.21V12a2.69,2.69,0,0,1,1.43-2.38l.07,0Zm-14-2.4H6l8-3.24.89,2.21.41,1h1.3l-.25-.63L14.69,0Z"/></g></symbol><symbol id="MyECouponsActive" viewBox="0 0 18 18"><g id="myECoupons_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M18,6v4.5a1.5,1.5,0,0,0,0,3V18H0V13.5a1.5,1.5,0,0,0,0-3V6ZM9.75,7.2H8.25v.9a2.26,2.26,0,0,0-2,2.24c0,1.6,1.46,2.06,2.16,2.27h0l.64.21c.95.29,1.12.48,1.12.84,0,.76-.89.84-1.27.84-1.14,0-1.15-.52-1.15-.72h0l-1.5,0a2.14,2.14,0,0,0,2,2.14h0v.86h1.5v-.9a2.27,2.27,0,0,0,2-2.24c0-1.6-1.46-2.06-2.16-2.27h0l-.65-.21c-.94-.29-1.11-.48-1.11-.84,0-.76.89-.84,1.27-.84,1.14,0,1.14.52,1.15.72h0l1.5,0a2.15,2.15,0,0,0-2-2.14h0ZM2.81,4.8H16.63l-.25-.63L14.69,0Z"/></g></symbol><symbol id="Newspaper" viewBox="0 0 18 18">
<g id="newspaper">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M1,0v18h16V0H1z M15.8,16.8H2.2V1.2h13.6V16.8z M8,8.4H4v1.2h4V8.4z M8,13.8H4V15h4V13.8z M8,11.1H4v1.2h4V11.1z M10,15h4
		V8.4h-4V15z M11.2,9.6h1.6v4.2h-1.6V9.6z M14,3H4v1.2h10V3z M14,5.7H4v1.2h10V5.7z"/>
</g>
</symbol><symbol id="NewModal" viewBox="0 0 18 18">
<g id="new_x5F_modal">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M11.8,15.8H2.2V6.2h2.6V5H1v12h12v-3.8h-1.2V15.8z M15.8,10.8H7.2V2.2H10V1H6v11h11V8h-1.2V10.8z M11.46,7.388L15.8,3.048
		l0,3.808l1.2-1.2L17,1h-4.657l-1.199,1.199h3.809L10.612,6.54L11.46,7.388z"/>
</g>
</symbol><symbol id="NewWindow" viewBox="0 0 18 18">
<g id="new_x5F_window">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.8,15.8H2.2V2.2H9V1H1v16h16V9h-1.2V15.8z M10.46,8.388L15.8,3.048l0,4.808l1.2-1.2L17,1h-5.657l-1.199,1.199h4.809
		L9.612,7.54L10.46,8.388z"/>
</g>
</symbol><symbol id="OnlineBanking" viewBox="0 0 18 18">
<g id="online_x5F_banking_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17,13.5v-11c0-1.105-0.896-2-2-2H3c-1.104,0-2,0.895-2,2v11H0v2c0,1.105,0.896,2,2,2h14c1.104,0,2-0.895,2-2v-2H17z
		 M2.2,2.5c0-0.441,0.359-0.8,0.8-0.8h12c0.441,0,0.8,0.359,0.8,0.8v11H2.2V2.5z M16.8,15.5c0,0.441-0.359,0.8-0.8,0.8H2
		c-0.441,0-0.8-0.359-0.8-0.8v-0.8h15.6V15.5z M7,4.5v4.639l1.031-0.516l1,1.998l1.649-0.826l-1-1.997l1.031-0.516L7,4.5z"/>
</g>
</symbol><symbol id="Payment" viewBox="0 0 18 18">
<g id="payment">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		c4.301,0,7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M5,8.152v1.696l3.4-3.399V14h1.2V6.449L13,9.848V8.152l-4-4L5,8.152z"/>
</g>
</symbol><symbol id="PaymentsAndTransfers" viewBox="0 0 18 18">
<g id="payments_x5F_and_x5F_transfers">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		c4.301,0,7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M9.064,6.352c1.283,0,1.292,0.651,1.295,0.866l1.2-0.018
		C11.544,6.092,10.807,5.353,9.6,5.188V4H8.4v1.216C7.207,5.431,6.44,6.226,6.44,7.337c0,1.494,1.342,1.91,2.059,2.133l0.641,0.205
		c0.957,0.297,1.219,0.51,1.219,0.988c0,0.914-1.089,0.985-1.423,0.985c-1.283,0-1.292-0.651-1.295-0.866L6.44,10.8
		c0.016,1.108,0.753,1.847,1.959,2.012V14h1.2v-1.216c1.193-0.215,1.959-1.01,1.959-2.121c0-1.494-1.342-1.91-2.063-2.135
		L8.859,8.325c-0.957-0.297-1.219-0.51-1.219-0.988C7.641,6.423,8.73,6.352,9.064,6.352z"/>
</g>
</symbol><symbol id="PaymentsAndTransfersActive" viewBox="0 0 18 18">
<g id="payments_x5F_and_x5F_transfers_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M8.776,8.141l0.891,0.286l0-0.001
		c0.988,0.307,2.826,0.877,2.826,2.902c0,1.532-1.074,2.625-2.744,2.899V16h-1.5v-1.746c-1.685-0.207-2.721-1.213-2.744-2.736
		l1.5-0.021c0.012,0.863,0.653,1.302,1.904,1.302c0.489,0,2.083-0.106,2.083-1.47c0-0.714-0.397-1.043-1.77-1.469L9.217,9.857
		L8.326,9.571C7.344,9.268,5.506,8.697,5.506,6.672c0-1.532,1.074-2.625,2.744-2.899V2h1.5v1.746
		c1.685,0.207,2.721,1.213,2.744,2.736l-1.5,0.021c-0.012-0.863-0.653-1.302-1.904-1.302c-0.489,0-2.083,0.106-2.083,1.47
		C7.006,7.386,7.403,7.715,8.776,8.141z"/>
</g>
</symbol><symbol id="PaymentActive" viewBox="0 0 18 18">
<g id="payment_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M13,10l-0.03,0.03l-3.22-3.22V14h-1.5
		V6.811l-3.22,3.22L5,10V7.939l4-4l4,4V10z"/>
</g>
</symbol><symbol id="PaymentByAlias" viewBox="0 0 18 18">
<g id="payment_x5F_by_x5F_alias">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M8,0H1v7h7V0z M6.8,5.8H2.2V1.2h4.6V5.8z M11,0v7h7V0H11z M16.8,5.8h-4.6V1.2h4.6V5.8z M11,17h7v-7h-7V17z M12.2,11.2h4.6
		v4.6h-4.6V11.2z M5,8c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S7.761,8,5,8z M5,16.8c-2.095,0-3.8-1.705-3.8-3.8
		S2.905,9.2,5,9.2s3.8,1.705,3.8,3.8S7.095,16.8,5,16.8z M2.5,12.652v1.697l1.9-1.9V15.6h1.2v-3.151l1.9,1.9v-1.697L5,10.151
		L2.5,12.652z"/>
</g>
</symbol><symbol id="PaymentByAliasActive" viewBox="0 0 18 18">
<g id="payment_x5F_by_x5F_alias_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M8,0H1v7h7V0z M11,0v7h7V0H11z M11,17h7v-7h-7V17z M5,8c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S7.761,8,5,8z
			 M7.5,14.061l-1.75-1.75v3.79h-1.5v-3.79l-1.75,1.75V11.94l2.5-2.5l2.5,2.5V14.061z"/>
	</g>
</g>
</symbol><symbol id="PaymentDirectDebit" viewBox="0 0 18 18">
<g id="payment_x5F_direct_x5F_debit">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,2C4.029,2,0,5.134,0,9c0,3.866,4.029,7,9,7s9-3.134,9-7C18,5.134,13.971,2,9,2z M11.855,14.405
		c-1.8,0.425-4.113,0.349-5.652-0.023C4.227,13.904,1.978,12.86,2,10.581c0.022-2.236,2.718-3.888,8.034-3.888v-4
		C12.642,2.693,16,5.346,16,9C16,12.273,13.842,13.936,11.855,14.405z M5.285,10.914c0,1.799,2.089,3.258,4.665,3.258V7.656
		C7.374,7.656,5.285,9.115,5.285,10.914z"/>
</g>
</symbol><symbol id="PaymentInternational" viewBox="0 0 18 18">
<g id="payment_x5F_international">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.971,4.029,9,9,9s9-4.029,9-9C18,4.029,13.971,0,9,0z M16.77,8.4h-2.8
		c-0.136-2.854-1.214-5.345-2.821-6.892C14.222,2.391,16.518,5.111,16.77,8.4z M8.4,1.779V8.4H5.234
		C5.387,5.451,6.637,2.956,8.4,1.779z M9.6,1.779c1.763,1.177,3.013,3.672,3.166,6.622H9.6V1.779z M6.851,1.508
		C5.244,3.055,4.166,5.546,4.03,8.4h-2.8C1.482,5.111,3.778,2.391,6.851,1.508z M9.6,16.77v-4.321l2.4,2.4v-1.696l-3-3l-3,3v1.696
		l2.4-2.4v4.321c-3.822-0.293-6.877-3.348-7.17-7.17H16.77C16.477,13.422,13.422,16.476,9.6,16.77z"/>
</g>
</symbol><symbol id="PaymentInternationalActive" viewBox="0 0 18 18">
<g id="payment_x5F_international_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M8.25,8.25V1.344C6.346,2.562,4.989,5.164,4.794,8.25H8.25z"/>
		<path d="M14.726,8.25h3.237c-0.336-4.058-3.359-7.349-7.289-8.088C12.93,1.688,14.526,4.71,14.726,8.25z"/>
		<path d="M9.75,1.344V8.25h3.456C13.011,5.164,11.654,2.562,9.75,1.344z"/>
		<path d="M0.038,9.75c0.362,4.371,3.841,7.851,8.212,8.212v-5.151l-2.22,2.22L6,15v-2.061l3-3l3,3V15l-0.03,0.03l-2.22-2.22v5.151
			c4.371-0.361,7.851-3.841,8.212-8.212H0.038z"/>
		<path d="M3.274,8.25c0.2-3.54,1.796-6.562,4.052-8.088c-3.93,0.74-6.953,4.03-7.289,8.088H3.274z"/>
	</g>
</g>
</symbol><symbol id="PaymentPerson" viewBox="0 0 18 18">
<g id="payment_x5F_person">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M13.396,4.011C13.396,1.574,12.064,0,10.004,0c-2.07,0-3.408,1.574-3.408,4.011c0,2.085,1.054,4.188,3.408,4.188
		C12.334,8.199,13.396,6.028,13.396,4.011z M10.004,7c-1.63,0-2.208-1.61-2.208-2.989c0-0.659,0.159-2.812,2.208-2.812
		c2.034,0,2.192,2.152,2.192,2.812C12.196,5.121,11.734,7,10.004,7z M10.422,16h7.464l-1.74-4.306v-0.001
		c-0.19-0.47-0.454-0.88-0.784-1.221c-0.549-0.565-1.212-1.031-1.97-1.385l-0.375-0.175l-0.297,0.289
		c-0.604,0.589-1.34,0.923-2.182,1.025c0.184,0.366,0.332,0.752,0.441,1.154c0.838-0.151,1.603-0.495,2.255-1.03
		c0.48,0.264,0.906,0.584,1.268,0.956c0.221,0.229,0.4,0.51,0.533,0.836l1.073,2.657h-5.175C10.803,15.221,10.632,15.622,10.422,16z
		 M2.5,12.652v1.697l1.9-1.9V15.6h1.2v-3.151l1.9,1.9v-1.697L5,10.151L2.5,12.652z M5,8c-2.761,0-5,2.239-5,5s2.239,5,5,5
		s5-2.239,5-5S7.761,8,5,8z M5,16.8c-2.095,0-3.8-1.705-3.8-3.8S2.905,9.2,5,9.2s3.8,1.705,3.8,3.8S7.095,16.8,5,16.8z"/>
</g>
</symbol><symbol id="PaymentPersonActive" viewBox="0 0 18 18">
<g id="payment_x5F_person_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M17.886,16l-1.74-4.306v-0.001c-0.19-0.47-0.454-0.88-0.784-1.221c-0.549-0.565-1.212-1.031-1.97-1.385l-0.375-0.175
		l-0.297,0.289c-0.529,0.516-1.157,0.841-1.869,0.984c0.412,0.853,0.65,1.805,0.65,2.814c0,1.082-0.27,2.102-0.74,3H17.886z
		 M13.396,4.011C13.396,1.574,12.064,0,10.004,0c-2.07,0-3.408,1.574-3.408,4.011c0,2.085,1.054,4.188,3.408,4.188
		C12.334,8.199,13.396,6.028,13.396,4.011z M5,8c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5S7.761,8,5,8z M7.5,14.561l-1.75-1.75
		v2.79h-1.5v-2.79l-1.75,1.75V12.44l2.5-2.5l2.5,2.5V14.561z"/>
</g>
</symbol><symbol id="PaymentScheduled" viewBox="0 0 18 18">
<g id="payment_x5F_scheduled">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,16.8c-4.301,0-7.8-3.499-7.8-7.8c0-4.301,3.499-7.8,7.8-7.8V0C4.029,0,0,4.029,0,9c0,4.971,4.029,9,9,9s9-4.029,9-9
		h-1.2C16.8,13.301,13.301,16.8,9,16.8z M12,2c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1C11,1.552,11.448,2,12,2z
		 M16,6.372c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1S16,5.82,16,6.372z M15.4,3.8c0.552,0,1-0.448,1-1s-0.448-1-1-1
		c-0.552,0-1,0.448-1,1S14.848,3.8,15.4,3.8z M9.6,14V6.449L13,9.848V8.152l-4-4l-4,4v1.696l3.4-3.399V14H9.6z"/>
</g>
</symbol><symbol id="PaymentScheduledActive" viewBox="0 0 18 18">
<g id="payment_x5F_scheduled_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2V0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9h-1.2
		C16.8,13.301,13.301,16.8,9,16.8z M12,2c0.552,0,1-0.448,1-1s-0.448-1-1-1s-1,0.448-1,1S11.448,2,12,2z M16,6.372
		c0,0.552,0.448,1,1,1s1-0.448,1-1s-0.448-1-1-1S16,5.819,16,6.372z M15.4,3.8c0.552,0,1-0.447,1-1c0-0.552-0.448-1-1-1
		c-0.552,0-1,0.448-1,1C14.4,3.353,14.848,3.8,15.4,3.8z M2.5,9c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5S12.59,2.5,9,2.5
		S2.5,5.41,2.5,9z M13,10l-0.03,0.03l-3.22-3.22V14h-1.5V6.811l-3.22,3.22L5,10V7.939l4-4l4,4V10z"/>
</g>
</symbol><symbol id="PersonalFinanceManagement" viewBox="0 0 18 18">
<g id="personal_x5F_finance_x5F_management">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.2,0L14.2,0H0v18h18V3.8L14.2,0z M16.303,3.8H14.2V1.697L16.303,3.8z M5.6,11.066h2.8v2.268H5.6V11.066z M4.4,13.334
		H1.2v-2.268h3.2V13.334z M8.4,14.533V16.8H5.6v-2.267H8.4z M9.6,14.533h2.8V16.8H9.6V14.533z M9.6,13.334v-2.268h2.8v2.268H9.6z
		 M13.6,11.066h3.2v2.268h-3.2V11.066z M13.6,9.867V7.6h3.2v2.268H13.6z M12.4,9.867H9.6V7.6h2.8V9.867z M8.4,9.867H5.6V7.6h2.8
		V9.867z M4.4,9.867H1.2V7.6h3.2V9.867z M1.2,14.533h3.2V16.8H1.2V14.533z M13.6,16.8v-2.267h3.2V16.8H13.6z M16.8,6.4H1.2V1.2H13V5
		h3.8V6.4z"/>
</g>
</symbol><symbol id="PersonalFinanceManagementActive" viewBox="0 0 18 18">
<g id="personal_x5F_finance_x5F_management_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="9.75" y="11.833" width="3.375" height="2.333"/>
		<rect x="9.75" y="15.667" width="3.375" height="2.333"/>
		<rect x="4.875" y="11.833" width="3.375" height="2.333"/>
		<rect x="4.875" y="8" width="3.375" height="2.333"/>
		<rect x="9.75" y="8" width="3.375" height="2.333"/>
		<polygon points="14.5,0.3 14.5,3.5 17.7,3.5 		"/>
		<rect y="8" width="3.375" height="2.333"/>
		<rect x="14.625" y="15.667" width="3.375" height="2.333"/>
		<rect x="14.625" y="11.833" width="3.375" height="2.333"/>
		<rect x="14.625" y="8" width="3.375" height="2.333"/>
		<rect x="4.875" y="15.667" width="3.375" height="2.333"/>
		<polygon points="13,0 0,0 0,6.5 18,6.5 18,5 13,5 		"/>
		<rect y="15.667" width="3.375" height="2.333"/>
		<rect y="11.833" width="3.375" height="2.333"/>
	</g>
</g>
</symbol><symbol id="Portfolio" viewBox="0 0 18 18">
<g id="portfolio_2_">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M16.471,6.5H5.109c-0.815,0-1.549,0.495-1.854,1.251L1.2,12.835V5c0-0.163,0.137-0.3,0.3-0.3h12c0.163,0,0.3,0.137,0.3,0.3
		v0.3H15V5c0-0.825-0.675-1.5-1.5-1.5H11V2c0-0.828-0.672-1.5-1.5-1.5h-4C4.672,0.5,4,1.172,4,2v1.5H1.5C0.675,3.5,0,4.175,0,5
		l0.01,11.16c0.042,0.717,0.626,1.34,1.413,1.34h11.868c0.58,0,1.101-0.352,1.318-0.889l3.252-8.049
		C18.26,7.576,17.534,6.5,16.471,6.5z M5.2,2c0-0.165,0.135-0.3,0.3-0.3h4c0.165,0,0.3,0.135,0.3,0.3v1.5H5.2V2z M16.749,8.112
		l-3.252,8.049c-0.034,0.084-0.115,0.139-0.206,0.139H1.423c-0.097,0-0.154-0.053-0.184-0.098c-0.044-0.065-0.051-0.134-0.022-0.207
		L4.367,8.2C4.49,7.896,4.781,7.7,5.109,7.7h11.362c0.132,0,0.208,0.072,0.249,0.132C16.76,7.893,16.798,7.99,16.749,8.112z"/>
</g>
</symbol><symbol id="PortfolioActive" viewBox="0 0 18 18">
<g id="portfolio_x5F_active">
	<rect x="0" style="fill:none;" width="18" height="18"/>
	<path d="M16.471,6.5H5.783C4.56,6.5,3.46,7.242,3.002,8.376L1.2,12.835V8.832l0.664-1.644C1.931,7.022,2.01,6.863,2.097,6.717
		c0.089-0.15,0.189-0.294,0.297-0.426C2.502,6.158,2.621,6.032,2.75,5.914c0.318-0.29,0.682-0.516,1.077-0.671
		c0.157-0.062,0.324-0.114,0.499-0.154C4.583,5.03,4.846,5,5.109,5H15c0-0.825-0.675-1.5-1.5-1.5H11V2c0-0.828-0.672-1.5-1.5-1.5h-4
		C4.672,0.5,4,1.172,4,2v1.5H1.5C0.675,3.5,0,4.175,0,5v1.5h0v9.666l0.01-0.005c0.042,0.717,0.626,1.34,1.413,1.34h11.868
		c0.58,0,1.101-0.352,1.318-0.889l3.252-8.049C18.26,7.576,17.534,6.5,16.471,6.5z M5.2,2c0-0.166,0.135-0.3,0.3-0.3h4
		c0.165,0,0.3,0.134,0.3,0.3v1.5H5.2V2z"/>
</g>
</symbol><symbol id="PositionDown" viewBox="0 0 18 9">
<g id="position_x5F_down">
	<polygon points="0,0 9,8.999 18,0 	"/>
	<rect y="0" style="fill:none;" width="18" height="9"/>
</g>
</symbol><symbol id="PositionUp" viewBox="0 0 18 9">
<g id="position_x5F_up">
	<polygon points="18,9 9,0.001 0,9 	"/>
	<rect style="fill:none;" width="18" height="9"/>
</g>
</symbol><symbol id="Presentation" viewBox="0 0 18 18">
<g id="presentation_1_">
	<rect y="0" style="fill:none;" width="18" height="18"/>
	<rect y="0" style="opacity:0.3;fill:none;" width="18" height="18"/>
	<path d="M18,1H9.6V0H8.4v1H0v13h8.151l-4,4h1.696L8.4,15.449V18h1.2v-2.551L12.152,18h1.696l-4-4H18V1z M16.8,12.8H1.2V2.2h15.6
		V12.8z M4,6.5c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1C3,6.052,3.448,6.5,4,6.5z M4,10.5c0.552,0,1-0.448,1-1
		c0-0.552-0.448-1-1-1s-1,0.448-1,1C3,10.052,3.448,10.5,4,10.5z M15,5H7v1h8V5z M15,9H7v1h8V9z"/>
</g>
</symbol><symbol id="Print" viewBox="0 0 18 18">
<g id="print">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M18,8c0-1.104-0.896-2-2-2h-1V0H3v6H2C0.895,6,0,6.896,0,8v8h3v2h12v-2h3V8z M4.2,1.2h9.6V6H4.2V1.2z M13.8,16.8H4.2v-4.6
		h9.6V16.8z M16.8,14.8H15V11H3v3.8H1.2V8c0-0.441,0.359-0.8,0.8-0.8h14c0.441,0,0.8,0.359,0.8,0.8V14.8z"/>
</g>
</symbol><symbol id="PrintActive" viewBox="0 0 18 18">
<g id="print_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16,6H2C0.896,6,0,6.896,0,8v8h3v-5h12v5h3V8C18,6.896,17.104,6,16,6z M15,0H3v4.5h12V0z M4.5,18h9v-5.5h-9V18z"/>
</g>
</symbol><symbol id="ProductsAndServices" viewBox="0 0 18 18">
<g id="products_x5F_and_x5F_services">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.2,0L14.2,0H6v5.8h1.2V1.2H13V5h3.8v7.8h-0.6V14H18V3.8L14.2,0z M14.2,3.8V1.697L16.303,3.8H14.2z M13.5,7h-12
		C0.675,7,0,7.675,0,8.5v8C0,17.325,0.675,18,1.5,18h12c0.825,0,1.5-0.675,1.5-1.5v-8C15,7.675,14.325,7,13.5,7z M13.8,16.5
		c0,0.163-0.137,0.3-0.3,0.3h-12c-0.163,0-0.3-0.137-0.3-0.3v-5.3h12.6V16.5z M13.8,10H1.2V8.5c0-0.163,0.137-0.3,0.3-0.3h12
		c0.163,0,0.3,0.137,0.3,0.3V10z M12,12.8H9V14h3V12.8z"/>
</g>
</symbol><symbol id="ProductsAndServicesActive" viewBox="0 0 18 18">
<g id="products_x5F_and_x5F_services_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.5,0.3v3.2h3.2L14.5,0.3z M13,5V0H6v5.5h8c1.378,0,2.5,1.122,2.5,2.5v6H18V5H13z M14,7H1C0.45,7,0,7.45,0,8v2h15V8
		C15,7.45,14.55,7,14,7z M0,17c0,0.55,0.45,1,1,1h13c0.55,0,1-0.45,1-1v-5.5H0V17z M10,13h3v1.5h-3V13z"/>
</g>
</symbol><symbol id="QrCode" viewBox="0 0 18 18">
<g id="qr_x5F_code">
	<path d="M0,8h8V0H0V8z M1.2,1.2h5.6v5.6H1.2V1.2z M3,5h2V3H3V5z M10,0v2h2V0H10z M14,2h-2v2h2V2z M12,4h-2v4h4V6h-2V4z M14,4v2h2V4
		H14z M18,8V6h-2v2H18z M18,0h-2v4h2V0z M0,18h8v-8H0V18z M1.2,11.2h5.6v5.6H1.2V11.2z M3,15h2v-2H3V15z M10,18h8v-8h-8V18z
		 M11.2,11.2h5.6v5.6h-5.6V11.2z M13,15h2v-2h-2V15z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="QrCodeActive" viewBox="0 0 18 18">
<g id="qr_x5F_code_x5F_active">
	<g>
		<rect x="11.5" y="5" width="1.5" height="1.5"/>
		<path d="M6.8,11.2H3.2v3.6h3.6V11.2z M5.6,13.6H4.4v-1.2h1.2V13.6z"/>
		<path d="M6.8,3.2H3.2v3.6h3.6V3.2z M5.6,5.6H4.4V4.4h1.2V5.6z"/>
		<path d="M14.8,11.2h-3.6v3.6h3.6V11.2z M13.6,13.6h-1.2v-1.2h1.2V13.6z"/>
		<path d="M0,0v18h18V0H0z M8,16H2v-6h6V16z M8,8H2V2h6V8z M16,16h-6v-6h6V16z M16,5h-1.5v1.5H16V8h-1.5V6.5H13V8h-3V5h1.5V3.5H10V2
			h1.5v1.5H13V5h1.5V2H16V5z"/>
	</g>
	<rect style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="QrScanner" viewBox="0 0 18 18">
<g id="qr_x5F_scanner">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1.2,16v-4H0v4c0,1.1,0.9,2,2,2h4v-1.2H2C1.566,16.8,1.2,16.434,1.2,16z M1.2,2c0-0.434,0.366-0.8,0.8-0.8h4V0H2
		C0.9,0,0,0.9,0,2v4h1.2V2z M16.8,16c0,0.434-0.366,0.8-0.8,0.8h-4V18h4c1.1,0,2-0.9,2-2v-4h-1.2V16z M16,0h-4v1.2h4
		c0.434,0,0.8,0.366,0.8,0.8v4H18V2C18,0.9,17.1,0,16,0z M0,9.2h18V8H0V9.2z"/>
</g>
</symbol><symbol id="QrScannerActive" viewBox="0 0 18 18">
<g id="qr_x5F_scanner_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M2,2h4V0H2C0.9,0,0,0.9,0,2v4h2V2z M2,12H0v4c0,1.1,0.9,2,2,2h4v-2H2V12z M16,0h-4v2h4v4h2V2C18,0.9,17.1,0,16,0z M16,16
		h-4v2h4c1.1,0,2-0.9,2-2v-4h-2V16z M0,10h18V8H0V10z"/>
</g>
</symbol><symbol id="Rates" viewBox="0 0 18 18">
<g id="rates">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14,11.001c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3C17,12.344,15.657,11.001,14,11.001z M14,15.8
		c-0.993,0-1.8-0.807-1.8-1.8c0-0.992,0.807-1.8,1.8-1.8s1.8,0.807,1.8,1.8C15.8,14.993,14.993,15.8,14,15.8z M4,6.999
		c1.657,0,3-1.343,3-3S5.657,1,4,1S1,2.343,1,4S2.343,6.999,4,6.999z M4,2.2c0.993,0,1.8,0.807,1.8,1.8s-0.807,1.8-1.8,1.8
		S2.2,4.992,2.2,4S3.007,2.2,4,2.2z M15.576,1.577l-14,13.998l0.849,0.848l14-13.998L15.576,1.577z"/>
</g>
</symbol><symbol id="RatesActive" viewBox="0 0 18 18">
<g id="rates_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M4.5,7.999C6.43,7.999,8,6.43,8,4.5S6.43,1,4.5,1S1,2.57,1,4.5S2.57,7.999,4.5,7.999z M4.5,3C5.327,3,6,3.673,6,4.5
		c0,0.826-0.673,1.499-1.5,1.499S3,5.326,3,4.5C3,3.673,3.673,3,4.5,3z M13.5,10.001c-1.93,0-3.5,1.569-3.5,3.499s1.57,3.5,3.5,3.5
		s3.5-1.57,3.5-3.5S15.43,10.001,13.5,10.001z M13.5,15c-0.827,0-1.5-0.673-1.5-1.5c0-0.826,0.673-1.499,1.5-1.499
		S15,12.674,15,13.5C15,14.327,14.327,15,13.5,15z M15.293,1.294l-14,13.998l1.414,1.414l14-13.998L15.293,1.294z"/>
</g>
</symbol><symbol id="Refresh" viewBox="0 0 18 18">
<g id="refresh">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M12.2,7H18V1.2L16.8,0v4.536C15.25,1.829,12.343,0,9,0C4.03,0,0,4.029,0,9s4.03,9,9,9s9-4.029,9-9h-1.2
		c0,4.301-3.499,7.8-7.8,7.8S1.2,13.301,1.2,9S4.699,1.2,9,1.2c3.16,0,5.88,1.892,7.103,4.6H11L12.2,7z"/>
</g>
</symbol><symbol id="Renew" viewBox="0 0 18 18">
<g id="renew">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,16.8c-3.16,0-5.88-1.892-7.103-4.6H7L5.8,11H0v5.8L1.2,18v-4.536C2.75,16.171,5.657,18,9,18c4.971,0,9-4.029,9-9h-1.2
		C16.8,13.301,13.301,16.8,9,16.8z M16.8,0v4.536C15.25,1.829,12.343,0,9,0C4.03,0,0,4.029,0,9h1.2c0-4.301,3.499-7.8,7.8-7.8
		c3.16,0,5.88,1.892,7.103,4.6H11L12.2,7H18V1.2L16.8,0z"/>
</g>
</symbol><symbol id="Reply" viewBox="0 0 18 18">
<g id="reply">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9.294,5H7V1.024L0.024,8L7,14.976V11h2.294c2.579,0,5.748,0.268,8.285,5.118c0.233-0.783,0.363-1.611,0.363-2.471
		C17.942,8.871,14.07,5,9.294,5z M9.294,9.8H5.8v2.278L1.722,8L5.8,3.922V6.2h3.494c3.787,0,6.923,2.841,7.388,6.503
		C14.024,9.8,11.055,9.8,9.294,9.8z"/>
</g>
</symbol><symbol id="ReplyActive" viewBox="0 0 18 18">
<g id="reply_x5F_active">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9.294,5H7V1.024L0.024,8L7,14.976V11h2.294c2.579,0,5.748,0.268,8.285,5.118c0.233-0.784,0.363-1.612,0.363-2.471
		C17.942,8.871,14.07,5,9.294,5z"/>
</g>
</symbol><symbol id="Report" viewBox="0 0 18 18">
<g id="report">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M12,0H0v18h12c1.104,0,2-0.895,2-2V2C14,0.895,13.104,0,12,0z M12.8,16c0,0.441-0.359,0.8-0.8,0.8H1.2V1.2H12
		c0.441,0,0.8,0.359,0.8,0.8V16z M3,5.2h8V4H3V5.2z M8,14h3v-1.2H8V14z M15.2,4.474v1.294l1.238,0.5L15.2,9.332v3.204l2.8-6.93
		L15.2,4.474z"/>
</g>
</symbol><symbol id="RequestOverdraftChange" viewBox="0 0 18 18"><g id="requestOverdraftChange"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M6,18a6,6,0,1,1,4.76-9.59V6.59L12,7.81v3.13H8.86L7.64,9.72h2.55A4.76,4.76,0,1,0,10.77,12v-.22H12V12A6,6,0,0,1,6,18Zm.52-3H5.37V11.32L4.12,12.57V10.92L6,9.09l1.83,1.83v1.65L6.53,11.32ZM16.48,0h-12A1.5,1.5,0,0,0,3,1.52v4a11.51,11.51,0,0,1,1.2-.43V1.52a.3.3,0,0,1,.3-.3h12a.31.31,0,0,1,.3.3v8a.3.3,0,0,1-.3.3H13.17V11h3.31A1.5,1.5,0,0,0,18,9.52v-8Q18,.7,16.48,0ZM6,3.32v1.5A12.36,12.36,0,0,1,8,5V3.32Z"/></g></symbol><symbol id="Reward" viewBox="0 0 18 18">
<g id="reward_1_">
	<path id="reward" d="M15.482,4c0.743-0.978,0.678-2.376-0.214-3.27c-0.974-0.973-2.558-0.974-3.531,0.001L8.999,3.469L6.261,0.73
		C5.287-0.242,3.704-0.241,2.73,0.731C1.839,1.624,1.774,3.022,2.517,4H1v14h16V4H15.482z M12.586,1.58
		c0.505-0.506,1.328-0.505,1.833-0.001c0.505,0.506,0.505,1.329,0,1.834L13.832,4h-3.667L12.586,1.58z M3.579,3.414
		c-0.505-0.506-0.505-1.329,0-1.834c0.504-0.506,1.328-0.506,1.833-0.001L7.833,4H4.165L3.579,3.414z M2.2,5.2h6.2v5.2H2.2V5.2z
		 M2.2,16.8v-5.2h6.2v5.2H2.2z M15.8,16.8H9.6v-5.2h6.2V16.8z M9.6,10.4V5.2h6.2v5.2H9.6z"/>
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="RewardActive" viewBox="0 0 18 18">
<g id="reward_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="9.75" y="11.75" width="7.25" height="6.25"/>
		<rect x="1" y="11.75" width="7.25" height="6.25"/>
		<path d="M15.482,4c0.743-0.978,0.678-2.376-0.214-3.27c-0.974-0.973-2.558-0.974-3.531,0.001L8.999,3.469L6.261,0.73
			C5.287-0.242,3.704-0.241,2.73,0.731C1.839,1.624,1.774,3.022,2.517,4H1v6.25h7.25V5.2h1.5v5.05H17V4H15.482z M4.165,4
			L3.579,3.414c-0.505-0.506-0.505-1.329,0-1.834c0.504-0.506,1.328-0.506,1.833-0.001L7.833,4H4.165z M14.419,3.413L13.832,4
			h-3.667l2.421-2.42c0.505-0.506,1.328-0.505,1.833-0.001C14.925,2.085,14.925,2.908,14.419,3.413z"/>
	</g>
</g>
</symbol><symbol id="RoboAdvice" viewBox="0 0 18 18">
<g id="robo_x5F_advice">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.131,10.589l6.469-6.47V2.423L9.131,8.892L6.229,5.988L2.4,9.817v1.696l3.829-3.828L9.131,10.589z M0,0v18l4-4h14V0H0z
		 M16.8,12.8H4H3.503l-0.352,0.351L1.2,15.103V1.2h15.6V12.8z"/>
</g>
</symbol><symbol id="RoboAdviceActive" viewBox="0 0 18 18">
<g id="robo_x5F_advice_x5F_active">
	<path d="M0,0v18l4-4h14V0H0z M15.6,4.332l-6.469,6.469L6.229,7.897L2.4,11.726V9.605l3.829-3.829L9.131,8.68L15.6,2.21V4.332z"/>
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="Save" viewBox="0 0 18 18">
<g id="save">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14,0H0v18h18V4L14,0z M12.8,1.2v3.6H5.2V1.2H12.8z M5.2,16.8v-5.6h7.6v5.6H5.2z M16.8,16.8H14V10H4v6.8H1.2V1.2H4V6h10
		V1.697l2.8,2.8V16.8z"/>
</g>
</symbol><symbol id="SaveActive" viewBox="0 0 18 18">
<g id="save_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<rect x="5.5" width="7" height="4.5"/>
		<polygon points="14,0 14,6 4,6 4,0 0,0 0,18 4,18 4,10 14,10 14,18 18,18 18,4 		"/>
		<rect x="5.5" y="11.5" width="7" height="6.5"/>
	</g>
</g>
</symbol><symbol id="Saving" viewBox="0 0 18 18">
<g id="saving">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.773,15.539C9.609,15.89,8.208,16.8,5.5,16.8c-2.744,0-4.15-0.936-4.282-1.264c-0.4-0.173-0.762-0.37-1.077-0.591
		C0.051,15.124,0,15.309,0,15.5C0,16.881,2.462,18,5.5,18c3.038,0,5.5-1.119,5.5-2.5c0-0.191-0.051-0.376-0.141-0.555
		C10.542,15.168,10.177,15.366,9.773,15.539z M16.5,0h-12C3.675,0,3,0.675,3,1.5v4.421c0.382-0.077,0.782-0.137,1.2-0.177V1.5
		c0-0.163,0.137-0.3,0.3-0.3h12c0.163,0,0.3,0.137,0.3,0.3v8c0,0.163-0.137,0.3-0.3,0.3h-4.204c-0.052,0.428-0.209,0.831-0.467,1.2
		H16.5c0.825,0,1.5-0.675,1.5-1.5v-8C18,0.675,17.325,0,16.5,0z M5.5,7C2.462,7,0,8.119,0,9.5C0,10.881,2.462,12,5.5,12
		c3.038,0,5.5-1.119,5.5-2.5C11,8.119,8.538,7,5.5,7z M5.5,10.8c-2.817,0-4.235-0.991-4.3-1.294C1.265,9.191,2.683,8.2,5.5,8.2
		s4.235,0.991,4.3,1.294C9.735,9.809,8.317,10.8,5.5,10.8z M6,4.2v1.493c0.71,0.025,1.38,0.103,2,0.228V4.2H6z M9.773,12.539
		C9.609,12.89,8.208,13.8,5.5,13.8c-2.744,0-4.15-0.936-4.282-1.264c-0.4-0.173-0.762-0.37-1.077-0.591
		C0.051,12.124,0,12.309,0,12.5C0,13.881,2.462,15,5.5,15c3.038,0,5.5-1.119,5.5-2.5c0-0.191-0.051-0.376-0.141-0.555
		C10.542,12.168,10.177,12.366,9.773,12.539z"/>
</g>
</symbol><symbol id="SavingActive" viewBox="0 0 18 18">
<g id="saving_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.5,0h-12C3.675,0,3,0.675,3,1.5v4.239C3.767,5.586,4.604,5.5,5.5,5.5c0.17,0,0.334,0.007,0.5,0.013V4h2v1.739
		c2.708,0.539,4.5,1.955,4.5,3.761c0,0.54-0.165,1.042-0.461,1.5H16.5c0.825,0,1.5-0.675,1.5-1.5v-8C18,0.675,17.325,0,16.5,0z
		 M5.5,13.5c-2.261,0-4.175-0.524-5.427-1.388C0.029,12.239,0,12.368,0,12.5C0,13.881,2.462,15,5.5,15s5.5-1.119,5.5-2.5
		c0-0.132-0.029-0.261-0.073-0.388C9.675,12.976,7.761,13.5,5.5,13.5z M5.5,16.5c-2.261,0-4.175-0.524-5.427-1.388
		C0.029,15.239,0,15.368,0,15.5C0,16.881,2.462,18,5.5,18s5.5-1.119,5.5-2.5c0-0.132-0.029-0.261-0.073-0.388
		C9.675,15.976,7.761,16.5,5.5,16.5z M5.5,7C2.462,7,0,8.119,0,9.5S2.462,12,5.5,12S11,10.881,11,9.5S8.538,7,5.5,7z"/>
</g>
</symbol><symbol id="Script" viewBox="0 0 18 18">
<g id="script">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M1,0v18h16V0H1z M15.8,16.8H2.2V1.2h13.6V16.8z M14,3.8H4V5h10V3.8z M14,6.8H4V8h10V6.8z M14,9.8H4V11h10V9.8z M14,12.8H4
		V14h10V12.8z"/>
</g>
</symbol><symbol id="Search" viewBox="0 0 18 18">
<g id="search">
	
		<rect x="0" y="0" transform="matrix(-1 -4.446411e-11 4.446411e-11 -1 18 18)" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M2.197,12.803C3.661,14.268,5.581,15,7.5,15c1.732,0,3.46-0.602,4.858-1.794l4.768,4.767l0.849-0.848l-4.768-4.768
		c2.513-2.947,2.383-7.376-0.402-10.161C11.339,0.732,9.419,0,7.5,0C5.581,0,3.661,0.732,2.197,2.197
		C-0.732,5.126-0.732,9.874,2.197,12.803z M1.2,7.5c0-1.683,0.656-3.265,1.845-4.455S5.817,1.2,7.5,1.2
		c1.683,0,3.265,0.655,4.455,1.845c2.456,2.456,2.456,6.453,0,8.91C10.765,13.145,9.183,13.8,7.5,13.8
		c-1.683,0-3.265-0.655-4.455-1.845C1.855,10.765,1.2,9.183,1.2,7.5z"/>
</g>
</symbol><symbol id="SearchActive" viewBox="0 0 18 18">
<g id="search_x5F_active">
	
		<rect x="0" y="0" transform="matrix(-1 -4.507074e-11 4.507074e-11 -1 18 18)" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M18,16.586l-4.542-4.542c2.248-2.94,2.034-7.159-0.654-9.847C11.339,0.732,9.419,0,7.5,0S3.661,0.732,2.197,2.197
		c-2.929,2.929-2.929,7.678,0,10.606C3.661,14.268,5.581,15,7.5,15c1.604,0,3.205-0.519,4.543-1.542L16.586,18L18,16.586z M7.5,13
		c-1.469,0-2.85-0.572-3.889-1.611C2.572,10.35,2,8.969,2,7.5s0.572-2.85,1.611-3.889C4.65,2.572,6.031,2,7.5,2
		s2.85,0.572,3.889,1.611C12.428,4.65,13,6.031,13,7.5s-0.572,2.85-1.611,3.889C10.35,12.428,8.969,13,7.5,13z"/>
</g>
</symbol><symbol id="SecurityDigitalIdentity" viewBox="0 0 18 18">
<g id="security_x5F_digital_x5F_identity">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,9.738c2.094,0,3.047-1.942,3.047-3.747C12.047,3.81,10.851,2.4,9,2.4c-1.86,0-3.062,1.409-3.062,3.591
		C5.938,7.856,6.885,9.738,9,9.738z M9,3.6c1.714,0,1.847,1.831,1.847,2.392c0,0.946-0.389,2.548-1.847,2.548
		c-1.809,0-1.861-2.287-1.861-2.548C7.139,5.431,7.273,3.6,9,3.6z M0,0v6.031l0,1.216C0,12.927,3.803,16.5,9,18
		c5.198-1.5,9-6.289,9-11.969V0H0z M8.997,16.746c-1.463-0.456-3.304-1.263-4.833-2.638l0.227-0.561
		c0.12-0.296,0.281-0.55,0.48-0.755c0.492-0.506,1.084-0.896,1.765-1.165L9,13.99l2.36-2.358c0.677,0.269,1.266,0.658,1.753,1.16
		c0.199,0.205,0.361,0.459,0.48,0.755l0.093,0.229C12.417,15.116,10.821,16.158,8.997,16.746z M16.8,6.031
		c0,2.486-0.835,4.835-2.261,6.74c-0.157-0.301-0.338-0.581-0.564-0.815c-0.705-0.727-1.574-1.261-2.583-1.588l-0.35-0.114L9,12.293
		l-2.043-2.042l-0.349,0.112c-1.013,0.326-1.887,0.862-2.597,1.593c-0.309,0.317-0.555,0.701-0.732,1.142l-0.027,0.067
		C2.048,11.729,1.2,9.813,1.2,7.247l0-1.216V1.2h15.6V6.031z"/>
</g>
</symbol><symbol id="SecurityEntitlements" viewBox="0 0 18 18">
<g>
	<path d="M0,11.5L0,11.5c0,3.1,2.1,5.7,4.9,6.5c2.9-0.8,5-3.4,5-6.5V9.1H0V11.5z M1.2,10.3h7.5v1c0,2.4-1.5,4.6-3.8,5.4
		c-2.2-0.8-3.8-3-3.8-5.4V10.3z"/>
	<path d="M11.5,6.4c1.8,0,2.6-1.7,2.6-3.2c0-2.2-1.3-3-2.6-3c-1.3,0-2.6,0.8-2.6,3C8.9,4.8,9.7,6.4,11.5,6.4z M11.5,1.3
		C12,1.3,13,1.5,13,3.2c0,0.8-0.3,2.1-1.5,2.1c-1.4,0-1.5-1.7-1.5-2.1C10,1.5,10.9,1.3,11.5,1.3z"/>
	<path d="M16.7,8.7c-0.2-0.4-0.4-0.7-0.6-1c-0.6-0.7-1.4-1.1-2.4-1.4l-0.1,0l-2.1,2.1L9.3,6.3l-0.1,0C8.3,6.6,7.6,7.1,6.9,7.7
		C6.8,7.9,6.7,8,6.6,8.1h1.6c0.3-0.2,0.6-0.4,0.9-0.5l2.4,2.4l2.4-2.4c0.5,0.2,1,0.6,1.4,1c0.2,0.2,0.3,0.4,0.4,0.6l0.7,1.8h-5.5
		c0,0.3,0,0.7,0,1.1H18L16.7,8.7z"/>
</g>
</symbol><symbol id="SecurityEntitlementsActive" viewBox="0 0 18 18">
<path d="M0,11.5L0,11.5c0,3.1,2.1,5.7,4.9,6.5c2.9-0.8,5-3.4,5-6.5V9.1H0V11.5z"/>
<path d="M11.5,6.4c1.8,0,2.6-1.7,2.6-3.2c0-2.2-1.3-3-2.6-3c-1.3,0-2.6,0.8-2.6,3C8.9,4.8,9.7,6.4,11.5,6.4z"/>
<path d="M8.2,8.1h1.4h1.3v1.5c0,0.2,0,0.3,0,0.5v1.9H18l-1.3-3.3c-0.2-0.4-0.4-0.7-0.6-1c-0.6-0.7-1.4-1.1-2.4-1.4l-0.1,0l-2.1,2.1
	L9.3,6.3l-0.1,0C8.3,6.6,7.5,7.1,6.9,7.7C6.8,7.9,6.7,8,6.6,8.1H8.2z"/>
</symbol><symbol id="SecurityEnvironment" viewBox="0 0 18 18">
<g id="security_x5F_environment">
	<path d="M0,0v6.031l0,1.216C0,12.927,3.803,16.5,9,18c5.198-1.5,9-6.289,9-11.969V0H0z M16.8,6.031
		c0,4.871-3.191,9.228-7.803,10.716C5.935,15.792,1.2,13.33,1.2,7.247l0-1.216V1.2h15.6V6.031z M13.86,4.881l-0.849-0.848
		L7.344,9.699L4.989,7.345L4.14,8.194l3.204,3.202L13.86,4.881z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="SecurityEnvironmentActive" viewBox="0 0 18 18">
<g id="security_x5F_enviornment_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v6.031l0,1.216C0,12.927,3.803,16.5,9,18c5.198-1.5,9-6.289,9-11.969V0H0z M7.344,11.608L4.034,8.3l1.061-1.061
		l2.249,2.248l5.562-5.561l1.061,1.061L7.344,11.608z"/>
</g>
</symbol><symbol id="SecurityFace" viewBox="0 0 18 18">
<g id="security_x5F_face">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1.2,16v-4H0v4c0,1.1,0.9,2,2,2h4v-1.2H2C1.566,16.8,1.2,16.434,1.2,16z M1.2,2c0-0.434,0.366-0.8,0.8-0.8h4V0H2
		C0.9,0,0,0.9,0,2v4h1.2V2z M16.8,16c0,0.434-0.366,0.8-0.8,0.8h-4V18h4c1.1,0,2-0.9,2-2v-4h-1.2V16z M16,0h-4v1.2h4
		c0.434,0,0.8,0.366,0.8,0.8v4H18V2C18,0.9,17.1,0,16,0z M5,6c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1S5,5.448,5,6z
		 M12,7c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1C11,6.552,11.448,7,12,7z M11.598,11.387
		c-1.45,1.307-3.746,1.307-5.196,0l-0.804,0.891C6.544,13.131,7.752,13.6,9,13.6s2.456-0.469,3.402-1.322L11.598,11.387z"/>
</g>
</symbol><symbol id="SecurityFingerprint" viewBox="0 0 18 18">
<g id="security_x5F_fingerprint">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,4.089c0.802,0,1.579,0.281,2.247,0.812c0.259,0.206,0.637,0.162,0.843-0.096c0.206-0.26,0.163-0.638-0.096-0.844
		C11.111,3.26,10.076,2.89,9,2.89c-2.915,0-5.287,2.743-5.287,6.115c0,1.31,0.352,2.558,1.004,3.59
		c0.352,0.608,0.995,0.985,1.676,0.985c1.076,0,1.952-0.915,1.952-2.04c0-0.403-0.112-0.793-0.33-1.135
		c-0.251-0.381-0.389-0.879-0.389-1.4c0-1.099,0.629-2.026,1.373-2.026s1.373,0.928,1.373,2.026c0,0.871-0.383,1.645-0.953,1.926
		c-0.297,0.146-0.419,0.507-0.272,0.804s0.506,0.418,0.804,0.272c0.985-0.486,1.622-1.664,1.622-3.002
		c0-1.778-1.154-3.226-2.573-3.226S6.427,7.227,6.427,9.005c0,0.754,0.208,1.485,0.582,2.053c0.09,0.141,0.137,0.308,0.137,0.482
		c0,0.464-0.337,0.841-0.752,0.841c-0.255,0-0.5-0.148-0.65-0.407c-0.543-0.86-0.831-1.887-0.831-2.969
		C4.914,6.294,6.747,4.089,9,4.089z M2.2,9.005c0-0.331-0.269-0.6-0.6-0.6S1,8.674,1,9.005c0,2.927,1.271,5.68,3.4,7.365
		c0.11,0.087,0.242,0.129,0.372,0.129c0.177,0,0.353-0.077,0.471-0.228c0.206-0.26,0.162-0.637-0.098-0.843
		C3.301,13.97,2.2,11.568,2.2,9.005z M9,0C5.646,0,2.623,2.383,1.479,5.929C1.376,6.244,1.55,6.583,1.865,6.685
		C2.18,6.785,2.518,6.613,2.62,6.298C3.604,3.248,6.168,1.199,9,1.199c3.75,0,6.8,3.502,6.8,7.806c0,3.446-2.015,6.527-4.922,7.499
		c-0.006,0.003-0.619,0.231-1.346,0.299c-0.33,0.031-0.573,0.323-0.542,0.653C9.019,17.768,9.28,18,9.586,18
		c0.019,0,0.038,0,0.056-0.002c0.896-0.084,1.63-0.36,1.637-0.363C14.648,16.509,17,12.96,17,9.005C17,4.039,13.411,0,9,0z
		 M14.287,9.005c0-0.873-0.155-1.716-0.462-2.504c-0.12-0.311-0.469-0.462-0.776-0.343c-0.309,0.12-0.462,0.468-0.342,0.776
		c0.252,0.649,0.38,1.347,0.38,2.07c0,2.299-1.173,4.123-3.073,4.765c-1.632,0.588-2.968,1.607-3.862,2.95
		c-0.184,0.276-0.109,0.648,0.167,0.832c0.102,0.068,0.218,0.101,0.332,0.101c0.194,0,0.384-0.094,0.5-0.267
		c0.75-1.128,1.881-1.987,3.258-2.483C12.8,14.096,14.287,11.835,14.287,9.005z"/>
</g>
</symbol><symbol id="SecurityHsbcServices" viewBox="0 0 18 18">
<g id="security_x5F_hsbc_x5F_services">
	<path d="M0,0v6.031l0,1.216C0,12.927,3.803,16.5,9,18c5.197-1.5,9-6.289,9-11.969V0H0z M16.8,6.031
		c0,4.871-3.191,9.228-7.803,10.716C5.935,15.792,1.2,13.33,1.2,7.247l0-1.216V1.2h15.6V6.031z M13.86,4.881l-0.849-0.848
		L7.344,9.699L4.989,7.345L4.14,8.194l3.204,3.202L13.86,4.881z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="SecurityHsbcServicesActive" viewBox="0 0 18 18">
<g id="security_x5F_hsbc_x5F_services_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M0,0v6.031l0,1.216C0,12.927,3.803,16.5,9,18c5.197-1.5,9-6.289,9-11.969V0H0z M7.344,11.608L4.034,8.3l1.061-1.061
		l2.249,2.248l5.562-5.561l1.061,1.061L7.344,11.608z"/>
</g>
</symbol><symbol id="SecurityPassword" viewBox="0 0 18 18">
<g id="security_x5F_password">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M2.2,1.2h13.6v1.6H17V0H1v2.8h1.2V1.2z M8.997,16.746c-1.671-0.527-3.892-1.563-5.333-3.546H2.24
		C3.624,15.551,6.058,17.151,9,18c2.657-0.767,4.9-2.504,6.329-4.8h-1.457C12.676,14.828,10.99,16.093,8.997,16.746z M16.5,4h-15
		C0.675,4,0,4.675,0,5.5v5C0,11.325,0.675,12,1.5,12h15c0.825,0,1.5-0.675,1.5-1.5v-5C18,4.675,17.325,4,16.5,4z M16.8,10.5
		c0,0.163-0.137,0.3-0.3,0.3h-15c-0.163,0-0.3-0.137-0.3-0.3v-5c0-0.163,0.137-0.3,0.3-0.3h15c0.163,0,0.3,0.137,0.3,0.3V10.5z
		 M12,9h3V7.8h-3V9z M4.3,6.7C3.582,6.7,3,7.282,3,8s0.582,1.3,1.3,1.3S5.6,8.718,5.6,8S5.018,6.7,4.3,6.7z M9,6.7
		C8.282,6.7,7.7,7.282,7.7,8S8.282,9.3,9,9.3s1.3-0.582,1.3-1.3S9.718,6.7,9,6.7z"/>
</g>
</symbol><symbol id="SecuritySecure" viewBox="0 0 18 18">
<g id="security_x5F_secure">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M15.5,5.734H14V4c0-2.2-1.8-4-4-4H8C5.8,0,4,1.8,4,4v1.734H2.5c-0.825,0-1.5,0.675-1.5,1.5V16.5C1,17.325,1.675,18,2.5,18
		h13c0.825,0,1.5-0.675,1.5-1.5V7.234C17,6.409,16.325,5.734,15.5,5.734z M5.2,4c0-1.544,1.256-2.8,2.8-2.8h2
		c1.544,0,2.8,1.256,2.8,2.8v1.734h-1.2V4c0-0.882-0.718-1.6-1.6-1.6H8C7.118,2.4,6.4,3.118,6.4,4v1.734H5.2V4z M10.4,4v1.734H7.6V4
		c0-0.217,0.183-0.4,0.4-0.4h2C10.217,3.6,10.4,3.783,10.4,4z M15.8,16.5c0,0.163-0.137,0.3-0.3,0.3h-13c-0.163,0-0.3-0.137-0.3-0.3
		V7.234c0-0.163,0.137-0.3,0.3-0.3h13c0.163,0,0.3,0.137,0.3,0.3V16.5z M8.4,14h1.2v-4H8.4V14z"/>
</g>
</symbol><symbol id="SecuritySecureActive" viewBox="0 0 18 18">
<g id="security_x5F_secure_x5F_active">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M15.5,5.734h-13c-0.825,0-1.5,0.675-1.5,1.5V16.5C1,17.325,1.675,18,2.5,18h13c0.825,0,1.5-0.675,1.5-1.5V7.234
		C17,6.409,16.325,5.734,15.5,5.734z M9.75,14h-1.5v-4h1.5V14z M6,4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v0.234h2V4c0-2.2-1.8-4-4-4H8
		C5.8,0,4,1.8,4,4v0.234h2V4z"/>
</g>
</symbol><symbol id="SecuritySecureKey" viewBox="0 0 18 18">
<g id="security_x5F_secure_x5F_key">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M4.8,8.6c0.442,0,0.8-0.358,0.8-0.8C5.6,7.358,5.242,7,4.8,7S4,7.358,4,7.8C4,8.242,4.358,8.6,4.8,8.6z M4.8,15
		c0.442,0,0.8-0.358,0.8-0.8c0-0.442-0.358-0.8-0.8-0.8S4,13.758,4,14.2C4,14.642,4.358,15,4.8,15z M4.8,11.8
		c0.442,0,0.8-0.358,0.8-0.8s-0.358-0.8-0.8-0.8S4,10.558,4,11S4.358,11.8,4.8,11.8z M9,8.6c0.442,0,0.8-0.358,0.8-0.8
		C9.8,7.358,9.442,7,9,7S8.2,7.358,8.2,7.8C8.2,8.242,8.558,8.6,9,8.6z M9,15c0.442,0,0.8-0.358,0.8-0.8c0-0.442-0.358-0.8-0.8-0.8
		s-0.8,0.358-0.8,0.8C8.2,14.642,8.558,15,9,15z M9,11.8c0.442,0,0.8-0.358,0.8-0.8S9.442,10.2,9,10.2S8.2,10.558,8.2,11
		S8.558,11.8,9,11.8z M13.2,8.6c0.442,0,0.8-0.358,0.8-0.8C14,7.358,13.642,7,13.2,7s-0.8,0.358-0.8,0.8
		C12.4,8.242,12.758,8.6,13.2,8.6z M13.2,15c0.442,0,0.8-0.358,0.8-0.8c0-0.442-0.358-0.8-0.8-0.8s-0.8,0.358-0.8,0.8
		C12.4,14.642,12.758,15,13.2,15z M13.2,11.8c0.442,0,0.8-0.358,0.8-0.8s-0.358-0.8-0.8-0.8s-0.8,0.358-0.8,0.8
		S12.758,11.8,13.2,11.8z M17,1.5C17,0.675,16.325,0,15.5,0h-13C1.675,0,1,0.675,1,1.5v15C1,17.325,1.675,18,2.5,18h13
		c0.825,0,1.5-0.675,1.5-1.5V1.5z M15.8,16.5c0,0.163-0.137,0.3-0.3,0.3h-13c-0.163,0-0.3-0.137-0.3-0.3V5h13.6V16.5z M15.8,3.8H2.2
		V1.5c0-0.163,0.137-0.3,0.3-0.3h13c0.163,0,0.3,0.137,0.3,0.3V3.8z"/>
</g>
</symbol><symbol id="SecuritySettings" viewBox="0 0 18 18">
<g id="security_x5F_settings">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M5,8.221c0,2.525,1.69,4.653,4,5.32c2.31-0.667,4-2.795,4-5.32V6H5V8.221z M6.2,7.2h5.6v1.021
		c0,1.803-1.135,3.423-2.8,4.056c-1.665-0.633-2.8-2.253-2.8-4.056V7.2z M16.376,6.992c-0.168-0.618-0.416-1.218-0.742-1.787
		l0.685-1.614L14.408,1.68l-1.614,0.685c-0.569-0.325-1.168-0.574-1.786-0.742L10.352,0H7.648L6.992,1.624
		C6.374,1.791,5.774,2.04,5.206,2.365L3.592,1.68L1.68,3.592l0.685,1.614C2.04,5.774,1.791,6.374,1.623,6.992L0,7.648v2.703
		l1.623,0.656c0.168,0.619,0.416,1.218,0.742,1.787L1.68,14.408l1.912,1.912l1.614-0.685c0.569,0.326,1.168,0.574,1.787,0.742
		L7.648,18h2.703l0.656-1.624c0.619-0.167,1.218-0.416,1.787-0.742l1.614,0.685l1.912-1.912l-0.685-1.614
		c0.326-0.569,0.574-1.168,0.742-1.787L18,10.352V7.648L16.376,6.992z M16.8,9.542l-0.873,0.353l-0.553,0.223l-0.156,0.575
		c-0.141,0.521-0.352,1.027-0.625,1.505l-0.296,0.517l0.233,0.548l0.369,0.869l-0.767,0.767l-0.868-0.369l-0.548-0.233l-0.517,0.296
		c-0.478,0.274-0.984,0.484-1.505,0.625l-0.575,0.156l-0.223,0.552L9.542,16.8H8.458l-0.353-0.873l-0.223-0.553l-0.576-0.156
		c-0.521-0.141-1.027-0.351-1.504-0.625l-0.517-0.296L4.736,14.53l-0.868,0.369l-0.767-0.767l0.369-0.868l0.233-0.548l-0.296-0.517
		c-0.274-0.479-0.484-0.985-0.625-1.505l-0.156-0.575L2.073,9.895L1.2,9.542V8.458l0.873-0.353l0.553-0.223l0.156-0.575
		c0.141-0.52,0.351-1.027,0.625-1.505l0.296-0.517L3.47,4.736L3.101,3.868l0.767-0.767L4.737,3.47l0.548,0.233l0.517-0.296
		C6.28,3.133,6.786,2.923,7.306,2.782l0.575-0.156l0.223-0.553L8.458,1.2h1.085l0.353,0.873l0.223,0.553l0.575,0.156
		c0.521,0.141,1.027,0.352,1.504,0.625l0.517,0.296l0.548-0.233l0.869-0.369l0.767,0.767L14.53,4.737l-0.233,0.548l0.296,0.517
		c0.274,0.478,0.484,0.984,0.625,1.505l0.156,0.575l0.553,0.223L16.8,8.458V9.542z"/>
</g>
</symbol><symbol id="SecuritySettingsActive" viewBox="0 0 18 18">
<g id="security_x5F_settings_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M18,10.352V7.648l-1.624-0.656c-0.168-0.618-0.416-1.218-0.742-1.787l0.685-1.614L14.408,1.68l-1.614,0.685
		c-0.569-0.326-1.168-0.574-1.786-0.742L10.352,0H7.648L6.992,1.624C6.374,1.791,5.774,2.04,5.206,2.365L3.592,1.68L1.68,3.592
		l0.685,1.614C2.04,5.774,1.791,6.374,1.624,6.992L0,7.648v2.703l1.624,0.656c0.167,0.619,0.416,1.218,0.742,1.787L1.68,14.408
		l1.912,1.912l1.614-0.685c0.569,0.326,1.168,0.574,1.787,0.742L7.648,18h2.703l0.656-1.624c0.619-0.167,1.218-0.416,1.787-0.742
		l1.614,0.685l1.912-1.912l-0.685-1.614c0.326-0.569,0.574-1.168,0.742-1.787L18,10.352z M13,8.221c0,2.525-1.69,4.653-4,5.32
		c-2.31-0.667-4-2.795-4-5.32l0,0V6h8V8.221z"/>
</g>
</symbol><symbol id="Settings" viewBox="0 0 18 18">
<g id="settings">
	<rect y="0" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M16.376,6.992c-0.168-0.618-0.416-1.218-0.742-1.786l0.685-1.614L14.408,1.68l-1.614,0.685
		c-0.569-0.325-1.168-0.574-1.787-0.742L10.352,0H7.648L6.992,1.624C6.374,1.791,5.774,2.04,5.206,2.365L3.592,1.68L1.68,3.592
		l0.685,1.614C2.04,5.774,1.791,6.374,1.624,6.992L0,7.648v2.703l1.624,0.656c0.167,0.619,0.416,1.218,0.742,1.787L1.68,14.408
		l1.912,1.912l1.614-0.685c0.569,0.326,1.168,0.574,1.787,0.742L7.648,18h2.703l0.656-1.623c0.618-0.168,1.218-0.416,1.787-0.742
		l1.614,0.685l1.912-1.912l-0.685-1.614c0.326-0.569,0.574-1.168,0.742-1.787L18,10.352V7.648L16.376,6.992z M15.927,9.895
		l-0.553,0.223l-0.156,0.576c-0.141,0.52-0.351,1.026-0.625,1.504l-0.295,0.517l0.232,0.548l0.369,0.869l-0.767,0.767l-0.868-0.369
		l-0.548-0.233l-0.517,0.296c-0.478,0.273-0.984,0.484-1.505,0.625l-0.575,0.156l-0.223,0.552L9.542,16.8H8.458l-0.353-0.873
		l-0.223-0.552l-0.576-0.156c-0.521-0.141-1.026-0.352-1.504-0.625l-0.517-0.296L4.736,14.53l-0.868,0.369l-0.767-0.767l0.369-0.868
		l0.233-0.548l-0.296-0.517c-0.273-0.478-0.484-0.984-0.625-1.505l-0.156-0.575L2.073,9.895L1.2,9.542V8.458l0.873-0.353
		l0.552-0.223l0.156-0.575c0.141-0.521,0.352-1.027,0.625-1.505l0.296-0.517L3.47,4.737L3.101,3.868l0.767-0.767L4.737,3.47
		l0.548,0.233l0.517-0.296c0.478-0.273,0.984-0.483,1.505-0.625l0.575-0.156l0.223-0.552L8.458,1.2h1.085l0.353,0.873l0.223,0.552
		l0.575,0.156c0.521,0.141,1.027,0.352,1.505,0.625l0.517,0.296l0.548-0.233l0.869-0.369l0.767,0.767L14.53,4.737l-0.233,0.548
		l0.296,0.517c0.273,0.477,0.483,0.983,0.625,1.504l0.156,0.575l0.553,0.223L16.8,8.458l0,1.084L15.927,9.895z M9,4.8
		c-1.122,0-2.177,0.437-2.97,1.23C5.237,6.823,4.8,7.878,4.8,9c0,1.122,0.437,2.177,1.23,2.97C6.823,12.763,7.878,13.2,9,13.2
		c1.122,0,2.176-0.437,2.97-1.23S13.2,10.122,13.2,9c0-1.122-0.437-2.177-1.23-2.97S10.122,4.8,9,4.8z M11.121,11.121
		C10.536,11.707,9.768,12,9,12c-0.768,0-1.536-0.293-2.122-0.879c-1.171-1.171-1.171-3.071,0-4.242C7.464,6.293,8.232,6,9,6
		c0.768,0,1.536,0.293,2.121,0.879C12.293,8.05,12.293,9.95,11.121,11.121z"/>
</g>
</symbol><symbol id="SettingsActive" viewBox="0 0 18 18">
<g id="settings_x5F_active">
	<rect y="0" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M18,10.352V7.648l-1.624-0.656c-0.168-0.618-0.416-1.218-0.742-1.787l0.685-1.614L14.408,1.68l-1.614,0.685
		c-0.569-0.326-1.168-0.574-1.786-0.742L10.352,0H7.648L6.992,1.624C6.374,1.791,5.774,2.04,5.206,2.365L3.592,1.68L1.68,3.592
		l0.685,1.614C2.04,5.774,1.791,6.374,1.624,6.992L0,7.648v2.703l1.624,0.656c0.167,0.619,0.416,1.218,0.742,1.787L1.68,14.408
		l1.912,1.912l1.614-0.685c0.569,0.326,1.168,0.574,1.787,0.742L7.648,18h2.703l0.656-1.624c0.619-0.167,1.218-0.416,1.787-0.742
		l1.614,0.685l1.912-1.912l-0.685-1.614c0.326-0.569,0.574-1.168,0.742-1.787L18,10.352z M11.828,11.829
		c-1.562,1.562-4.095,1.562-5.657,0c-1.562-1.562-1.562-4.095,0-5.657c1.562-1.562,4.095-1.562,5.657,0
		C13.39,7.734,13.39,10.266,11.828,11.829z"/>
</g>
</symbol><symbol id="ShareAndroid" viewBox="0 0 18 18">
<g id="share_x5F_android">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.5,13c-0.694,0-1.322,0.283-1.775,0.74L5.972,9.276C5.982,9.184,6,9.094,6,9c0-0.094-0.018-0.184-0.028-0.276
		l6.753-4.465C13.179,4.716,13.806,5,14.5,5C15.881,5,17,3.88,17,2.5S15.881,0,14.5,0S12,1.119,12,2.5
		c0,0.253,0.049,0.491,0.118,0.721L5.544,7.568C5.092,6.924,4.347,6.5,3.5,6.5C2.119,6.5,1,7.619,1,9s1.119,2.5,2.5,2.5
		c0.847,0,1.592-0.423,2.044-1.067l6.573,4.346C12.048,15.008,12,15.247,12,15.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5
		S15.881,13,14.5,13z M14.5,1.2c0.717,0,1.3,0.583,1.3,1.3c0,0.717-0.583,1.3-1.3,1.3s-1.3-0.583-1.3-1.3
		C13.2,1.783,13.783,1.2,14.5,1.2z M3.5,10.3c-0.717,0-1.3-0.583-1.3-1.3c0-0.717,0.583-1.3,1.3-1.3S4.8,8.283,4.8,9
		C4.8,9.717,4.217,10.3,3.5,10.3z M14.5,16.8c-0.717,0-1.3-0.583-1.3-1.3s0.583-1.3,1.3-1.3s1.3,0.583,1.3,1.3
		S15.217,16.8,14.5,16.8z"/>
</g>
</symbol><symbol id="ShareAndroidActive" viewBox="0 0 18 18">
<g id="share_x5F_android_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M14.5,13c-0.544,0-1.044,0.178-1.454,0.474l-0.044-0.029L6.279,9l6.722-4.444l0.044-0.029C13.456,4.821,13.956,5,14.5,5
		C15.881,5,17,3.88,17,2.5C17,1.119,15.881,0,14.5,0S12,1.119,12,2.5c0,0.103,0.018,0.201,0.03,0.301l-0.131,0.087l-6.61,4.37
		C4.835,6.792,4.202,6.5,3.5,6.5C2.119,6.5,1,7.619,1,9c0,1.38,1.119,2.5,2.5,2.5c0.702,0,1.335-0.292,1.789-0.758l6.61,4.37
		l0.131,0.086C12.018,15.299,12,15.397,12,15.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S15.881,13,14.5,13z"/>
</g>
</symbol><symbol id="ShareIos" viewBox="0 0 18 18">
<g id="share_x5F_ios">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M13,6v1.217h2.783v8.566H2.222V7.217H5V6H1.005v11H17V6H13z M8.4,12h1.2V2.448l2.4,2.4V3.152l-3-3l-3,3v1.696l2.4-2.4V12z"/>
</g>
</symbol><symbol id="ShareIosActive" viewBox="0 0 18 18">
<g id="share_x5F_ios_x5F_active">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M8,12h2V3.885l3,3.001V4.057l-4-4l-4,4v2.829l3-3.001V12z M15,6v9H3.005V6h-2v11H17V6H15z"/>
</g>
</symbol><symbol id="ShoppingCart" viewBox="0 0 18 18">
<g id="shopping_x5F_cart_1_">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M15,14H4.361l0.808-2h9.395L18,3.5H2.294L1.283,1H0v0.026l4.156,10.281L3.067,14H2.5C1.672,14,1,14.672,1,15.5
		S1.672,17,2.5,17S4,16.328,4,15.5c0-0.103-0.01-0.203-0.03-0.3h9.561c-0.02,0.097-0.03,0.197-0.03,0.3c0,0.828,0.672,1.5,1.5,1.5
		s1.5-0.672,1.5-1.5S15.828,14,15,14z M16.109,4.775l-2.405,5.95H5.295l-2.405-5.95H16.109z"/>
</g>
</symbol><symbol id="ShoppingCartActive" viewBox="0 0 18 18">
<g id="shopping_x5F_cart_x5F_active">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M15,14H4.361l0.808-2h9.395L18,3.5H2.294L1.283,1H0v0.026l4.156,10.281L3.067,14H2.5C1.672,14,1,14.671,1,15.5
		S1.672,17,2.5,17S4,16.329,4,15.5c0-0.103-0.01-0.203-0.03-0.3h9.561c-0.02,0.097-0.03,0.197-0.03,0.3c0,0.829,0.672,1.5,1.5,1.5
		s1.5-0.671,1.5-1.5S15.828,14,15,14z"/>
</g>
</symbol><symbol id="Shortcuts" viewBox="0 0 18 18">
<g id="shortcuts">
	<path d="M0,0v18h18V0H0z M16.8,16.8H1.2V1.2h15.6V16.8z M5.819,14.47l0.424,0.425l4.957-4.957l2.699,2.7V3.996L5.26,3.997
		l2.727,2.727L5.819,8.891C4.281,10.429,4.281,12.932,5.819,14.47z M6.668,9.738l3.016-3.015L8.156,5.196L12.7,5.195v4.544
		L11.201,8.24L6.29,13.151c-0.278-0.436-0.426-0.942-0.426-1.472C5.864,10.947,6.149,10.258,6.668,9.738z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="ShortcutsActive" viewBox="0 0 18 18">
<g id="shortcuts_x5F_active">
	<g>
		<path d="M6.774,9.845c-0.49,0.49-0.76,1.143-0.76,1.835c0,0.436,0.106,0.855,0.307,1.229l4.88-4.88l1.349,1.35V5.346L8.519,5.347
			l1.377,1.377L6.774,9.845z"/>
		<path d="M0,0v18h18V0H0z M14.05,12.999l-2.849-2.85l-4.957,4.957l-0.53-0.53c-0.773-0.773-1.2-1.802-1.2-2.896
			c0-1.094,0.426-2.122,1.2-2.896l2.061-2.061L4.897,3.847l9.152-0.001V12.999z"/>
	</g>
	<rect style="fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="SignatureLive" viewBox="0 0 18.024 18">
<g id="signature_x5F_live">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M15.634,14.685c-0.651-0.649-1.71-0.649-2.361,0.001l-1.632,1.633c-0.184,0.183-0.482,0.183-0.665,0.001l-1.634-1.635
		c-0.651-0.649-1.71-0.649-2.361,0.001l-1.329,1.328c-0.621,0.621-1.48,0.882-2.361,0.715c-1.022-0.193-1.865-1.046-2.049-2.072
		c-0.141-0.79,0.059-1.558,0.563-2.16c0.498-0.594,1.227-0.936,2.001-0.936v-1.199c-1.13,0-2.195,0.497-2.922,1.364
		c-0.726,0.867-1.026,2.013-0.825,3.142c0.27,1.506,1.506,2.757,3.007,3.041c0.243,0.046,0.487,0.068,0.729,0.068
		c1.009,0,1.984-0.394,2.705-1.114l1.328-1.328c0.183-0.184,0.481-0.184,0.665-0.001l1.634,1.635
		c0.65,0.648,1.709,0.648,2.361-0.001l1.632-1.633c0.183-0.184,0.481-0.184,0.665-0.001l2.39,2.39l0.849-0.848L15.634,14.685z
		 M17.508,3.607c0.656-0.656,0.656-1.719,0-2.375l-0.74-0.74C16.44,0.164,16.01,0,15.58,0s-0.86,0.164-1.188,0.492L6.298,8.587L4,14
		l5.413-2.298L17.508,3.607z M6.265,11.735l1.046-2.464l7.93-7.93c0.122-0.122,0.265-0.14,0.339-0.14s0.217,0.018,0.339,0.14
		l0.74,0.74c0.187,0.187,0.187,0.491,0,0.678l-7.93,7.93L6.265,11.735z"/>
</g>
</symbol><symbol id="SignatureLiveActive" viewBox="0 0 18 18">
<g id="signature_x5F_live_x5F_active">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.413,11.702l8.095-8.095c0.656-0.656,0.656-1.719,0-2.375l-0.74-0.741c-0.656-0.656-1.719-0.656-2.375,0L6.298,8.587
		L4,14L9.413,11.702z M13.389,14.026l-1.731,1.634l-1.634-1.635c-0.806-0.805-2.119-0.806-2.926,0.001L5.77,15.355
		c-0.526,0.525-1.254,0.748-2.004,0.604c-0.863-0.164-1.574-0.884-1.729-1.75c-0.12-0.672,0.049-1.322,0.477-1.833
		c0.421-0.503,1.039-0.792,1.695-0.792v-2c-1.249,0-2.426,0.55-3.229,1.509c-0.802,0.958-1.134,2.222-0.912,3.469
		c0.303,1.691,1.64,3.043,3.326,3.362C3.661,17.975,3.93,18,4.197,18c1.114,0,2.19-0.436,2.987-1.231l1.427-1.329l1.634,1.634
		c0.806,0.807,2.118,0.807,2.927,0l1.731-1.634l1.682,1.682l1.414-1.414l-1.683-1.683C15.511,13.22,14.198,13.219,13.389,14.026z"/>
</g>
</symbol><symbol id="SocialFacebook" viewBox="0 0 18 18">
    <title>System icons/ Social facebook / </title>
    <path d="M13,2.10096154 L13,4.32211538 L11.7280093,4.32211538 C11.2635008,4.32211538 10.9502323,4.42307591 10.7881944,4.625 C10.6261566,4.82692409 10.5451389,5.12980567 10.5451389,5.53365385 L10.5451389,7.12379808 L12.9189815,7.12379808 L12.6030093,9.61418269 L10.5451389,9.61418269 L10.5451389,16 L8.06597222,16 L8.06597222,9.61418269 L6,9.61418269 L6,7.12379808 L8.06597222,7.12379808 L8.06597222,5.28966346 C8.06597222,4.24638901 8.34683361,3.43730255 8.90856481,2.86237981 C9.47029602,2.28745706 10.2183595,2 11.1527778,2 C11.9467632,2 12.5624978,2.03365351 13,2.10096154 Z"/>
    <g id="System-icons/-Social-facebook-/-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Container" fill="#FFFFFF" opacity="0" x="0" y="0" width="18" height="18"/>
        <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"/>
        </mask>
    </g>
</symbol><symbol id="SocialTwitter" viewBox="0 0 18 18">
    <title>System icons/ Social twitter / </title>
    <path d="M16,4.425 C15.6032129,5.03750306 15.1235223,5.55937284 14.5609137,5.990625 C14.5668359,6.07812544 14.569797,6.20937412 14.569797,6.384375 C14.569797,7.19687906 14.4572769,8.00780845 14.2322335,8.8171875 C14.0071901,9.62656655 13.6651884,10.4031213 13.2062183,11.146875 C12.7472481,11.8906287 12.2009338,12.5484346 11.5672589,13.1203125 C10.933584,13.6921904 10.1696322,14.1484358 9.27538071,14.4890625 C8.3811292,14.8296892 7.42470898,15 6.40609137,15 C4.80117641,15 3.33249397,14.5468795 2,13.640625 C2.20727684,13.6656251 2.438239,13.678125 2.6928934,13.678125 C4.02538737,13.678125 5.21276975,13.2468793 6.25507614,12.384375 C5.63324562,12.3718749 5.0765676,12.1703145 4.58502538,11.7796875 C4.09348316,11.3890605 3.75592308,10.890628 3.57233503,10.284375 C3.76776747,10.3156252 3.94839173,10.33125 4.1142132,10.33125 C4.3688676,10.33125 4.62055713,10.2968753 4.86928934,10.228125 C4.20600345,10.0843743 3.65672806,9.73594027 3.2214467,9.1828125 C2.78616534,8.62968473 2.56852792,7.98750366 2.56852792,7.25625 L2.56852792,7.21875 C2.97123721,7.45625119 3.40355099,7.58437491 3.86548223,7.603125 C3.47461734,7.32812362 3.16370674,6.96875222 2.93274112,6.525 C2.70177549,6.08124778 2.58629442,5.60000259 2.58629442,5.08125 C2.58629442,4.53124725 2.71658076,4.02187734 2.97715736,3.553125 C3.69374301,4.48437966 4.5657732,5.2296847 5.59327411,5.7890625 C6.62077502,6.3484403 7.72080632,6.65937469 8.89340102,6.721875 C8.84602345,6.48437381 8.82233503,6.25312613 8.82233503,6.028125 C8.82233503,5.19062081 9.10215456,4.47656545 9.66180203,3.8859375 C10.2214495,3.29530955 10.8980502,3 11.6916244,3 C12.5207317,3 13.2195403,3.31874681 13.7880711,3.95625 C14.4335904,3.82499934 15.0406063,3.58125178 15.6091371,3.225 C15.3900158,3.94375359 14.9695463,4.5 14.3477157,4.89375 C14.8984799,4.83124969 15.4492358,4.67500125 16,4.425 Z"/>
    <g id="System-icons/-Social-twitter-/-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Container" fill="#FFFFFF" opacity="0" x="0" y="0" width="18" height="18"/>
        <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"/>
        </mask>
    </g>
</symbol><symbol id="SocialYoutube" viewBox="0 0 18 18">
    <title>System icons/ Social youtube / </title>
    <path d="M7.34830646,10.5253968 L11.6694939,8.34285714 L7.34830646,6.13412698 L7.34830646,10.5253968 Z M9,3 C9.9999492,3 10.9656595,3.01309511 11.8971598,3.03928571 C12.82866,3.06547632 13.5116508,3.09312155 13.9461526,3.12222222 L14.5979019,3.15714286 C14.603854,3.15714286 14.6544459,3.16150789 14.7496791,3.1702381 C14.8449124,3.1789683 14.9133603,3.18769837 14.9550248,3.19642857 C14.9966894,3.20515877 15.0666252,3.21825388 15.1648345,3.23571429 C15.2630438,3.25317469 15.3478597,3.27645488 15.4192846,3.30555556 C15.4907096,3.33465623 15.5740374,3.37248654 15.6692707,3.41904762 C15.7645039,3.4656087 15.8567598,3.52235416 15.946041,3.58928571 C16.0353221,3.65621727 16.121626,3.7333329 16.2049551,3.82063492 C16.2406675,3.85555573 16.2867955,3.90939117 16.3433402,3.98214286 C16.399885,4.05489454 16.4861888,4.22513094 16.6022543,4.49285714 C16.7183199,4.76058335 16.7971837,5.05449575 16.8388483,5.37460317 C16.8864649,5.74709181 16.9236648,6.14431006 16.9504492,6.56626984 C16.9772335,6.98822962 16.9936015,7.31851733 16.9995536,7.55714286 L16.9995536,9.09365079 C17.0055057,9.93757036 16.9519378,10.7814773 16.8388483,11.6253968 C16.7971837,11.9455042 16.7227839,12.2350516 16.6156464,12.4940476 C16.508509,12.7530436 16.4132772,12.9320101 16.3299481,13.0309524 L16.2049551,13.1793651 C16.121626,13.2666671 16.0353221,13.3437827 15.946041,13.4107143 C15.8567598,13.4776458 15.7645039,13.5329363 15.6692707,13.5765873 C15.5740374,13.6202383 15.4907096,13.6566136 15.4192846,13.6857143 C15.3478597,13.714815 15.2630438,13.7380952 15.1648345,13.7555556 C15.0666252,13.773016 14.9952014,13.7861111 14.9505608,13.7948413 C14.9059202,13.8035715 14.8374723,13.8123015 14.7452151,13.8210317 C14.6529579,13.8297619 14.603854,13.834127 14.5979019,13.834127 C13.1039302,13.9447095 11.2379815,14 9,14 C7.76791974,13.9883597 6.69804966,13.9694446 5.79035768,13.943254 C4.8826657,13.9170634 4.28597878,13.8952382 4.00027901,13.8777778 L3.56280342,13.8428571 L3.24139279,13.8079365 C3.02711796,13.7788358 2.86492625,13.7497356 2.7548128,13.7206349 C2.64469934,13.6915342 2.49292362,13.6304237 2.29948106,13.5373016 C2.10603851,13.4441794 1.93789481,13.3248685 1.79504493,13.1793651 C1.75933246,13.1444443 1.71320454,13.0906088 1.65665979,13.0178571 C1.60011505,12.9451055 1.5138112,12.7748691 1.39774567,12.5071429 C1.28168014,12.2394167 1.20281628,11.9455042 1.16115173,11.6253968 C1.1135351,11.2529082 1.07633517,10.8556899 1.04955081,10.4337302 C1.02276646,10.0117704 1.00639849,9.68148267 1.00044641,9.44285714 L1.00044641,7.90634921 C0.994494333,7.06242964 1.04806224,6.21852274 1.16115173,5.37460317 C1.20281628,5.05449575 1.27721615,4.76494838 1.38435356,4.50595238 C1.49149097,4.24695638 1.5867228,4.06798991 1.6700519,3.96904762 L1.79504493,3.82063492 C1.87837403,3.7333329 1.96467787,3.65621727 2.05395905,3.58928571 C2.14324023,3.52235416 2.23549606,3.4656087 2.33072932,3.41904762 C2.42596258,3.37248654 2.50929043,3.33465623 2.58071537,3.30555556 C2.65214031,3.27645488 2.73695616,3.25317469 2.83516545,3.23571429 C2.93337475,3.21825388 3.00331062,3.20515877 3.04497517,3.19642857 C3.08663972,3.18769837 3.1550876,3.1789683 3.25032086,3.1702381 C3.34555412,3.16150789 3.39614602,3.15714286 3.4020981,3.15714286 C4.89606982,3.05238043 6.76201846,3 9,3 Z"/>
    <g id="System-icons/-Social-youtube-/-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Container" fill="#FFFFFF" opacity="0" x="0" y="0" width="18" height="18"/>
        <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"/>
        </mask>
    </g>
</symbol><symbol id="Sort" viewBox="0 0 18 18"><title>sort</title><polygon points="9 0 1.5 7.5 16.5 7.5 9 0"/><polygon points="9 18 16.5 10.5 1.5 10.5 9 18"/><g class="cls-1"><rect class="cls-2" width="18" height="18"/></g></symbol><symbol id="Stamp" viewBox="0 0 18 18"><g id="stamp"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M14.19,1.32a2.44,2.44,0,0,1,1.88.86,2.5,2.5,0,0,1-1,4L11.67,7.59a3,3,0,0,0-.89.6l-.15.15a2.84,2.84,0,0,0,0,4l2.13,2.12a.17.17,0,0,1,.05.13.17.17,0,0,1-.05.14l-1.41,1.4L1.87,6.65,3.28,5.24a.18.18,0,0,1,.13,0,.21.21,0,0,1,.13,0L5.67,7.37a2.81,2.81,0,0,0,4,0l.15-.15a2.8,2.8,0,0,0,.6-.89l1.47-3.45a2.41,2.41,0,0,1,.55-.83,2.47,2.47,0,0,1,1.76-.73m0-1.32a3.79,3.79,0,0,0-2.7,1.12,3.91,3.91,0,0,0-.84,1.27L9.2,5.81a1.75,1.75,0,0,1-.32.48l-.15.15a1.53,1.53,0,0,1-1.07.44A1.51,1.51,0,0,1,6.6,6.44L4.47,4.31a1.47,1.47,0,0,0-1.06-.44,1.49,1.49,0,0,0-1.07.44L0,6.65,11.35,18l2.34-2.34a1.5,1.5,0,0,0,0-2.13L11.56,11.4a1.52,1.52,0,0,1,0-2.13l.15-.14a1.39,1.39,0,0,1,.48-.32l3.42-1.46a3.74,3.74,0,0,0,1.44-1A3.81,3.81,0,0,0,14.19,0ZM.85,9.2,0,10.05l8,8,.85-.85L.85,9.2Z"/></g></symbol><symbol id="StampActive" viewBox="0 0 18 18"><g id="stamp_active"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M7.94,18,0,10.05,1.06,9l8,7.94Zm3.78-8.86a1.27,1.27,0,0,1,.47-.32l3.42-1.46a3.74,3.74,0,0,0,1.44-1,3.81,3.81,0,1,0-6.4-3.94L9.2,5.82a1.4,1.4,0,0,1-.32.47l-.15.15a1.5,1.5,0,0,1-2.13,0L4.48,4.31a1.52,1.52,0,0,0-2.13,0L.43,6.23,11.78,17.58l1.92-1.92a1.52,1.52,0,0,0,0-2.13l-2.13-2.12a1.5,1.5,0,0,1,0-2.13Z"/></g></symbol><symbol id="StatusBubble" viewBox="0 0 18 18">
<style type="text/css">
	.st0{fill:none;}
</style>
<g id="status_x5F_bubble">
	<rect y="0" class="st0" width="18" height="18"/>
	<g>
		<g>
			<circle cx="9" cy="9" r="9"/>
		</g>
	</g>
</g>
</symbol><symbol id="StatusConfirmation" viewBox="0 0 18 18">
<g id="status_x5F_confirmation_1_">
	<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M7.216,11.432L4.647,8.863L3.798,9.711l3.417,3.418l6.986-6.985l-0.849-0.848L7.216,11.432
		z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="StatusConfirmationActive" viewBox="0 0 18 18">
<g id="status_x5F_confirmation">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<g>
			<circle cx="9" cy="9" r="9"/>
		</g>
		<polygon style="fill:#FFFFFF;" points="7.216,13.129 3.798,9.711 4.647,8.863 7.216,11.432 13.353,5.296 14.202,6.143 		"/>
	</g>
</g>
</symbol><symbol id="StatusConfirmationDark" viewBox="0 0 18 18">
<g id="status_x5F_confirmation_x5F_ondark_1_">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path style="fill:#FFFFFF;" d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M7.216,13.553
		L3.586,9.924L4.859,8.65l2.357,2.357l5.925-5.925l1.272,1.273L7.216,13.553z"/>
</g>
</symbol><symbol id="StatusConfirmationLight" viewBox="0 0 18 18">
<g id="status_x5F_confirmation_x5F_onlight_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<circle style="fill:#00847F;" cx="9" cy="9" r="9"/>
	</g>
	<polygon style="fill:#FFFFFF;" points="7.216,13.553 3.586,9.924 4.859,8.65 7.216,11.008 13.141,5.083 14.414,6.356 	"/>
</g>
</symbol><symbol id="StatusError" viewBox="0 0 18 18">
<g id="status_x5F_error_1_">
	<path d="M17.891,15.8l-8.2-14.118C9.537,1.416,9.268,1.284,9,1.284S8.463,1.416,8.309,1.682L0.109,15.8
		C-0.2,16.333,0.184,17,0.8,17h16.4C17.816,17,18.2,16.333,17.891,15.8z M1.497,15.8L9,2.881L16.503,15.8H1.497z M8.4,11h1.2V6H8.4
		V11z M8,13.826c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1C8.448,12.826,8,13.274,8,13.826z"/>
	<g style="opacity:0.25;">
		<rect x="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="StatusErrorActive" viewBox="0 0 18 18">
<g id="status_x5F_error">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M8.309,1.682L0.109,15.8C-0.2,16.332,0.184,17,0.8,17h16.4c0.616,0,1-0.668,0.691-1.2l-8.2-14.118
			C9.383,1.151,8.617,1.151,8.309,1.682z"/>
		<path style="fill:#FFFFFF;" d="M9.6,5H8.4v6h1.2V5z M9,12.826c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1s1-0.448,1-1
			C10,13.274,9.552,12.826,9,12.826z"/>
	</g>
</g>
</symbol><symbol id="StatusErrorDark" viewBox="0 0 18 18">
<g id="status_x5F_error_x5F_ondark_1_">
	<rect x="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path style="fill:#FFFFFF;" d="M17.891,15.8l-8.2-14.118c-0.308-0.53-1.074-0.53-1.382,0L0.109,15.8C-0.2,16.333,0.184,17,0.8,17
		h16.4C17.816,17,18.2,16.333,17.891,15.8z M8.1,5h1.8v6H8.1V5z M9,14.826c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25
		s1.25,0.56,1.25,1.25S9.69,14.826,9,14.826z"/>
</g>
</symbol><symbol id="StatusErrorLight" viewBox="0 0 18 18">
<g id="status_x5F_error_x5F_onlight_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path style="fill:#A8000B;" d="M8.309,1.682L0.109,15.8C-0.2,16.332,0.184,17,0.8,17h16.4c0.616,0,1-0.668,0.691-1.2l-8.2-14.118
		C9.383,1.151,8.617,1.151,8.309,1.682z"/>
	<g>
		<rect x="8.1" y="5" style="fill:#FFFFFF;" width="1.8" height="6"/>
		<circle style="fill:#FFFFFF;" cx="9" cy="13.576" r="1.25"/>
	</g>
</g>
</symbol><symbol id="StatusFraudConfirmationDark" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="white"/>
  <path d="M7.21594 12.5529L3.58594 8.92395L4.85894 7.64995L7.21594 10.0079L13.1409 4.08295L14.4139 5.35595L7.21594 12.5529Z" fill="#333333"/>
</symbol><symbol id="StatusFraudConfirmationLight" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="#00847F"/>
  <path d="M7.21594 12.553L3.58594 8.92401L4.85894 7.65001L7.21594 10.008L13.1409 4.08301L14.4139 5.35601L7.21594 12.553Z" fill="white"/>
</symbol><symbol id="StatusFraudErrorDark" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2437 5.02232L11.9679 3.74652L8.99976 6.71462L6.03167 3.74652L4.75587 5.02232L7.72396 7.99042L4.75537 10.959L6.03117 12.2348L8.99976 9.26621L11.9684 12.2348L13.2442 10.959L10.2756 7.99042L13.2437 5.02232Z" fill="#333333"/>
</symbol><symbol id="StatusFraudErrorLight" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="#A8000B"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2441 5.02232L11.9683 3.74652L9.00009 6.71478L6.03182 3.74652L4.75603 5.02232L7.72429 7.99058L4.75586 10.959L6.03166 12.2348L9.00009 9.26638L11.9685 12.2348L13.2443 10.959L10.2759 7.99058L13.2441 5.02232Z" fill="white"/>
</symbol><symbol id="StatusFraudInfoDark" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="white"/>
  <path d="M10.25 4.24994C10.25 4.94029 9.69036 5.49994 9 5.49994C8.30964 5.49994 7.75 4.94029 7.75 4.24994C7.75 3.55958 8.30964 2.99994 9 2.99994C9.69036 2.99994 10.25 3.55958 10.25 4.24994Z" fill="#333333"/>
  <path d="M8.099 7.49994H9.899V13.4999H8.099V7.49994Z" fill="#333333"/>
</symbol><symbol id="StatusFraudInfoLight" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="#305A85"/>
  <path d="M10.25 4.25C10.25 4.94036 9.69036 5.5 9 5.5C8.30964 5.5 7.75 4.94036 7.75 4.25C7.75 3.55964 8.30964 3 9 3C9.69036 3 10.25 3.55964 10.25 4.25Z" fill="white"/>
  <path d="M8.099 7.5H9.899V13.5H8.099V7.5Z" fill="white"/>
</symbol><symbol id="StatusFraudWarningDark" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="white"/>
  <path d="M10.25 12.25C10.25 11.5596 9.69036 11 9 11C8.30964 11 7.75 11.5596 7.75 12.25C7.75 12.9404 8.30964 13.5 9 13.5C9.69036 13.5 10.25 12.9404 10.25 12.25Z" fill="#333333"/>
  <path d="M8.099 9H9.899V3H8.099V9Z" fill="#333333"/>
</symbol><symbol id="StatusFraudWarningLight" viewBox="0 0 18 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.031C0 11.711 3.803 16.5 9 18C14.197 16.5 18 11.711 18 6.031V0H0V6.031Z" fill="#FFBB33"/>
  <path d="M10.25 12.25C10.25 11.5596 9.69036 11 9 11C8.30964 11 7.75 11.5596 7.75 12.25C7.75 12.9404 8.30964 13.5 9 13.5C9.69036 13.5 10.25 12.9404 10.25 12.25Z" fill="#333333"/>
  <path d="M8.099 9H9.899V3H8.099V9Z" fill="#333333"/>
</symbol><symbol id="StatusIndeterminate" viewBox="0 0 18 18">
<g id="status_x5F_indeterminate_1_">
	<rect style="fill:none;" width="18" height="18"/>
	<rect y="8.4" width="18" height="1.199"/>
</g>
</symbol><symbol id="StatusIndeterminateThick" viewBox="0 0 18 18">
<g id="status_x5F_indeterminate_x5F_thick_1_">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<rect y="8.1" width="18" height="1.801"/>
</g>
</symbol><symbol id="StatusInformation" viewBox="0 0 18 18">
<g id="status_x5F_information_1_">
	<path d="M8.4,14.25h1.2v-7H8.4V14.25z M9.001,3.75c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S9.553,3.75,9.001,3.75z
		 M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="StatusInformationActive" viewBox="0 0 18 18">
<g id="status_x5F_information">
	<rect transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 18 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<g>
			<circle cx="9" cy="9" r="9"/>
		</g>
		<path style="fill:#FFFFFF;" d="M9.001,3.75c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1
			C10.001,4.198,9.553,3.75,9.001,3.75z M8.4,14.25h1.2v-7H8.4V14.25z"/>
	</g>
</g>
</symbol><symbol id="StatusInformationDark" viewBox="0 0 18 18">
<g id="status_x5F_information_x5F_ondark_1_">
	<rect y="0" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 18 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path style="fill:#FFFFFF;" d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M9.9,14.25H8.1v-6
		h1.8V14.25z M9.001,6.25c-0.69,0-1.25-0.56-1.25-1.25c0-0.69,0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25
		C10.251,5.69,9.691,6.25,9.001,6.25z"/>
</g>
</symbol><symbol id="StatusInformationLight" viewBox="0 0 18 18">
<g id="status_x5F_information_x5F_onlight_1_">
	<rect transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 18 18)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<circle style="fill:#305A85;" cx="9" cy="9" r="9"/>
	</g>
	<g>
		<circle style="fill:#FFFFFF;" cx="9.001" cy="5" r="1.25"/>
		<rect x="8.1" y="8.25" style="fill:#FFFFFF;" width="1.8" height="6"/>
	</g>
</g>
</symbol><symbol id="StatusNo" viewBox="0 0 18 18">
<g id="status_x5F_no_1_">
	<polygon points="16.424,2.424 15.576,1.576 9,8.152 2.424,1.576 1.576,2.424 8.152,9 1.576,15.576 2.424,16.424 9,9.848 
		15.576,16.424 16.424,15.576 9.848,9 	"/>
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="StatusNoThick" viewBox="0 0 18 18">
<g id="status_x5F_no_x5F_thick_1_">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<polygon points="16.636,2.637 15.364,1.363 9,7.727 2.636,1.363 1.364,2.637 7.727,9 1.364,15.363 2.636,16.637 9,10.273 
		15.364,16.637 16.636,15.363 10.273,9 	"/>
</g>
</symbol><symbol id="StatusWarning" viewBox="0 0 18 18">
<g id="status_x5F_warning_1_">
	<path d="M9.6,3.75H8.4v7h1.2V3.75z M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,16.8
		c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M8.999,12.25c-0.552,0-1,0.448-1,1
		c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1C9.999,12.698,9.552,12.25,8.999,12.25z"/>
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
</g>
</symbol><symbol id="StatusWarningActive" viewBox="0 0 18 18">
<g id="status_x5F_warning">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<g>
			<circle cx="9" cy="9" r="9"/>
		</g>
		<path style="fill:#FFFFFF;" d="M8.999,12.25c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1S9.552,12.25,8.999,12.25z
			 M9.6,3.75H8.4v7h1.2V3.75z"/>
	</g>
</g>
</symbol><symbol id="StatusWarningAmber" viewBox="0 0 18 18">
<g id="status_x5F_warning_x5F_onamber_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<circle style="fill:#FFFFFF;" cx="9" cy="9" r="9"/>
	</g>
	<g>
		<circle cx="8.999" cy="13" r="1.25"/>
		<rect x="8.1" y="3.75" width="1.8" height="6"/>
	</g>
</g>
</symbol><symbol id="StatusWarningDark" viewBox="0 0 18 18">
<g id="status_x5F_warning_x5F_ondark_1_">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path style="fill:#FFFFFF;" d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M8.1,3.75h1.8v6
		H8.1V3.75z M8.999,14.25c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25S9.69,14.25,8.999,14.25z"/>
</g>
</symbol><symbol id="StatusWarningLight" viewBox="0 0 18 18">
<style type="text/css">
	.st0{fill:none;}
	.st1{fill:#FFBB33;}
</style>
<g id="status_x5F_warning_x5F_onlight_1_">
	<rect y="0" class="st0" width="18" height="18"/>
	<g>
		<circle class="st1" cx="9" cy="9" r="9"/>
	</g>
	<g>
		<circle cx="9" cy="13" r="1.2"/>
		<rect x="8.1" y="3.8" width="1.8" height="6"/>
	</g>
</g>
</symbol><symbol id="StatusYes" viewBox="0 0 18 18">
<g id="status_x5F_yes_1_">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<polygon points="5.826,15.685 0.076,9.935 0.924,9.088 5.826,13.988 17.076,2.739 17.924,3.587 	"/>
</g>
</symbol><symbol id="StatusYesThick" viewBox="0 0 18 18">
<g id="status_x5F_yes_x5F_thick_1_">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<polygon points="5.916,15.942 0.106,10.134 1.378,8.86 5.916,13.397 16.622,2.693 17.894,3.967 	"/>
</g>
</symbol><symbol id="Subtract" viewBox="0 0 18 18">
<g id="subtract">
	<rect style="fill:none;" width="18" height="18"/>
	<rect y="8.4" width="18" height="1.199"/>
</g>
</symbol><symbol id="SubtractCircle" viewBox="0 0 18 18">
<g id="subtract_x5F_circle">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.03,0,0,4.03,0,9s4.03,9,9,9s9-4.03,9-9S13.97,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8S4.699,1.2,9,1.2
		s7.8,3.499,7.8,7.8S13.301,16.8,9,16.8z M4,9.6h10V8.4H4V9.6z"/>
</g>
</symbol><symbol id="SubtractCircleActive" viewBox="0 0 18 18">
<g id="subtract_x5F_circle_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M14,9.9H4V8.1h10V9.9z"/>
	</g>
</g>
</symbol><symbol id="Survey" viewBox="0 0 18 18"><title>survey</title><polygon points="17.05 5.88 12.4 10.53 10.43 8.56 9.48 9.51 12.4 12.43 18 6.84 17.05 5.88"/><path d="M3.2,6.06v4.25H7.46V6.06Zm3.3,3.3H4.15V7H6.5Z" transform="translate(0 0)"/><path d="M3.2,11.3v4.25H7.46V11.3Zm3.3,3.3H4.15V12.25H6.5Z" transform="translate(0 0)"/><path d="M13.9,12.64v4.25H1.15V9.45h0V3.06H3.71V4.8h7.64V3.06H13.9V7.33L15,6.2V1.91H11.3L9.44,0H5.62L3.7,1.91H0V18H15V11.41Zm-9-10.26L6.09,1.15H9l1.2,1.23V3.66H4.85Z" transform="translate(0 0)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="Tag" viewBox="0 0 18 18"><g id="tag"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M10.34,7.72H7.54l-.26,2.4h2.79ZM7.9,4.5l-.22,2h2.79l.23-2h1.2l-.23,2h1.84l-.13,1.2H11.54l-.27,2.4h1.86L13,11.32H11.14L10.9,13.5H9.7l.24-2.18H7.14L6.9,13.5H5.7l.24-2.18H4l.13-1.2h2l.26-2.4H4.4l.13-1.2h2l.22-2ZM9,1.2A7.8,7.8,0,1,0,16.8,9,7.8,7.8,0,0,0,9,1.2ZM9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"/></g></symbol><symbol id="TagActive" viewBox="0 0 18 18"><g id="tagActive"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M10.34,7.72H7.54l-.27,2.4h2.8ZM7.9,4.5l-.22,2h2.8l.22-2h1.2l-.23,2h1.84l-.13,1.2H11.54l-.26,2.4h1.85L13,11.32H11.14L10.9,13.5H9.7l.24-2.18H7.14L6.9,13.5H5.7l.24-2.18H4l.13-1.2h2l.26-2.4H4.4l.13-1.2H6.47l.23-2ZM9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"/></g></symbol><symbol id="Task" viewBox="0 0 18 18">
<g id="task">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M8,8.2h5V7H8V8.2z M5,8.2h1.2V7H5V8.2z M8,11.2h5V10H8V11.2z M5,11.2h1.2V10H5V11.2z M8,14.2h5V13H8V14.2z M5,14.2h1.2V13
		H5V14.2z M13,2l-2-2H7L5,2l0,0v0H1v16h16V2H13z M6.2,2.497L7.497,1.2h3.006L11.8,2.497V3.8H6.2L6.2,2.497z M15.8,16.8H2.2V3.2H5V5
		h8V3.2h2.8V16.8z"/>
</g>
</symbol><symbol id="TaskActive" viewBox="0 0 18 18">
<g id="task_x5F_active">
	<rect style="fill:none;" width="18" height="18"/>
	<g>
		<polygon points="13,2 11,0 7,0 5,2 5,2 5,3 13,3 		"/>
		<path d="M14.5,2v2.5h-11l0-2.5H1v16h16V2H14.5z M5.5,15H4v-1.5h1.5V15z M5.5,11.75H4v-1.5h1.5V11.75z M5.5,8.5H4V7h1.5V8.5z
			 M14,15H7v-1.5h7V15z M14,11.75H7v-1.5h7V11.75z M14,8.5H7V7h7V8.5z"/>
	</g>
</g>
</symbol><symbol id="Time" viewBox="0 0 18 18">
<g id="time">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.03,0,0,4.029,0,9c0,4.971,4.03,9,9,9s9-4.029,9-9C18,4.029,13.97,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		c0-4.301,3.499-7.8,7.8-7.8s7.8,3.499,7.8,7.8C16.8,13.301,13.301,16.8,9,16.8z M9.6,3H8.4v6.6H13V8.4H9.6V3z"/>
</g>
</symbol><symbol id="TimeActive" viewBox="0 0 18 18">
<g id="time_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M13,9.75H8.25V3h1.5v5.25H13V9.75z"/>
</g>
</symbol><symbol id="TouchContract" viewBox="0 0 18 18"><title>Touch contract</title><path d="M7.66,2.37a.79.79,0,0,1,.57.23L10.8,5.18V6.83l.82.27,5,1.66A.3.3,0,0,1,16.8,9v6A1.8,1.8,0,0,1,15,16.8H11.66a2.78,2.78,0,0,1-2-.82L6,12.32a.8.8,0,0,1,1.13-1.13l2,2V5.84l-.35-.35L7.09,3.73a.8.8,0,0,1,.57-1.37m0-1.2a2,2,0,0,0-1.41.59h0a2,2,0,0,0,0,2.83h0L8,6.34v4a2,2,0,0,0-2.83,0h0a2,2,0,0,0,0,2.83h0l3.66,3.66A4,4,0,0,0,11.66,18H15a3,3,0,0,0,3-3V9a1.5,1.5,0,0,0-1-1.42L12,6V4.68L9.07,1.75A2,2,0,0,0,7.66,1.16Z" transform="translate(0 0)"/><polygon points="5 8.65 2.5 6.15 0 8.65 0 10.41 2 8.45 2 12 3 12 3 8.45 5 10.41 5 8.65"/><polygon points="5 1.59 3 3.55 3 0 2 0 2 3.55 0 1.59 0 3.33 2.51 5.85 5 3.34 5 1.59"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchDragDoubleFinger" viewBox="0 0 18 18"><title>Touch drag double finger</title><polygon points="15.48 0 13.88 0 15.79 2 13.19 2 13.19 3.1 15.69 3.1 13.88 5 15.48 5 17.98 2.5 15.48 0"/><polygon points="4.82 2 2.21 2 4.12 0 2.52 0 0.01 2.5 2.52 5 4.12 5 2.31 3.1 4.82 3.1 4.82 2"/><path d="M15.49,8.57l-2.84-.95V4.13a2.07,2.07,0,0,0-2-2.13h-.07A2.06,2.06,0,0,0,9,2.67a2.08,2.08,0,0,0-3.6,1.4v6L5,9.65a2.09,2.09,0,1,0-3,2.92H2l4.22,4.22a4.14,4.14,0,0,0,3,1.21h4.49a3.1,3.1,0,0,0,3.1-3.1h0V10.48A2.07,2.07,0,0,0,15.49,8.57Zm.05,6.33a1.86,1.86,0,0,1-1.86,1.86H9.19a2.88,2.88,0,0,1-2-.85L2.93,11.69A.83.83,0,0,1,4.1,10.52l.43.43,2.12,2.12V4.13a.9.9,0,0,1,.65-.91h.18a.82.82,0,0,1,.62.29l.31.36V8.3H9.65V3.85L10,3.49a.82.82,0,0,1,.62-.29h.18a.9.9,0,0,1,.65.91v4.4l.85.28,2.8.93a.82.82,0,0,1,.49.76Z"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchExpand" viewBox="0 0 18 18"><title>Touch expand</title><path d="M7.66,2.34a.79.79,0,0,1,.57.23L10.8,5.15V6.8l.82.27,5,1.66A.3.3,0,0,1,16.8,9v6a1.8,1.8,0,0,1-1.8,1.8H11.66a2.78,2.78,0,0,1-2-.82L6,12.29a.8.8,0,0,1,1.13-1.13l2,2V5.81l-.35-.35L7.09,3.7a.8.8,0,0,1,.57-1.37m0-1.2a2,2,0,0,0-1.41.59h0a2,2,0,0,0,0,2.83h0L8,6.31v4a2,2,0,0,0-2.83,0h0a2,2,0,0,0,0,2.83h0L8.83,16.8A4,4,0,0,0,11.66,18H15a3,3,0,0,0,3-3V9a1.5,1.5,0,0,0-1-1.42L12,6V4.65L9.07,1.72A2,2,0,0,0,7.66,1.13Z" transform="translate(0 0)"/><polygon points="5 7.57 3 9.53 3 6.88 3 4.97 3 2.33 5 4.28 5 2.54 2.49 0.03 0 2.52 0 4.28 2 2.33 2 4.97 2 6.88 2 9.53 0 7.57 0 9.3 2.51 11.82 5 9.32 5 7.57"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchSwipe" viewBox="0 0 18 18"><title>Touch swipe</title><polygon points="3.6 0 2 0 3.9 2 0 2 0 3.1 3.8 3.1 2 5 3.6 5 6.1 2.5 3.6 0"/><path d="M16.71,8.61l-2.83-.95-3.09-1V4.1a2.06,2.06,0,1,0-4.12,0v6l-.4-.4a2.14,2.14,0,0,0-1.51-.63,2,2,0,0,0-1.38.54,2.06,2.06,0,0,0-.05,3l4.2,4.2A4.12,4.12,0,0,0,10.44,18h4.47A3.09,3.09,0,0,0,18,14.91V10.52A2.06,2.06,0,0,0,16.71,8.61Zm.05,6.3a1.86,1.86,0,0,1-1.85,1.85H10.44a2.86,2.86,0,0,1-2-.84l-4.2-4.2a.82.82,0,0,1,0-1.19.78.78,0,0,1,.54-.21.91.91,0,0,1,.64.26l.4.4L7.91,13.1v-9a.82.82,0,1,1,1.65,0V7.52l.84.28,3.09,1,2.79.93a.82.82,0,0,1,.49.75Z" transform="translate(0 0)"/></symbol><symbol id="TouchSwipeDown" viewBox="0 0 18.01 18"><title>Touch swipe down</title><polygon points="0 3 2 5 4 3 4 1.6 2.5 3.2 2.5 0 1.5 0 1.5 3.2 0 1.6 0 3"/><path d="M17.16,9.94,13.63,6.4A1.9,1.9,0,0,0,11.54,6L6.39,8.57,4.14,6.32A1.9,1.9,0,0,0,1.45,9l5.19,5.2H6.08a1.9,1.9,0,1,0,0,3.8h5.48a3.8,3.8,0,0,0,2.69-1.11L17.16,14a2.85,2.85,0,0,0,0-4Zm-.81,3.23-2.92,2.92a2.64,2.64,0,0,1-1.88.78H6.08a.76.76,0,0,1,0-1.52H9.4l-1.95-2L2.26,8.2A.76.76,0,0,1,3.33,7.12h0L5.58,9.37l.58.58.74-.37L12,7a.76.76,0,0,1,.81.17l3.54,3.54a1.71,1.71,0,0,1,0,2.42h0Z" transform="translate(0 0)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchSwipeLeft" viewBox="0 0 18 18"><g id="touchSwipeLeft"><rect id="Bounding_box" data-name="Bounding box" class="cls-1" width="18" height="18"/><path class="cls-2" d="M9,2.49a2,2,0,0,1,2,2h0V7l3,1,2.69.89a2.15,2.15,0,0,1,1.29,1.89h0V15a2.93,2.93,0,0,1-3,3H10.64a3.93,3.93,0,0,1-2.78-1.19h0L3.78,12.73a2,2,0,0,1,0-2.88,1.88,1.88,0,0,1,1.29-.5,2,2,0,0,1,1.49.59h0l.4.3V4.48A2,2,0,0,1,9,2.49ZM9,3.68a.86.86,0,0,0-.8.8h0v8.65l-2-2-.4-.4a.71.71,0,0,0-.6-.3.65.65,0,0,0-.5.2.89.89,0,0,0-.29.6.73.73,0,0,0,.19.59h0l4.08,4.08a3,3,0,0,0,2,.8h4.28a1.79,1.79,0,0,0,1.79-1.79h0V10.74a.75.75,0,0,0-.5-.7h0l-2.69-.89-3-1-.79-.29V4.48A.86.86,0,0,0,9,3.68ZM4.08,0,2.19,2H6.76V3H2.29L4.08,5H2.49L0,2.49,2.49,0Z"/></g></symbol><symbol id="TouchSwipeRight" viewBox="0 0 18 18"><g id="touchSwipeRight"><rect id="Container" class="cls-1" width="17.9" height="18"/><path class="cls-2" d="M6.07,2.5,3.58,5H2L3.78,3.1H0V2H3.88L2,0H3.58ZM18,10.5v4.4h0A3.1,3.1,0,0,1,14.92,18H10.44a4,4,0,0,1-2.88-1.2L3.38,12.6l-.1-.1a2.07,2.07,0,0,1,.1-2.9,2.38,2.38,0,0,1,1.39-.5,2.2,2.2,0,0,1,1.5.6l.39.4v-6h0a2,2,0,0,1,2-2.1,2.1,2.1,0,0,1,2.09,2.1V6.6l3.08,1,2.79,1A2.33,2.33,0,0,1,18,10.5Zm-1.39,0a.79.79,0,0,0-.5-.8l-2.78-.9-3.09-1-.79-.3V4.1a.86.86,0,0,0-.8-.8.78.78,0,0,0-.79.8v9L5.77,11l-.5-.4a.71.71,0,0,0-.6-.3.76.76,0,0,0-.49.2h0a.91.91,0,0,0,0,1.2l4.17,4.2a2.79,2.79,0,0,0,2,.8h4.48a1.81,1.81,0,0,0,1.89-1.8Z"/></g></symbol><symbol id="TouchSwipeUp" viewBox="0 0 18.01 18"><title>Touch swipe up</title><polygon points="4 2 2 0 0 2 0 3.4 1.5 1.8 1.5 5 2.5 5 2.5 1.8 4 3.4 4 2"/><path d="M17.16,9.94,13.63,6.4A1.9,1.9,0,0,0,11.54,6L6.39,8.57,4.14,6.32A1.9,1.9,0,0,0,1.45,9l5.19,5.2H6.08a1.9,1.9,0,1,0,0,3.8h5.48a3.8,3.8,0,0,0,2.69-1.11L17.16,14a2.85,2.85,0,0,0,0-4Zm-.81,3.23-2.92,2.92a2.64,2.64,0,0,1-1.88.78H6.08a.76.76,0,0,1,0-1.52H9.4l-1.95-2L2.26,8.2A.76.76,0,0,1,3.33,7.12h0L5.58,9.37l.58.58.74-.37L12,7a.76.76,0,0,1,.81.17l3.54,3.54a1.71,1.71,0,0,1,0,2.42h0Z" transform="translate(0 0)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchTap" viewBox="0 0 18 18"><title>Touch tap</title><path d="M7.52,4.66a.75.75,0,0,1,.75.75v3.1L9,8.77l2.8.93,2.52.84a.74.74,0,0,1,.44.68v4a1.68,1.68,0,0,1-1.68,1.68h-4a2.59,2.59,0,0,1-1.88-.78l-3.8-3.8a.75.75,0,0,1,0-1.06h0a.71.71,0,0,1,.49-.19.82.82,0,0,1,.58.24l.36.36,1.91,1.91V5.41a.75.75,0,0,1,.75-.75m0-1.12A1.87,1.87,0,0,0,5.66,5.41v5.45L5.3,10.5A1.94,1.94,0,0,0,3.94,10a1.83,1.83,0,0,0-1.25.49,1.87,1.87,0,0,0,0,2.64l0,0,3.8,3.8a3.73,3.73,0,0,0,2.59,1h4.05a2.8,2.8,0,0,0,2.8-2.8h0v-4a1.87,1.87,0,0,0-1.17-1.73l-2.56-.8-2.8-.93V5.41A1.87,1.87,0,0,0,7.52,3.54Z"/><rect x="6.97" width="1.05" height="2.62"/><rect x="2.12" y="4.22" width="2.62" height="1.05"/><rect x="10.4" y="4.22" width="2.62" height="1.05"/><rect x="4.31" y="0.85" width="1.05" height="2.62" transform="translate(-0.11 4.05) rotate(-45)"/><rect x="8.98" y="1.63" width="2.62" height="1.05" transform="translate(1.49 7.91) rotate(-45)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="TouchTapDoubleFinger" viewBox="0 0 18 18"><title>Touch tap double finger</title><rect x="2.21" y="4.49" width="2.36" height="1.03"/><rect x="13.23" y="4.49" width="2.32" height="1.03"/><rect x="4.26" y="1.2" width="1.03" height="2.56" transform="translate(-0.35 4.11) rotate(-45)"/><rect x="8.96" y="0.84" width="2.56" height="1.03" transform="translate(7.31 11.26) rotate(-81.07)"/><rect x="7.04" y="0.06" width="1.03" height="2.56" transform="translate(-0.12 1.19) rotate(-8.93)"/><rect x="11.71" y="1.97" width="2.56" height="1.03" transform="translate(2.05 9.91) rotate(-45)"/><path d="M14.64,9.66l-2.52-.84V5.73a1.83,1.83,0,0,0-1.75-1.91h-.08a1.82,1.82,0,0,0-1.37.63,1.82,1.82,0,0,0-1.37-.63,1.89,1.89,0,0,0-.37,0A1.89,1.89,0,0,0,5.72,5.73V11l-.38-.38A1.83,1.83,0,0,0,2.75,13.2l3.73,3.73A3.66,3.66,0,0,0,9.06,18h4a2.74,2.74,0,0,0,2.74-2.74v-3.9A1.83,1.83,0,0,0,14.64,9.66Zm0,5.6A1.65,1.65,0,0,1,13,16.91H9a2.55,2.55,0,0,1-1.78-.76L3.52,12.42a.73.73,0,0,1,1-1l.38.38,1.91,1.85V5.73a.8.8,0,0,1,.58-.8h.16a.72.72,0,0,1,.55.26l.28.32V9.42h1.1V5.49l.28-.32a.72.72,0,0,1,.55-.26h.16a.8.8,0,0,1,.58.8v3.9l.75.25,2.48.83a.73.73,0,0,1,.43.67Z"/><rect class="cls-1" x="0.01" width="18" height="18"/></symbol><symbol id="TouchWipeDoubleFinger" viewBox="0 0 18.02 18"><title>Touch swipe double finger</title><polygon points="3.62 0 2.02 0 3.92 2 0.01 2 0.01 3.1 3.81 3.1 2.02 5 3.62 5 6.12 2.5 3.62 0"/><path d="M16.69,8.53l-2.86-1V4.08a2.07,2.07,0,0,0-2-2.18h-.12a2.06,2.06,0,0,0-1.56.72A2.07,2.07,0,0,0,6.55,4s0,.08,0,.12v6l-.43-.43a2.08,2.08,0,0,0-2.94,2.94l4.23,4.19A4.15,4.15,0,0,0,10.36,18h4.51A3.12,3.12,0,0,0,18,14.91V10.46A2.08,2.08,0,0,0,16.69,8.53Zm0,6.35a1.87,1.87,0,0,1-1.87,1.87H10.36A2.89,2.89,0,0,1,8.3,15.9L4.07,11.67A.83.83,0,0,1,5.25,10.5l.43.43,2.13,2.13v-9a.9.9,0,0,1,.65-.91h.18a.82.82,0,0,1,.62.29l.32.36V8.26h1.24V3.8l.32-.36a.82.82,0,0,1,.62-.29h.18a.9.9,0,0,1,.65.91v4.4l.85.28,2.81.94a.83.83,0,0,1,.49.76Z" transform="translate(0 0)"/><rect class="cls-1" width="18" height="18"/></symbol><symbol id="Trade" viewBox="0 0 18 18">
<g id="trade">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M1.2,8.999c0-3.968,2.981-7.247,6.819-7.731L9.151,2.4L7.948,3.603C5.414,4.094,3.5,6.322,3.5,9
		c0,2.318,1.435,4.296,3.464,5.106l0.959-0.959C6.075,12.665,4.7,10.997,4.7,9c0-2.193,1.656-3.987,3.78-4.247L10.849,2.4
		L8.413,0.029C3.717,0.333,0,4.227,0,8.999c0,4.575,3.417,8.345,7.837,8.916l-1.65-1.65C3.274,15.134,1.2,12.307,1.2,8.999z
		 M10.164,0.083l1.65,1.65C14.726,2.865,16.8,5.691,16.8,8.999c0,3.968-2.98,7.246-6.819,7.731l-1.133-1.132l1.201-1.202
		C12.585,13.906,14.5,11.678,14.5,9c0-2.318-1.436-4.297-3.465-5.106l-0.959,0.959C11.925,5.334,13.3,7.002,13.3,9
		c0,2.193-1.657,3.988-3.781,4.247l-2.368,2.352l2.436,2.371C14.283,17.666,18,13.771,18,8.999C18,4.424,14.583,0.655,10.164,0.083z
		"/>
</g>
</symbol><symbol id="TradeActive" viewBox="0 0 18 18">
<g id="trade_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M5.283,15.574l2.319-2.319C5.806,12.665,4.5,10.994,4.5,9c0-2.302,1.736-4.179,3.966-4.446l2.13-2.129L8.211,0.039
			C3.611,0.439,0,4.295,0,8.999c0,4.488,3.289,8.199,7.586,8.878L5.283,15.574z"/>
		<path d="M10.414,0.121l2.303,2.303l-2.319,2.319C12.194,5.333,13.5,7.005,13.5,9c0,2.303-1.736,4.18-3.967,4.446l-2.128,2.128
			l2.385,2.385C14.39,17.559,18,13.703,18,8.999C18,4.511,14.711,0.801,10.414,0.121z"/>
	</g>
</g>
</symbol><symbol id="TradeFinance" viewBox="0 0 18 18">
<g id="trade_x5F_finance">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M10.164,0.083l1.65,1.65C14.726,2.865,16.8,5.691,16.8,8.999c0,3.968-2.98,7.246-6.819,7.731l-1.133-1.132l1.201-1.202
		C12.585,13.906,14.5,11.678,14.5,9c0-2.318-1.436-4.297-3.465-5.106l-0.959,0.959C11.925,5.334,13.3,7.002,13.3,9
		c0,2.193-1.657,3.988-3.781,4.247l-2.368,2.352l2.436,2.371C14.283,17.666,18,13.771,18,8.999C18,4.424,14.583,0.655,10.164,0.083z
		 M1.2,8.999c0-3.968,2.981-7.247,6.819-7.731L9.151,2.4L7.948,3.603C5.414,4.094,3.5,6.322,3.5,9c0,2.318,1.435,4.296,3.464,5.106
		l0.959-0.959C6.075,12.665,4.7,10.997,4.7,9c0-2.193,1.656-3.987,3.78-4.247L10.849,2.4L8.413,0.029C3.717,0.333,0,4.227,0,8.999
		c0,4.575,3.417,8.345,7.837,8.916l-1.65-1.65C3.274,15.134,1.2,12.307,1.2,8.999z M8.579,5.908v0.477
		C7.709,6.539,7.15,7.128,7.15,7.953c0,1.114,0.993,1.422,1.464,1.567l0.406,0.13l0.004,0.002C9.65,9.847,9.65,9.942,9.65,10.075
		c0,0.371-0.483,0.411-0.69,0.411c-0.604,0-0.608-0.229-0.609-0.339l-1.2,0.018c0.012,0.811,0.561,1.369,1.429,1.494v0.431H9.51
		v-0.468c0.817-0.178,1.34-0.751,1.34-1.547c0-1.111-0.992-1.421-1.468-1.569l0,0.001l-0.407-0.13C8.35,8.183,8.35,8.086,8.35,7.953
		c0-0.371,0.483-0.411,0.69-0.411c0.604,0,0.608,0.229,0.609,0.339l1.2-0.018c-0.012-0.782-0.525-1.325-1.34-1.474v-0.48H8.579z"/>
</g>
</symbol><symbol id="TradeFinanceActive" viewBox="0 0 18 18">
<g id="trade_x5F_finance_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M7.602,13.255C5.806,12.665,4.5,10.994,4.5,9c0-2.302,1.736-4.179,3.966-4.446l2.13-2.129L8.211,0.039
		C3.611,0.439,0,4.295,0,8.999c0,4.488,3.289,8.199,7.586,8.878l-2.303-2.303L7.602,13.255z M10.414,0.121l2.303,2.303l-2.319,2.319
		C12.194,5.333,13.5,7.005,13.5,9c0,2.303-1.736,4.18-3.967,4.446l-2.128,2.128l2.385,2.385C14.39,17.559,18,13.703,18,8.999
		C18,4.511,14.711,0.801,10.414,0.121z M8.579,5.908v0.478C7.709,6.539,7.15,7.128,7.15,7.953c0,1.114,0.993,1.422,1.464,1.567
		l0.406,0.13l0.004,0.002C9.65,9.847,9.65,9.942,9.65,10.075c0,0.371-0.483,0.411-0.69,0.411c-0.604,0-0.608-0.229-0.609-0.339
		l-1.2,0.018c0.012,0.811,0.561,1.369,1.429,1.494v0.431H9.51v-0.468c0.817-0.178,1.34-0.75,1.34-1.546
		c0-1.111-0.992-1.421-1.468-1.569l0,0l-0.407-0.13C8.35,8.183,8.35,8.086,8.35,7.953c0-0.371,0.483-0.411,0.69-0.411
		c0.604,0,0.608,0.229,0.609,0.339l1.2-0.018c-0.012-0.782-0.525-1.325-1.34-1.475v-0.48H8.579z"/>
</g>
</symbol><symbol id="Transfer" viewBox="0 0 18 18">
<g id="transfer">
	
		<rect y="0" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 18 5.458745e-12)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.971,4.029,9,9,9s9-4.029,9-9C18,4.029,13.971,0,9,0z M9,16.8c-4.301,0-7.8-3.499-7.8-7.8
		c0-4.301,3.499-7.8,7.8-7.8s7.8,3.499,7.8,7.8C16.8,13.301,13.301,16.8,9,16.8z M9.302,9h1.697l3-3l-3-3H9.302l2.4,2.4H4V6.6h7.702
		L9.302,9z M8.698,9H7.002l-3,3l3,3h1.697l-2.4-2.4H14V11.4H6.298L8.698,9z"/>
</g>
</symbol><symbol id="TransferActive" viewBox="0 0 18 18">
<g id="transfer_x5F_active">
	
		<rect y="0" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 18 4.001954e-11)" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.97,4.029,9,9,9s9-4.03,9-9C18,4.029,13.971,0,9,0z M14,12.75H6.661L8.911,15H6.79l-3-3l3-3
		h2.121l-2.25,2.25H14V12.75z M11.21,9H9.089l2.25-2.25H4v-1.5h7.339L9.089,3h2.121l3,3L11.21,9z"/>
</g>
</symbol><symbol id="TransferGlobal" viewBox="0 0 18 18">
<g id="transfer_x5F_global">
	<rect y="0" style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9,0C4.029,0,0,4.029,0,9c0,4.971,4.029,9,9,9s9-4.029,9-9C18,4.029,13.971,0,9,0z M16.77,8.4h-2.8
		c-0.136-2.854-1.214-5.345-2.821-6.892C14.222,2.391,16.518,5.111,16.77,8.4z M9.6,16.221V9.6h3.166
		C12.613,12.549,11.363,15.044,9.6,16.221z M9.6,8.4V1.779c1.763,1.177,3.013,3.672,3.166,6.622H9.6z M1.23,9.6h4.321l-2.4,2.4
		h1.697l3.001-3L4.848,6H3.151l2.4,2.4H1.23C1.523,4.578,4.578,1.523,8.4,1.23V16.77C4.578,16.476,1.523,13.422,1.23,9.6z
		 M11.149,16.492c1.607-1.547,2.685-4.038,2.821-6.892h2.8C16.518,12.888,14.222,15.609,11.149,16.492z"/>
</g>
</symbol><symbol id="TransferGlobalActive" viewBox="0 0 18 18">
<g id="transfer_x5F_global_x5F_active">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<g>
		<path d="M14.708,8.25h3.254c-0.337-4.071-3.378-7.368-7.326-8.094C12.906,1.677,14.506,4.698,14.708,8.25z"/>
		<path d="M9.75,1.344V8.25h3.456C13.011,5.164,11.654,2.562,9.75,1.344z"/>
		<path d="M9.75,9.75v6.906c1.904-1.218,3.261-3.821,3.456-6.906H9.75z"/>
		<path d="M8.25,0.038C3.879,0.399,0.399,3.879,0.038,8.25h5.151l-2.22-2.22L3,6v0h2.06l3,3l-3,3H3v0L2.969,11.97l2.22-2.22H0.038
			c0.362,4.371,3.841,7.851,8.212,8.212V0.038z M4,5l0.03-0.03L4.06,5H4z M4.03,13.03L4,13H4.06L4.03,13.03z"/>
		<path d="M14.708,9.75c-0.202,3.552-1.802,6.573-4.072,8.094c3.948-0.726,6.989-4.023,7.326-8.094H14.708z"/>
	</g>
</g>
</symbol><symbol id="Travel" viewBox="0 0 18 18">
<g id="travel_1_">
	<path d="M16.5,3.5H13V2c0-0.825-0.675-1.5-1.5-1.5h-5C5.675,0.5,5,1.175,5,2v1.5H1.5C0.675,3.5,0,4.175,0,5v11
		c0,0.825,0.675,1.5,1.5,1.5h15c0.825,0,1.5-0.675,1.5-1.5V5C18,4.175,17.325,3.5,16.5,3.5z M13.8,10.3h-2.6V6.964l1.3-1.3l1.3,1.3
		V10.3z M10,6.467V11.5h3.8v4.8H5.2V4.7h6.567L10,6.467z M6.2,2c0-0.163,0.137-0.3,0.3-0.3h5c0.163,0,0.3,0.137,0.3,0.3v1.5H6.2V2z
		 M1.2,16V5c0-0.163,0.137-0.3,0.3-0.3H4v11.6H1.5C1.337,16.3,1.2,16.163,1.2,16z M16.8,16c0,0.163-0.137,0.3-0.3,0.3H15V6.467
		L13.233,4.7H16.5c0.163,0,0.3,0.137,0.3,0.3V16z"/>
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="TravelActive" viewBox="0 0 18 18">
<g id="travel_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<polygon points="11.5,7.088 11.5,10 13.5,10 13.5,7.088 12.5,6.088 		"/>
		<path d="M16.5,3.5H13V2c0-0.825-0.675-1.5-1.5-1.5h-5C5.675,0.5,5,1.175,5,2v1.5H1.5C0.675,3.5,0,4.175,0,5v11
			c0,0.825,0.675,1.5,1.5,1.5H4V4.713h1.5V17.5h8v-6H10V6.467l2.5-2.5l2.5,2.5V17.5h1.5c0.825,0,1.5-0.675,1.5-1.5V5
			C18,4.175,17.325,3.5,16.5,3.5z M11.8,3.5H6.2V2c0-0.163,0.137-0.3,0.3-0.3h5c0.163,0,0.3,0.137,0.3,0.3V3.5z"/>
	</g>
</g>
</symbol><symbol id="Upload" viewBox="0 0 18 18">
<g id="upload">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M15.8,12v3.8H2.2V12H1v5h16v-5H15.8z M8.4,13.849h1.2V3.297l4.4,4.4V6.001L9,1L4,6.001v1.697l4.4-4.4V13.849z"/>
</g>
</symbol><symbol id="User" viewBox="0 0 18 18">
<g id="user_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.191,12.775c-0.198-0.489-0.478-0.944-0.846-1.322c-0.875-0.901-1.97-1.583-3.262-2.002l-3.073,3.073L5.932,9.445
		c-1.299,0.419-2.399,1.103-3.278,2.008c-0.368,0.379-0.648,0.833-0.846,1.322L0,17.25h18L16.191,12.775z M2.921,13.225
		c0.149-0.368,0.349-0.683,0.594-0.935c0.595-0.613,1.305-1.099,2.115-1.45l2.533,2.533l0.849,0.848l0.848-0.848l2.526-2.526
		c0.804,0.35,1.508,0.834,2.099,1.443c0.245,0.252,0.445,0.567,0.594,0.936l1.142,2.825H1.779L2.921,13.225z M9.01,9.25
		c2.449,0,3.49-2.298,3.49-4.359c0-2.14-1.021-4.141-3.49-4.141c-2.469,0-3.51,1.982-3.51,4.141C5.5,7.011,6.52,9.25,9.01,9.25z
		 M9.01,1.95c2.067,0,2.29,2.057,2.29,2.941c0,1.173-0.482,3.159-2.29,3.159c-2.199,0-2.31-2.631-2.31-3.159
		C6.7,4.007,6.925,1.95,9.01,1.95z"/>
</g>
</symbol><symbol id="UserActive" viewBox="0 0 18 18">
<g id="user_x5F_active_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.191,12.775c-0.198-0.489-0.478-0.944-0.846-1.322c-0.875-0.901-1.97-1.583-3.262-2.002l-3.073,3.073L5.932,9.445
		c-1.299,0.419-2.399,1.103-3.278,2.008c-0.368,0.378-0.648,0.833-0.845,1.322L0,17.25h18L16.191,12.775z M9.01,9.25
		c2.449,0,3.49-2.298,3.49-4.359c0-2.14-1.02-4.141-3.49-4.141c-2.469,0-3.51,1.981-3.51,4.141C5.5,7.011,6.52,9.25,9.01,9.25z"/>
</g>
</symbol><symbol id="UserMultiple" viewBox="0 0 18 18">
<g id="user_x5F_multiple">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9.074,3.833C9.057,3.66,9.05,3.51,9.05,3.431c0-0.833,0.222-2.231,1.708-2.231c1.472,0,1.692,1.398,1.692,2.231
		c0,0.239-0.058,2.252-1.547,2.387c0.155,0.359,0.281,0.742,0.354,1.165c1.665-0.291,2.393-1.995,2.393-3.552
		C13.65,1.658,12.804,0,10.758,0S7.85,1.642,7.85,3.431c0,0.014,0.003,0.029,0.003,0.043C8.293,3.533,8.703,3.651,9.074,3.833z
		 M11.313,8.688c-0.043,0.448-0.13,0.854-0.252,1.225c0.92-0.046,1.799-0.29,2.582-0.737c0.513,0.257,0.968,0.589,1.358,0.991
		c0.177,0.182,0.321,0.41,0.43,0.679l0.79,1.955h-2.756c0.275,0.341,0.517,0.715,0.691,1.146L14.178,14H18l-1.457-3.605
		c-0.159-0.394-0.385-0.76-0.681-1.065c-0.638-0.657-1.421-1.17-2.335-1.512C12.892,8.295,12.14,8.592,11.313,8.688z M12.362,13.33
		c-0.705-0.726-1.587-1.275-2.627-1.613l-2.476,2.475l-2.48-2.48c-1.047,0.337-1.932,0.889-2.64,1.617
		c-0.296,0.305-0.522,0.671-0.681,1.065L0,18h14.5l-1.457-3.604C12.884,14.001,12.658,13.635,12.362,13.33z M1.779,16.8l0.79-1.956
		c0.108-0.268,0.253-0.497,0.429-0.678c0.423-0.435,0.92-0.787,1.485-1.052l1.926,1.926l0.849,0.848l0.848-0.848l1.921-1.92
		c0.56,0.264,1.054,0.614,1.473,1.046c0.176,0.181,0.321,0.41,0.429,0.679l0.79,1.955H1.779z M7.258,11.659
		c2.029,0,2.892-1.904,2.892-3.612c0-1.773-0.846-3.431-2.892-3.431S4.35,6.258,4.35,8.048C4.35,9.804,5.195,11.659,7.258,11.659z
		 M7.258,5.816c1.472,0,1.692,1.398,1.692,2.231c0,0.247-0.047,2.412-1.692,2.412c-1.626,0-1.708-2.009-1.708-2.412
		C5.55,7.214,5.772,5.816,7.258,5.816z"/>
</g>
</symbol><symbol id="UserMultipleActive" viewBox="0 0 18 18">
<g id="user_x5F_multiple_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M11.553,6.923c1.458-0.43,2.097-2.029,2.097-3.492C13.65,1.658,12.804,0,10.758,0C8.812,0,7.946,1.489,7.866,3.175
		C9.816,3.42,11.195,4.823,11.553,6.923z M16.543,10.396c-0.159-0.394-0.385-0.76-0.681-1.065c-0.638-0.657-1.421-1.169-2.334-1.513
		c-0.556,0.418-1.202,0.701-1.909,0.831c-0.066,0.694-0.243,1.374-0.532,1.988c0.891,0.406,1.68,0.957,2.351,1.648
		c0.421,0.433,0.756,0.954,0.996,1.548L14.501,14H18L16.543,10.396z M7.258,11.659c2.029,0,2.892-1.904,2.892-3.611
		c0-1.773-0.846-3.432-2.892-3.432c-2.046,0-2.908,1.642-2.908,3.432C4.35,9.804,5.195,11.659,7.258,11.659z M12.362,13.33
		c-0.705-0.726-1.587-1.275-2.627-1.613l-2.476,2.476l-2.48-2.48c-1.046,0.337-1.932,0.889-2.64,1.617
		c-0.296,0.305-0.522,0.671-0.681,1.065L0,18h14.5l-1.457-3.604C12.884,14.001,12.658,13.635,12.362,13.33z"/>
</g>
</symbol><symbol id="UserStaff" viewBox="0 0 18 18">
<g id="user_x5F_staff_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M16.191,12.775c-0.198-0.489-0.478-0.944-0.846-1.322c-0.875-0.901-1.97-1.583-3.262-2.002l-3.073,3.073L5.932,9.445
		c-1.299,0.419-2.399,1.103-3.278,2.008c-0.368,0.379-0.648,0.833-0.846,1.322L0,17.25h18L16.191,12.775z M1.779,16.05l1.142-2.825
		c0.149-0.368,0.348-0.683,0.593-0.935c0.231-0.238,0.493-0.439,0.758-0.638L6.05,16.05H1.779z M8.4,16.05H7.344L5.31,11.016
		c0.11-0.055,0.206-0.127,0.32-0.176l2.533,2.533L8.4,13.61V16.05z M9.6,16.05v-2.418l0.259-0.259l2.526-2.526
		c0.114,0.05,0.21,0.122,0.32,0.177l-2.031,5.027H9.6z M13.742,11.662c0.259,0.196,0.517,0.394,0.743,0.627
		c0.245,0.252,0.445,0.567,0.594,0.936l1.142,2.825h-4.252L13.742,11.662z M9.01,9.25c2.449,0,3.49-2.298,3.49-4.359
		c0-2.14-1.021-4.141-3.49-4.141c-2.469,0-3.51,1.982-3.51,4.141C5.5,7.011,6.52,9.25,9.01,9.25z M9.01,1.95
		c2.067,0,2.29,2.057,2.29,2.941c0,1.173-0.482,3.159-2.29,3.159c-2.199,0-2.31-2.631-2.31-3.159C6.7,4.007,6.925,1.95,9.01,1.95z"/>
</g>
</symbol><symbol id="UserStaffActive" viewBox="0 0 18 18">
<g id="user_x5F_staff_x5F_active_1_">
	<rect x="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M12.5,4.891c0-2.14-1.021-4.141-3.49-4.141c-2.469,0-3.51,1.981-3.51,4.141c0,2.12,1.02,4.359,3.51,4.359
		C11.459,9.25,12.5,6.952,12.5,4.891z M2.654,11.453c-0.368,0.378-0.648,0.833-0.845,1.322L0,17.25h6.373l-2.692-6.663
		C3.315,10.851,2.966,11.132,2.654,11.453z M4.986,9.813l3.005,7.437H8.25v-5.487L5.932,9.445C5.604,9.551,5.289,9.674,4.986,9.813z
		 M16.191,12.775c-0.198-0.489-0.478-0.944-0.846-1.322c-0.307-0.316-0.651-0.596-1.012-0.856l-2.458,6.083l-0.23,0.57H18
		L16.191,12.775z M12.084,9.451L9.75,11.785v5.465h0.278l0.458-1.133l2.544-6.296C12.727,9.682,12.412,9.557,12.084,9.451z"/>
</g>
</symbol><symbol id="Video" viewBox="0 0 18 18">
<g id="video">
	<path d="M0,0v18h18V0H0z M16.8,16.8H1.2V1.2h15.6V16.8z M6,5.5v7L12.14,9L6,5.5z"/>
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="VideoActive" viewBox="0 0 18 18">
<g id="video_x5F_active">
	<path d="M0,0v18h18V0H0z M6,12.5v-7L12.14,9L6,12.5z"/>
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
</g>
</symbol><symbol id="View" viewBox="0 0 18 18">
<g id="view">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9,3C4.973,3,1.516,5.469,0,9c1.516,3.53,4.973,6,9,6s7.484-2.47,9-6C16.484,5.469,13.027,3,9,3z M12.551,7.75
		c0,1.958-1.593,3.55-3.551,3.55S5.449,9.708,5.449,7.75S7.042,4.2,9,4.2S12.551,5.792,12.551,7.75z M9,13.8
		c-3.25,0-6.209-1.867-7.677-4.8c0.821-1.64,2.117-2.928,3.66-3.762C4.525,5.968,4.25,6.825,4.25,7.75c0,2.623,2.127,4.75,4.75,4.75
		s4.75-2.127,4.75-4.75c0-0.925-0.276-1.782-0.733-2.512c1.543,0.833,2.84,2.122,3.66,3.762C15.209,11.933,12.25,13.8,9,13.8z"/>
</g>
</symbol><symbol id="ViewActive" viewBox="0 0 18 18">
<g id="view_x5F_active">
	<rect style="opacity:0.4;fill:none;" width="18" height="18"/>
	<path d="M9.001,3C9.001,3,9,3,9.001,3C9,3,8.999,3,8.999,3C4.972,3,1.516,5.47,0,9c1.516,3.531,4.973,6,9,6
		c4.027,0,7.484-2.469,9-6C16.484,5.47,13.028,3,9.001,3z M9,13.8c-3.25,0-6.209-1.867-7.677-4.8
		c0.821-1.639,2.117-2.928,3.66-3.762C4.525,5.968,4.25,6.825,4.25,7.75c0,2.623,2.127,4.75,4.75,4.75s4.75-2.127,4.75-4.75
		c0-0.925-0.276-1.782-0.733-2.512c1.543,0.833,2.84,2.122,3.66,3.762C15.209,11.933,12.25,13.8,9,13.8z"/>
</g>
</symbol><symbol id="ViewAll" viewBox="0 0 18 18">
<g id="view_x5F_all">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M1,17h7V1H1V17z M2.2,2.2h4.6v13.6H2.2V2.2z M10,1v4h7V1H10z M15.8,3.8h-4.6V2.2h4.6V3.8z M10,17h7v-4h-7V17z M11.2,14.2
		h4.6v1.6h-4.6V14.2z M10,11h7V7h-7V11z M11.2,8.2h4.6v1.6h-4.6V8.2z"/>
</g>
</symbol><symbol id="ViewColumn" viewBox="0 0 18 18">
<g id="view_x5F_column">
	<g style="opacity:0.25;">
		<rect style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M1,17h7V1H1V17z M2.2,2.2h4.6v13.6H2.2V2.2z M10,1v16h7V1H10z M15.8,15.8h-4.6V2.2h4.6V15.8z"/>
</g>
</symbol><symbol id="ViewGrid" viewBox="0 0 18 18">
<g id="view_x5F_grid">
	<rect style="fill:none;" width="18" height="18"/>
	<path d="M1,8h7V1H1V8z M2.2,2.2h4.6v4.6H2.2V2.2z M1,17h7v-7H1V17z M2.2,11.2h4.6v4.6H2.2V11.2z M10,1v7h7V1H10z M15.8,6.8h-4.6
		V2.2h4.6V6.8z M10,17h7v-7h-7V17z M11.2,11.2h4.6v4.6h-4.6V11.2z"/>
</g>
</symbol><symbol id="Voice" viewBox="0 0 18 18">
<g id="voice">
	<rect y="0" style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,13c2.75,0,5-2.25,5-5V5c0-2.75-2.25-5-5-5S4,2.25,4,5v3C4,10.75,6.25,13,9,13z M5.2,5c0-2.095,1.705-3.8,3.8-3.8
		s3.8,1.705,3.8,3.8v3c0,2.095-1.705,3.8-3.8,3.8S5.2,10.095,5.2,8V5z M15.4,6v2c0,3.529-2.871,6.4-6.4,6.4S2.6,11.529,2.6,8V6H1.4
		v2c0,3.988,3.09,7.261,7,7.569V16.8H5V18h3.4h1.2H13v-1.2H9.6v-1.231c3.91-0.308,7-3.581,7-7.569V6H15.4z"/>
</g>
</symbol><symbol id="VoiceActive" viewBox="0 0 18 18">
<g id="voice_x5F_active">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<path d="M9,13c2.75,0,5-2.25,5-5V5c0-2.75-2.25-5-5-5S4,2.25,4,5v3C4,10.75,6.25,13,9,13z M15.4,6v2c0,3.529-2.871,6.4-6.4,6.4
		S2.6,11.529,2.6,8V6H1.4v2c0,3.988,3.09,7.261,7,7.569V16.8H5V18h8v-1.2H9.6v-1.231c3.91-0.308,7-3.581,7-7.569V6H15.4z"/>
</g>
</symbol><symbol id="VolumeHigh" viewBox="0 0 18 18">
<g id="volume_x5F_high">
	<g style="opacity:0.3;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M11.89,6.299C12.566,7,12.988,7.95,12.988,9c0,1.098-0.459,2.087-1.192,2.796l0.848,0.848
		c0.95-0.927,1.544-2.216,1.544-3.644c0-1.381-0.556-2.63-1.45-3.55L11.89,6.299z M15.214,2.974l-0.848,0.848
		c1.31,1.336,2.122,3.163,2.122,5.178c0,2.062-0.85,3.929-2.216,5.272l0.848,0.848c1.583-1.561,2.568-3.727,2.568-6.12
		C17.688,6.654,16.742,4.527,15.214,2.974z M0,5v8h5l5,5V0L5,5H0z M5.849,5.849L8.8,2.897v12.206l-2.951-2.952L5.497,11.8H1.2V6.2
		h4.297L5.849,5.849z"/>
</g>
</symbol><symbol id="VolumeLow" viewBox="0 0 18 18">
<g id="volume_x5F_low">
	<g style="opacity:0.3;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M11.89,6.299C12.566,7,12.988,7.95,12.988,9c0,1.098-0.459,2.087-1.192,2.796l0.848,0.848
		c0.95-0.927,1.544-2.216,1.544-3.644c0-1.381-0.556-2.63-1.45-3.55L11.89,6.299z M0,5v8h5l5,5V0L5,5H0z M5.849,5.849L8.8,2.897
		v12.206l-2.951-2.952L5.497,11.8H1.2V6.2h4.297L5.849,5.849z"/>
</g>
</symbol><symbol id="VolumeOff" viewBox="0 0 18 18">
<g id="volume_x5F_off">
	<g style="opacity:0.25;">
		<rect y="0" style="fill:none;" width="18" height="18"/>
	</g>
	<path d="M0,5v8h5l5,5V0L5,5H0z M5.849,5.849L8.8,2.897v12.206l-2.952-2.952L5.497,11.8H1.2V6.2h4.297L5.849,5.849z M17.746,6.924
		l-0.849-0.848l-2.076,2.076l-2.076-2.076l-0.849,0.848L13.974,9l-2.076,2.076l0.849,0.848l2.076-2.076l2.076,2.076l0.849-0.848
		L15.67,9L17.746,6.924z"/>
</g>
</symbol><symbol id="Wifi" viewBox="0 0 18 18">
<g id="wifi">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path d="M9,11.821c-0.981,0-1.866,0.406-2.501,1.057L9,15.379l2.501-2.501C10.866,12.227,9.981,11.821,9,11.821z"/>
		<path d="M9,8.746c-1.831,0-3.485,0.749-4.677,1.956l0.852,0.852C6.15,10.563,7.503,9.946,9,9.946s2.85,0.617,3.825,1.608
			l0.852-0.852C12.485,9.495,10.831,8.746,9,8.746z"/>
		<path d="M9,5.721c-2.666,0-5.076,1.088-6.816,2.842l0.851,0.851C4.559,7.876,6.669,6.921,9,6.921s4.441,0.955,5.965,2.493
			l0.851-0.851C14.076,6.809,11.666,5.721,9,5.721z"/>
		<path d="M9,2.621c-3.518,0-6.7,1.431-9,3.742v0.017l0.844,0.844C2.929,5.124,5.815,3.821,9,3.821s6.071,1.303,8.156,3.403
			L18,6.379V6.362C15.7,4.052,12.518,2.621,9,2.621z"/>
	</g>
</g>
</symbol><symbol id="WifiActive" viewBox="0 0 18 18">
<g id="wifi_x5F_active_1_">
	<rect style="opacity:0.25;fill:none;" width="18" height="18"/>
	<g>
		<path style="fill:#231F20;" d="M9,8.746c-1.831,0-3.485,0.75-4.677,1.956l1.417,1.417c0.831-0.845,1.984-1.373,3.26-1.373
			s2.429,0.528,3.26,1.373l1.417-1.417C12.485,9.495,10.831,8.746,9,8.746z"/>
		<path style="fill:#231F20;" d="M9,11.821c-0.981,0-1.866,0.406-2.501,1.057L9,15.379l2.501-2.501
			C10.866,12.227,9.981,11.821,9,11.821z"/>
		<path style="fill:#231F20;" d="M9,2.621c-3.518,0-6.7,1.431-9,3.742v0.017l1.41,1.41C3.35,5.834,6.035,4.621,9,4.621
			s5.65,1.213,7.59,3.168L18,6.379V6.363C15.7,4.052,12.518,2.621,9,2.621z"/>
		<path style="fill:#231F20;" d="M9,5.721c-2.666,0-5.076,1.088-6.816,2.842L3.601,9.98C4.979,8.587,6.89,7.721,9,7.721
			s4.021,0.866,5.399,2.259l1.417-1.417C14.076,6.809,11.666,5.721,9,5.721z"/>
	</g>
</g>
</symbol></svg>`; export default svgContent;